export const DataARB = [
  {
    ID: 0,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالأطفال والنزاع المسلح",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالأطفال والنزاع المسلح",
    Title: "انخفاض عدد الأطفال المحتجزين المتحقَّق منه",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,HT,NG,SO,YE",
    Image: "1POLICY1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=62"
  },
  {
    ID: 1,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالأطفال والنزاع المسلح",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالأطفال والنزاع المسلح",
    Title: "مقياس األداء: عدد خط العمل المشااترالة وبروتوالولت التسااليم واللتزامات األخرى بين األمم المتحدة وأطراف النزاع إلنهاء النتهاكات الجسيمة ضد الأطفال ومنعها )العدد التراكمي(",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=63"
  },
  {
    ID: 2,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالأطفال والنزاع المسلح",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالأطفال والنزاع المسلح",
    Title: "انخفاض عدد الأطفال الذين تجندهم وتستخدمهم أطراف النزاع في حالت النزاع المسلح",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=63"
  },
  {
    ID: 3,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالأطفال والنزاع المسلح",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالأطفال والنزاع المسلح",
    Title: "تسريح المزيد من الأطفال من القوات المسلحة والجماعات المسلحة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=64"
  },
  {
    ID: 4,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف الجنسي في حالات النزاع",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف الجنسي في حالات النزاع",
    Title: "تعزيز المل ية الوطنية لمنع العنف الجنسي المتصل بالنزاع وتحقيق العدالة للناجيات والناجين: حالة أوالرانيا",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UA",
    Image: "1POLICY5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=75"
  },
  {
    ID: 5,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف الجنسي في حالات النزاع",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف الجنسي في حالات النزاع",
    Title: "نهوض السلطات الوطنية بتوفير الخدمات وقيامها بتعزيز استجابة قطاع العدالة للعنف الجنسي المتصل بالنزاع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DJ,ER,ET,SO,SD,QQ",
    Image: "1POLICY6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=76"
  },
  {
    ID: 6,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف الجنسي في حالات النزاع",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف الجنسي في حالات النزاع",
    Title: "استجابة قضائية معززة من السلطات الوطنية لتعزيز العدالة التي تركز على الناجيات والناجين والمساءلة عن العنف الجنسي المتصل بالنزاع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CO,CF,CD,UA",
    Image: "1POLICY7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=77"
  },
  {
    ID: 7,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف الجنسي في حالات النزاع",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف الجنسي في حالات النزاع",
    Title: "تعزيز الامتثال للمعايير الدولية المتعلقة بمنع العنف الجنسي المتصل بالنزاع والتصدي له",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=77"
  },
  {
    ID: 8,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف ضد الأطفال",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف ضد الأطفال",
    Title: "تعزيز التزام القطاع الخاص بحماية الأطفال من العنف في سياق السفر والسياحة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=87"
  },
  {
    ID: 9,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف ضد الأطفال",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف ضد الأطفال",
    Title: "تنشيط مبادرة البلدان الرائدة (التحالف العالمي الرائد المعني بالقضاء على العنف ضد الأطفال) للقضاء على العنف ضد الأطفال بحلول عام 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=88"
  },
  {
    ID: 10,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف ضد الأطفال",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف ضد الأطفال",
    Title: "اعتماد الدول الأعضاء خرائط طريق استراتيجية لتسريع وتيرة الإجراءات الرامية إلى القضاء على العنف ضد الأطفال بحلول عام 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=89"
  },
  {
    ID: 11,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف ضد الأطفال",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الممثلة الخاصة للأمين العام المعنية بالعنف ضد الأطفال",
    Title: "التعلم من الأقران بين الدول الأعضاء يُسرّع وتيرة الإجراءات الرامية إلى القضاء على العنف ضد الأطفال",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=89"
  },
  {
    ID: 12,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "مكتب المنسق الخاص المعني بتحسين جهود الأمم المتحدة في مجال التصدي للاستغلال والانتهاك الجنسيين",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب المنسق الخاص المعني بتحسين جهود الأمم المتحدة في مجال التصدي للاستغلال والانتهاك الجنسيين",
    Title: "توسيع نطاق دمج تدابير الحماية في أطر التعاون القطري",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=103"
  },
  {
    ID: 13,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "مكتب المنسق الخاص المعني بتحسين جهود الأمم المتحدة في مجال التصدي للاستغلال والانتهاك الجنسيين",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب المنسق الخاص المعني بتحسين جهود الأمم المتحدة في مجال التصدي للاستغلال والانتهاك الجنسيين",
    Title: "نهج منسق للأمم المتحدة للتصدي بفعالية أكبر للاستغلال والانتهاك الجنسيين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=103"
  },
  {
    ID: 14,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "مكتب المنسق الخاص المعني بتحسين جهود الأمم المتحدة في مجال التصدي للاستغلال والانتهاك الجنسيين",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب المنسق الخاص المعني بتحسين جهود الأمم المتحدة في مجال التصدي للاستغلال والانتهاك الجنسيين",
    Title: "تحقيق الفعالية في جهود الوقاية والاستجابة من خلال إضفاء الطابع المؤسسي على الحماية من الاستغلال والانتهاك الجنسيين على نطاق منظومة الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=104"
  },
  {
    ID: 15,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "مكتب المنسق الخاص المعني بتحسين جهود الأمم المتحدة في مجال التصدي للاستغلال والانتهاك الجنسيين",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب المنسق الخاص المعني بتحسين جهود الأمم المتحدة في مجال التصدي للاستغلال والانتهاك الجنسيين",
    Title: "تعزيز النهج الاستراتيجي على نطاق المنظومة للتصدي للاستغلال والانتهاك الجنسيين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=105"
  },
  {
    ID: 16,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "مكتب أمين المظالم وخدمات الوساطة في الأمم المتحدة",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب أمين المظالم وخدمات الوساطة في الأمم المتحدة",
    Title: "إدارة النزاعات التي تنشأ في أماكن العمل بشكل أفضل من خالل أنشطة بناء القدرات والمهارات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=114"
  },
  {
    ID: 17,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "مكتب أمين المظالم وخدمات الوساطة في الأمم المتحدة",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب أمين المظالم وخدمات الوساطة في الأمم المتحدة",
    Title: "إتاحة حصول أفراد الأمم المتحدة من غير الموظفين على خدمات تسوية النزاعات بالوسائل غير الرسمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=115"
  },
  {
    ID: 18,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "مكتب أمين المظالم وخدمات الوساطة في الأمم المتحدة",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب أمين المظالم وخدمات الوساطة في الأمم المتحدة",
    Title: "زيادة فرص حصول الموظفين الميدانيين على الخدمات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=116"
  },
  {
    ID: 19,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "مكتب أمين المظالم وخدمات الوساطة في الأمم المتحدة",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب أمين المظالم وخدمات الوساطة في الأمم المتحدة",
    Title: "زيادة الوعي بخدمات الوساطة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=116"
  },
  {
    ID: 20,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "مكتب إقامة العدل",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب إقامة العدل",
    Title: "تحسين القدرات في تتبع القضايا المرفوعة أمام محكمة األمم المتحدة للمنازعات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=125"
  },
  {
    ID: 21,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "مكتب إقامة العدل",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب إقامة العدل",
    Title: "تحسين شفافية نظام إقامة العدل من خلال استخدام تحليل المعلومات المتعلقة بالأعمال والإبلاغ بشأن تحليل الاتجاهات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=125"
  },
  {
    ID: 22,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "مكتب إقامة العدل",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب إقامة العدل",
    Title: "زيادة الاستفادة من المشورة القانونية المقدمة من مكتب تقديم المساعدة القانونية للموظفين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=126"
  },
  {
    ID: 23,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "مكتب إقامة العدل",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب إقامة العدل",
    Title: "تسوية القضايا المعروضة على محكمة الأمم المتحدة للمنازعات على نحو أفضل من حيث توقيتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=127"
  },
  {
    ID: 24,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "مكتب الأخلاقيات",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الأخلاقيات",
    Title: "زيادة ثقة الموظفين في طلب المشورة بشأن الحماية من النتقام",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=136"
  },
  {
    ID: 25,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "مكتب الأخلاقيات",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الأخلاقيات",
    Title: "تعزيز الوعي الأخلاقي وإمكانية حصول الموظفين الميدانيين على الخدمات المتعلقة بالأخلاقيات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=137"
  },
  {
    ID: 26,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "مكتب الأخلاقيات",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الأخلاقيات",
    Title: "زيادة الشفافية والمساءلة من خلال تعزيز المشورة والتوجيهات المقدمة من خلال برنامج إقرارات الذمة المالية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=138"
  },
  {
    ID: 27,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "مكتب الأخلاقيات",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الأخلاقيات",
    Title: "تعزيز فهم الموظفين إلجراءات الحماية من النتقام وتحسين توقيتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=139"
  },
  {
    ID: 28,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "نظام المنسقين المقيمين",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "نظام المنسقين المقيمين",
    Title: "اعتمدت الحكومات الوطنية نُهجا سياساتية متكاملة لتسريع تحقيق أهداف التنمية المستدامة ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=149"
  },
  {
    ID: 29,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "نظام المنسقين المقيمين",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "نظام المنسقين المقيمين",
    Title: "زيادة الشفافية والمساءلة عن النتائج التي تحققها الأمم المتحدة والمساهمة في أهداف التنمية المستدامة من خلال المؤشرات الموحدة لأطر الأمم المتحدة للتعاون من أجل التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=150"
  },
  {
    ID: 30,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "نظام المنسقين المقيمين",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "نظام المنسقين المقيمين",
    Title: "تعزيز فعالية دعم الأمم المتحدة في تحقيق أهداف التنمية المستدامة من خلال الحلول القائمة على البيانات والابتكار الرقمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=151"
  },
  {
    ID: 31,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "نظام المنسقين المقيمين",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "نظام المنسقين المقيمين",
    Title: "حماية الأرواح وسبل العيش في ظل الآثار الاجتماعية الاقتصادية الطويلة الأجل للأزمات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الإدارة العامة",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=152"
  },
  {
    ID: 32,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "مكتب الأمم المتحدة للشباب",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الأمم المتحدة للشباب",
    Title: "التقدم المحرز في تعزيز أولويات الشباب ومشارالتهم المجدية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=169"
  },
  {
    ID: 33,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "مكتب الأمم المتحدة للشباب",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الأمم المتحدة للشباب",
    Title: "إشراك الشباب على المستويات كافة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=170"
  },
  {
    ID: 34,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "مكتب الأمم المتحدة للشباب",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الأمم المتحدة للشباب",
    Title: "نحو إنشاء منصة عالمية للاستثمار في الشباب من أجل توسيع نطاق البرامج المتعلقة بالشباب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=170"
  },
  {
    ID: 35,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "مكتب الأمم المتحدة للشباب",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب الأمم المتحدة للشباب",
    Title: "تعزيز مشاركة الشباب في عمليات السلام والأمن",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=171"
  },
  {
    ID: 36,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "مكتب حماية البيانات والخصوصية",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب حماية البيانات والخصوصية",
    Title: "تعزيز الجاهزية العملياتية في مجال إدارة حماية البيانات والخصوصية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=181"
  },
  {
    ID: 37,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "مكتب حماية البيانات والخصوصية",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب حماية البيانات والخصوصية",
    Title: "زيادة حماية البيانات والخصوصية على نطاق الأمانة العامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=181"
  },
  {
    ID: 38,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "مكتب حماية البيانات والخصوصية",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب حماية البيانات والخصوصية",
    Title: "تحسين طرائق أداء العمل لإدماج سياسة حماية البيانات والخصوصية وضمان الامتثال لها على نطاق المنظمة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=182"
  },
  {
    ID: 39,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "مكتب حماية البيانات والخصوصية",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب حماية البيانات والخصوصية",
    Title: "تعزيز قدرة المنظمة على الصمود وبلوغ مرحلة النضج في مجال حماية البيانات والخصوصية منذ مرحلة التصميم في عصر الذكاء الاصطناعي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=183"
  },
  {
    ID: 40,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "مكتب التكنولوجيات الرقمية والناشئة",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب التكنولوجيات الرقمية والناشئة",
    Title: "يصبح التقدم المحرز في التعاهد الرقمي العالمي جليا لجميع الأطراف المعنية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=190"
  },
  {
    ID: 41,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "مكتب التكنولوجيات الرقمية والناشئة",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب التكنولوجيات الرقمية والناشئة",
    Title: "تعزيز التزام أصحاب المصلحة المتعددين بالتعاهد الرقمي العالمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=191"
  },
  {
    ID: 42,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "مكتب التكنولوجيات الرقمية والناشئة",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب التكنولوجيات الرقمية والناشئة",
    Title: "تعزيز التعاون في مجال الحوكمة الدولية للذكاء الاصطناعي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=192"
  },
  {
    ID: 43,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "تحالف الأمم المتحدة للحضارات",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "تحالف الأمم المتحدة للحضارات",
    Title: "تعزيز مسؤولية الدول الأعضاء في النهوض بثقافة السلام، والحوار بين الأديان والثقافات من أجل التوصل إلى تفاهم متبادل، والتصدي لجميع أشكال التعصب الديني",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=204"
  },
  {
    ID: 44,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "تحالف الأمم المتحدة للحضارات",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "تحالف الأمم المتحدة للحضارات",
    Title: "إذكاء وعي الجهات الفاعلة الحكومية وغير الحكومية بالاتجاهات المعاصرة لكراهية الإسلام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=204"
  },
  {
    ID: 45,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "تحالف الأمم المتحدة للحضارات",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "تحالف الأمم المتحدة للحضارات",
    Title: "تعزيز التنسيق على نطاق منظومة الأمم المتحدة ومشاركة الجهات المعنية لمكافحة معاداة السامية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=205"
  },
  {
    ID: 46,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "مكتب التقييم على نطاق المنظومة التابع لمجموعة الأمم المتحدة للتنمية المستدامة",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب التقييم على نطاق المنظومة التابع لمجموعة الأمم المتحدة للتنمية المستدامة",
    Title: "استرشاد عملية اتخاذ القرار في مبادرة الأمم المتحدة 80 بأدلة التقييم على نطاق المنظومة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=214"
  },
  {
    ID: 47,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "مكتب التقييم على نطاق المنظومة التابع لمجموعة الأمم المتحدة للتنمية المستدامة",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب التقييم على نطاق المنظومة التابع لمجموعة الأمم المتحدة للتنمية المستدامة",
    Title: "زيادة توافر واستخدام نتائج التقييم على نطاق المنظومة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=215"
  },
  {
    ID: 48,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "مكتب التقييم على نطاق المنظومة التابع لمجموعة الأمم المتحدة للتنمية المستدامة",
    Programme: "تقرير السياسات والتوجيه والتنسيق عموما",
    Subprogramme: "مكتب التقييم على نطاق المنظومة التابع لمجموعة الأمم المتحدة للتنمية المستدامة",
    Title: "تحسين استخدام الدول الأعضاء والهيئات الحكومية الدولية لأدلة التقييم الصادرة عن منظومة الأمم المتحدة في عملية اتخاذ القرارات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=ar#page=216"
  },
  {
    ID: 49,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي",
    Title: "تزايد عدد العمليات غير الرسمية التي يقوم بها الميسرون المشاركون الذين يعينهم رئيس الجمعية العامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=10"
  },
  {
    ID: 50,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي",
    Title: "إتاحة معلومات موحدة عن وقائع اجتماعات مختلف الهيئات الحكومية الدولية للمندوبين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=10"
  },
  {
    ID: 51,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي",
    Title: "تحقيق تفاعل أبسط وأكثر سهولة بين الوفود والأمانة العامة باستخدام منصة e-delegate",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=11"
  },
  {
    ID: 52,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي",
    Title: "تحسُّن إتاحة وحدات بوابة e-delegate للأجهزة الفرعية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=12"
  },
  {
    ID: 53,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "تخطيط خدمات المؤتمرات وتنسيقها",
    Title: "زيادة عدد الاجتماعات المعقودة خارج المقر التي قدمت الخدمات إليها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CA,CR,ET,FR,DE,MA,PA,QA,SA,ES,EI,TH,TM,UY",
    Image: "2DGACM5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=14"
  },
  {
    ID: 54,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "تخطيط خدمات المؤتمرات وتنسيقها",
    Title: "البوابة العالمية لخدمة المؤتمرات والاجتماعات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=15"
  },
  {
    ID: 55,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "تخطيط خدمات المؤتمرات وتنسيقها",
    Title: "زيادة التعليقات الواردة من الدول الأعضاء من خلال الاستقصاء العالمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=16"
  },
  {
    ID: 56,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "تخطيط خدمات المؤتمرات وتنسيقها",
    Title: "ضمان مرونة العمليات من خلال التدريب على أداء مهام متعددة في سياق خدمات المؤتمرات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=17"
  },
  {
    ID: 57,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "خدمات الوثائق",
    Title: "استمرار إصدار الوثائق في المواعيد المقررة على الرغم من المعوقات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=21"
  },
  {
    ID: 58,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "خدمات الوثائق",
    Title: "إعداد وثائق عالية الجودة بلغات متعددة من خلال إطار إدارة جودة الترجمة التحريرية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=22"
  },
  {
    ID: 59,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "خدمات الوثائق",
    Title: "توافر الوثائق للاجتماعات في المواعيد المقررة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=22"
  },
  {
    ID: 60,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "خدمات الوثائق",
    Title: "إعمال مبدأ المساواة في المعاملة بين اللغات الرسمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=23"
  },
  {
    ID: 61,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "خدمات الاجتماعات والنشر",
    Title: "الحفاظ على الجودة وتحقيق الكفاءة لصالح منظمي الاجتماعات من خلال الإدارة المتكاملة لموارد الترجمة الشفوية على النطاق العالمي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=27"
  },
  {
    ID: 62,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "خدمات الاجتماعات والنشر",
    Title: "زيادة خدمات الترجمة الشفوية المتاحة لتلبية الطلب المتزايد من الدول الأعضاء على الاجتماعات المزودة بخدمة الترجمة الشفوية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=28"
  },
  {
    ID: 63,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "خدمات الاجتماعات والنشر",
    Title: "تعزُّز منتجات النشر لفائدة الدول الأعضاء والجمهور",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=29"
  },
  {
    ID: 64,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "إدارة شؤون الجمعية العامة والمؤتمرات",
    Programme: "شؤون الجمعية العامة والمجلس الاقتصادي والاجتماعي وإدارة المؤتمرات",
    Subprogramme: "خدمات الاجتماعات والنشر",
    Title: "استمرار تغطية الاجتماعات من خلال تسخير تكنولوجيا التخطيط لخدمات الترجمة الشفوية الداخلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=ar#page=30"
  },
  {
    ID: 65,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "منع نشوب النزاعات وإدارتها وتسويتها",
    Title: "مساهمة الدول األعضاء والجهات المعنية األخرى في الستع ارض بشأن مستقبل جميع أشكال عمليات األمم المتحدة للسالم",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=14"
  },
  {
    ID: 66,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "منع نشوب النزاعات وإدارتها وتسويتها",
    Title: "الحد من الأخطار التي تهدد السلام والأمن الدوليين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,LY,MZ,SD,QQ",
    Image: "3DPPA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=15"
  },
  {
    ID: 67,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "منع نشوب النزاعات وإدارتها وتسويتها",
    Title: "حصول المنظمات الإقليمية ودون الإقليمية على الدعم في مجال الوساطة والدبلوماسية الوقائية والمساعي الحميدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=15"
  },
  {
    ID: 68,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "منع نشوب النزاعات وإدارتها وتسويتها",
    Title: "تحسين إمكانية حصول الدول الأعضاء على الدعم السريع في مجال الوساطة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=16"
  },
  {
    ID: 69,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "المساعدة الانتخابية",
    Title: "تحسين القيادة والمشاركة النساإلية في العمليات النتخابية والسياسية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=19"
  },
  {
    ID: 70,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "المساعدة الانتخابية",
    Title: "زيادة تمثيل المرأة في العمليات الانتخابية والسياسية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=20"
  },
  {
    ID: 71,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "المساعدة الانتخابية",
    Title: "تعزيز قدرة الدول الأعضاء التي تتلقى المساعدة الانتخابية من الأمم المتحدة من خلال مبادرات مشتركة مع المنظمات الإقليمية ودون الإقليمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=21"
  },
  {
    ID: 72,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "المساعدة الانتخابية",
    Title: "تلقي الدول الأعضاء ردودا فعالة وفي الوقت المناسب على طلبات المساعدة الانتخابية من الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=21"
  },
  {
    ID: 73,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "شؤون مجلس الأمن",
    Title: "تحسين أساليب عمل مجلس األمن من خالل النظر بسرعة أكبر في تعليقات األعضاء",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=24"
  },
  {
    ID: 74,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "شؤون مجلس الأمن",
    Title: "تحسين التفاعل مع الدول الأعضاء بشأن أعمال مجلس الأمن",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=25"
  },
  {
    ID: 75,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "شؤون مجلس الأمن",
    Title: "تحسن إمكانية حصول الدول الأعضاء والجمهور على معلومات تحليلية محدّثة ومتزامنة عن ممارسات مجلس الأمن وعمله",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=26"
  },
  {
    ID: 76,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "شؤون مجلس الأمن",
    Title: "تلقّي أعضاء مجلس الأمن معلومات في أوانها عن تنفيذ تدابير الجزاءات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=26"
  },
  {
    ID: 77,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "إنهاء الاستعمار",
    Title: "تعزيز الوعي العام بإنهاء الستعمار",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=29"
  },
  {
    ID: 78,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "إنهاء الاستعمار",
    Title: "حصول اللجنة الخاصة على قائمة مستكملة بأسماء الخبراء المؤهلين في مجال إنهاء الاستعمار",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=30"
  },
  {
    ID: 79,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "إنهاء الاستعمار",
    Title: "زيادة نشر المعلومات عن إنهاء الاستعمار",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=30"
  },
  {
    ID: 80,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "إنهاء الاستعمار",
    Title: "إتاحة إمكانية اطلاع اللجنة الخاصة على تقارير محسّنة بشأن المساعدة المقدّمة إلى الأقاليم غير المتمتعة بالحكم الذاتي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=31"
  },
  {
    ID: 81,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "قضية فلسطين",
    Title: "زيادة تفاعل الدول األعضاء مع اللجنة ودعمها لها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=34"
  },
  {
    ID: 82,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "قضية فلسطين",
    Title: "تعزيز أنشطة التوعية التي تقوم بها اللجنة المعنية بقضية فلسطين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=34"
  },
  {
    ID: 83,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "قضية فلسطين",
    Title: "تحسين إحاطات اللجنة وتفاعلها مع مجلس الأمن",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=35"
  },
  {
    ID: 84,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "قضية فلسطين",
    Title: "الزيادة في أنشطة الدعوة والتفاعل العام من جانب اللجنة المعنية بقضية فلسطين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=36"
  },
  {
    ID: 85,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب دعم بناء السلام",
    Title: "عززت الدول الأعضاء الاستراتيجيات والنُهج الوطنية القائمة للوقاية وبناء السلام",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "TD,MR,PG",
    Image: "3DPPA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=39"
  },
  {
    ID: 86,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب دعم بناء السلام",
    Title: "زيادة التركيز على المراحل الانتقالية التي تمر بها البعثات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=39"
  },
  {
    ID: 87,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب دعم بناء السلام",
    Title: "تعزيز الشراكة مع المؤسسات المالية الدولية من أجل تنفيذ استراتيجيات لبناء السلام والوقاية تكون الجهات الوطنية مسؤولة عنها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=40"
  },
  {
    ID: 88,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب دعم بناء السلام",
    Title: "زيادة الاستثمارات في مبادرات صندوق بناء السلام التي أبلغت عن تحقيق آثار محفّزة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=41"
  },
  {
    ID: 89,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "التعاون بين الأمم المتحدة وجامعة الدول العربية",
    Title: "تعزيز التعاون بين جامعة الدول العربية والأمم المتحدة في مجال حقوق المرأة وحماية الطفل في النزاع المسلح",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=44"
  },
  {
    ID: 90,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "التعاون بين الأمم المتحدة وجامعة الدول العربية",
    Title: "التقدم الذي أحرزته جامعة الدول العربية في مجال الدبلوماسية الوقائية والوساطة والتحليل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=44"
  },
  {
    ID: 91,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "التعاون بين الأمم المتحدة وجامعة الدول العربية",
    Title: "تعزيز التفاعل مع الأمانة العامة لجامعة الدول العربية والدول الأعضاء في الجامعة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=45"
  },
  {
    ID: 92,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "إدارة الشؤون السياسية وبناء السلام",
    Programme: "الشؤون السياسية",
    Subprogramme: "التعاون بين الأمم المتحدة وجامعة الدول العربية",
    Title: "تعزيز الشراكة بين الأمم المتحدة وجامعة الدول العربية في السير قدما بمنع نشوب النزاعات والحفاظ على السلام في المنطقة العربية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=46"
  },
  {
    ID: 93,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "مكتب منسق الأمم المتحدة الخاص لعملية السلام في الشرق الأوسط ",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب منسق الأمم المتحدة الخاص لعملية السلام في الشرق الأوسط ",
    Title: "تخطيط اإلنعاش القاإلم على األدلة من أجل غزة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=72"
  },
  {
    ID: 94,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "مكتب منسق الأمم المتحدة الخاص لعملية السلام في الشرق الأوسط ",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب منسق الأمم المتحدة الخاص لعملية السلام في الشرق الأوسط ",
    Title: "إحراز تقدم نحو تشااكيل حكومة فلسااطينية واحدة تدير األرض الفلسااطينية المحتلة بأكملها، في إطار التوصاال عن طريا التفاوض إلى حل الدولتين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=73"
  },
  {
    ID: 95,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "مكتب منسق الأمم المتحدة الخاص لعملية السلام في الشرق الأوسط ",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب منسق الأمم المتحدة الخاص لعملية السلام في الشرق الأوسط ",
    Title: "السعي إلى وضع إطار سياسي لتسوية النزاع اإلسراإليلي - الفلسطيني",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "PS",
    Image: "3DPPA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=74"
  },
  {
    ID: 96,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "مكتب منسق الأمم المتحدة الخاص لعملية السلام في الشرق الأوسط ",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب منسق الأمم المتحدة الخاص لعملية السلام في الشرق الأوسط ",
    Title: "إحراز تقادم نحو تنفياذ الخطاة الشاااااااااااملاة إلنهااء النزاع في غزة على النحو الاذي أياد قرار مجلس األمن",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=74"
  },
  {
    ID: 97,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "سجل الأمم المتحدة للأضرار الناشئة عن تشييد الجدار في الأرض الفلسطينية المحتلة",
    Programme: "الشؤون السياسية",
    Subprogramme: "سجل الأمم المتحدة للأضرار الناشئة عن تشييد الجدار في الأرض الفلسطينية المحتلة",
    Title: "تحسين عملية استعراض مطالبات إدراج األضرار من أجل تقديم خدمة أسرع ألصحاب المطالبات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=83"
  },
  {
    ID: 98,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "سجل الأمم المتحدة للأضرار الناشئة عن تشييد الجدار في الأرض الفلسطينية المحتلة",
    Programme: "الشؤون السياسية",
    Subprogramme: "سجل الأمم المتحدة للأضرار الناشئة عن تشييد الجدار في الأرض الفلسطينية المحتلة",
    Title: "انخفاض عدد المطالبات غير المجهزة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=84"
  },
  {
    ID: 99,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "سجل الأمم المتحدة للأضرار الناشئة عن تشييد الجدار في الأرض الفلسطينية المحتلة",
    Programme: "الشؤون السياسية",
    Subprogramme: "سجل الأمم المتحدة للأضرار الناشئة عن تشييد الجدار في الأرض الفلسطينية المحتلة",
    Title: "تعزيز عملية التصحيح لستكمال المطالبات المجمعة التي فيها نواقص",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "PS",
    Image: "3DPPA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=85"
  },
  {
    ID: 100,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "سجل الأمم المتحدة للأضرار الناشئة عن تشييد الجدار في الأرض الفلسطينية المحتلة",
    Programme: "الشؤون السياسية",
    Subprogramme: "سجل الأمم المتحدة للأضرار الناشئة عن تشييد الجدار في الأرض الفلسطينية المحتلة",
    Title: "تعزيز عملية اتخاذ المجلس للقرارات من خالل األخذ بعملية منسقة في تقديم المطالبات إليه",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=85"
  },
  {
    ID: 101,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "مكتب الأمم المتحدة لدى الاتحاد الأفريقي",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب الأمم المتحدة لدى الاتحاد الأفريقي",
    Title: "تمت عملية النتقال األمني في الصومال وعززت قدرات التحاد األفريقي لدعم السالم",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "3DPPA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=95"
  },
  {
    ID: 102,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "مكتب الأمم المتحدة لدى الاتحاد الأفريقي",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب الأمم المتحدة لدى الاتحاد الأفريقي",
    Title: "تعزيز مشاركة الشباب في مبادرات السالم واألمن في أفريقيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=96"
  },
  {
    ID: 103,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "مكتب الأمم المتحدة لدى الاتحاد الأفريقي",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب الأمم المتحدة لدى الاتحاد الأفريقي",
    Title: "تعزيز الجهود المشاتركة بين األمم المتحدة والتحاد األفريقي في منع نشاوب النزاعات والوسااطة فيها والحفا على السالم ومعالجة األسباب الجذرية للنزاع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=97"
  },
  {
    ID: 104,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "مكتب الأمم المتحدة لدى الاتحاد الأفريقي",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب الأمم المتحدة لدى الاتحاد الأفريقي",
    Title: "تعزيز المشاركة الفعالة للمرأة ودورها القيادي وتأثيرها في عمليات السالم واألمن في أفريقيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=97"
  },
  {
    ID: 105,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "مكتب مكافحة الإرهاب",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب مكافحة الإرهاب",
    Title: "إنشاء شبكة عالمية لضحايا اإلرهاب من أجل الدفاع عن حقوقهم وتشكيل السياسات وإتاحة إمكانية الحصول على الدعم",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=112"
  },
  {
    ID: 106,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "مكتب مكافحة الإرهاب",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب مكافحة الإرهاب",
    Title: "تكثيف الدول األعضاء لجهودها في مكافحة استعمال األسلحة لألغراض اإلرهابية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=113"
  },
  {
    ID: 107,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "مكتب مكافحة الإرهاب",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب مكافحة الإرهاب",
    Title: "تعزيز القدرات الوطنية لمكافحة اإلرهاب من خالل تعزيز التنسايا بين الوكالت ومهارات التحليل الساتخباراتي من أجل منع اإلرهاب ومكافحته",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=114"
  },
  {
    ID: 108,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "مكتب مكافحة الإرهاب",
    Programme: "الشؤون السياسية",
    Subprogramme: "مكتب مكافحة الإرهاب",
    Title: "تعزيز القدرات الوطنية لمكافحة استخدام المنظومات الجوية غير المأهولة ألغراض إرهابية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=ar#page=114"
  },
  {
    ID: 109,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "المفاوضات والمداولات المتعددة الأطراف بشأن نزع السلاح والحد من الأسلحة",
    Title: "زيادة التقارير السنوية المقدمة من الأطراف المتعاقدة السامية في اتفاقية حظر أو تقييد استعمال أسلحة تقليدية معينة يمكن اعتبارها مفرطة الضرر أو عشوائية الأثر",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=9"
  },
  {
    ID: 110,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "المفاوضات والمداولات المتعددة الأطراف بشأن نزع السلاح والحد من الأسلحة",
    Title: "زيادة المداولات واحتمالات المفاوضات خلال مؤتمر نزع السلاح",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=10"
  },
  {
    ID: 111,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "المفاوضات والمداولات المتعددة الأطراف بشأن نزع السلاح والحد من الأسلحة",
    Title: "منع حدوث سباق تسلح في الفضاء الخارجي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=10"
  },
  {
    ID: 112,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "المفاوضات والمداولات المتعددة الأطراف بشأن نزع السلاح والحد من الأسلحة",
    Title: "التعامل مع التكنولوجيات الناشئة في مجال منظومات الأسلحة الفتاكة الذاتية التشغيل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=11"
  },
  {
    ID: 113,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "أسلحة الدمار الشامل",
    Title: "تحدد الدول الأعضاء من منطقة آسيا والمحيط الهادئ أوجه التآزر المحتملة لمشاركتها في الصكوك الرامية إلى التصدي للتهديد الناجم عن انتشار الأسلحة البيولوجية أو استخدامها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "نزع السلاح",
    Beneficiary: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "4ODA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=15"
  },
  {
    ID: 114,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "أسلحة الدمار الشامل",
    Title: "عملية التوصل إلى إنشاء منطقة خالية من الأسلحة النووية وغيرها من أسلحة الدمار الشامل في الشرق الأوسط",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,DJ,EG,QG,IR,IQ,JO,KW,LB,LY,MA,OM,QA,SA,SY,TN,AE,PS,YE",
    Image: "4ODA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=16"
  },
  {
    ID: 115,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "أسلحة الدمار الشامل",
    Title: "تحسين حالة الجاهزية لآلية الأمين العام للتحقق من الاستخدام المزعوم للأسلحة الكيميائية والبيولوجية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=17"
  },
  {
    ID: 116,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "أسلحة الدمار الشامل",
    Title: "يعزز فريق الخبراء العلميين والتقنيين المعني بالتحقق من نزع السلاح النووي فهم التحديات التقنية المتصلة بالتحقق من نزع السلاح النووي والنهج الممكنة إزاءه",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=17"
  },
  {
    ID: 117,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "الأسلحة التقليدية",
    Title: "زيادة فهم أثر الزيادة العالمية في الإنفاق العسكري على التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، وتقديم مقترحات للتخفيف من ذلك الأثر",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=22"
  },
  {
    ID: 118,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "الأسلحة التقليدية",
    Title: "زيادة استخدام الآلية العالمية للمساعدة في إدارة الذخائر طوال دورة حياتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=23"
  },
  {
    ID: 119,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "الأسلحة التقليدية",
    Title: "معالجة التطورات في مجال تصنيع وتكنولوجيا وتصميم الأسلحة الصغيرة والأسلحة الخفيفة لمنع الاتجار غير المشروع بها وإساءة استخدامها ومكافحة ذلك والقضاء عليه",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=24"
  },
  {
    ID: 120,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "الأسلحة التقليدية",
    Title: "تعزيز الخبرات للمضي قدما في تنفيذ برنامج العمل المتعلق بالأسلحة الصغيرة وصكه الدولي للتعقب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=24"
  },
  {
    ID: 121,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "نزع السلاح الإقليمي، وبناء القدرات، والتوعية",
    Title: "تعزيز الخبرات الوطنية في مجاة نزع السالح للمضي قدما بجهود نزع السالح",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SR,ZM",
    Image: "4ODA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=28"
  },
  {
    ID: 122,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "نزع السلاح الإقليمي، وبناء القدرات، والتوعية",
    Title: "اآللية العالمية المتعلقة بالتطورات في ميدان تكنولوجيا المعلومات واالتصناالت في سنياق األمن الدولي وتعزيز السلور المسؤوة من جانب الدوة في استخدام تكنولوجيات المعلومات والاتصالات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=29"
  },
  {
    ID: 123,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "المفاوضات والمداولات المتعددة الأطراف بشأن نزع السلاح والحد من الأسلحة",
    Title: "تعزيز الخبرة في مجاة نزع السننالح من خالة برنامج األمم المتحدة للزماالت والتدريب والخدمات االسننتشننارية في ميدان نزع السالح",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=33"
  },
  {
    ID: 124,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "الإعلام والتوعية",
    Title: "تمكين الشباب في ميدان نزع السالح وعدم االنتشار",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "نزع السلاح",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=33"
  },
  {
    ID: 125,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "الإعلام والتوعية",
    Title: "زيادة الوعي بقضايا نزع السالح وعدم االنتشار",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=34"
  },
  {
    ID: 126,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "نزع السلاح الإقليمي",
    Title: "التوعينة والندعم علت الصنننننننننعند اإلقليمي ودون اإلقليمي والوطني من أجنل تنفينذ اإلطنار العنالمي إلدارة النذخيرة التقليدية طواة دورة حياتها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=35"
  },
  {
    ID: 127,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "مكتب شؤون نزع السلاح",
    Programme: "نزع السلاح",
    Subprogramme: "نزع السلاح الإقليمي",
    Title: "زيادة ادماج نزع السالح في أطر التنمية الوطنية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "نزع السلاح",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز جهود ومبادرات نزع السلاح وعدم الانتشار وتحديد الأسلحة",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=ar#page=35"
  },
  {
    ID: 128,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "العمليات",
    Title: "التقدم المحرز في تنفيذ التفاق السياسي للسالم والمصالحة في جمهورية أفريقيا الوسطى لعام 2019",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF",
    Image: "5DPO1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=9"
  },
  {
    ID: 129,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "العمليات",
    Title: "التقدم المحرز في تنفيذ الاتفاق المنشط لتسوية النزاع في جمهورية جنوب السودان لعام 2018",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SS,II",
    Image: "5DPO2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=10"
  },
  {
    ID: 130,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "العمليات",
    Title: "تعزيز بناء السلام في أبيي من خلال البرنامج المشترك للمنسقين المقيمين في السودان وجنوب السودان في أبيي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SS,II,SD,QQ",
    Image: "5DPO3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=11"
  },
  {
    ID: 131,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "العمليات",
    Title: "تعزيز عمليات نزع سلاح المقاتلين الأجانب في شرق جمهورية الكونغو الديمقراطية وتسريحهم وإعادتهم إلى أوطانهم وإعادة توطينهم وإعادة إدماجهم في المجتمع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD",
    Image: "5DPO4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=12"
  },
  {
    ID: 132,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "الشؤون العسكرية",
    Title: "تعزيز الستعدادات لنتقال وانسحاب بعثات األمم المتحدة لحفظ السالم",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين أداء وسلامة وأمن بعثات حفظ السلام، بما يشمل كفالة الانتقال السلس في أعقاب تنفيذ قرارات مجلس الأمن",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CY,LB,SS,II,SD,QQ",
    Image: "5DPO5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=14"
  },
  {
    ID: 133,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "الشؤون العسكرية",
    Title: "تنشئ البعثات قدرات للتخلص من الذخائر المتفجرة للتصدي للتهديدات التي تشكلها الأجهزة المتفجرة اليدوية الصنع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين أداء وسلامة وأمن بعثات حفظ السلام، بما يشمل كفالة الانتقال السلس في أعقاب تنفيذ قرارات مجلس الأمن",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LB",
    Image: "5DPO6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=15"
  },
  {
    ID: 134,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "الشؤون العسكرية",
    Title: "استجابة عمليات السلام للتصدي لأخطار منظومات الطائرات المسيرة المعادية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين أداء وسلامة وأمن بعثات حفظ السلام، بما يشمل كفالة الانتقال السلس في أعقاب تنفيذ قرارات مجلس الأمن",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CD,ML",
    Image: "5DPO7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=16"
  },
  {
    ID: 135,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "الشؤون العسكرية",
    Title: "تعزز عمليات السلام الرصد والتحليل والاستجابة للمعلومات المغلوطة والمعلومات المضللة وخطاب الكراهية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين أداء وسلامة وأمن بعثات حفظ السلام، بما يشمل كفالة الانتقال السلس في أعقاب تنفيذ قرارات مجلس الأمن",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,LB,ML,SS,II",
    Image: "5DPO8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=16"
  },
  {
    ID: 136,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "سيادة القانون والمؤسسات الأمنية",
    Title: "تعزيز القدرات الوةنية وا قليمية للتخفيف من المخاةر التي تشكلها األجهزة المتفجرة اليدوية الصنع",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=20"
  },
  {
    ID: 137,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "سيادة القانون والمؤسسات الأمنية",
    Title: "تحسين أداء شرطة الأمم المتحدة لتعزيز تنفيذ الولاية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=21"
  },
  {
    ID: 138,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "سيادة القانون والمؤسسات الأمنية",
    Title: "تمكين الدول المضيفة من مواصلة وإدامة التقدم المحرز في مجال سيادة القانون وإصلاح المؤسسات الأمنية أثناء وبعد المراحل الانتقالية للبعثات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CF,CD,ML,SO",
    Image: "5DPO11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=22"
  },
  {
    ID: 139,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "سيادة القانون والمؤسسات الأمنية",
    Title: "تعزيز المساءلة عن الجرائم المرتكبة ضد موظفي الأمم المتحدة العاملين في عمليات حفظ السلام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF,CD,LB,ML",
    Image: "5DPO12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=23"
  },
  {
    ID: 140,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "السياسات والتقييم والتدريب",
    Title: "تعزيز السياسات والتوجيهات المتعلقة بحماية المدنيين في عمليات دعم السلام التي يقودها الاتحاد الأفريقي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "5DPO13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=27"
  },
  {
    ID: 141,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "السياسات والتقييم والتدريب",
    Title: "منصة إلكترونية لتعزيز التعاون المباشر فيما بين الدول الأعضاء بشأن إعداد أفراد حفظ السلام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=28"
  },
  {
    ID: 142,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "السياسات والتقييم والتدريب",
    Title: "تحسين التحليل والتخطيط على مستوى المكاتب الميدانية لمعالجة ديناميات النزاعات المحلية وتعزيز الحلول السياسية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=29"
  },
  {
    ID: 143,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "إدارة عمليات السلام",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "السياسات والتقييم والتدريب",
    Title: "تعزيز الجهود الرامية إلى منع العنف الجنسي المرتبط بالنزاعات والتصدي له في عمليات حفظ السلام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "الحد من العنف الجنسي، بما في ذلك استخدامه كأسلوب من أساليب الحرب والإرهاب، والحد من العنف ضد الأطفال، بما في ذلك الانتهاكات الجسيمة المرتكبة ضد الأطفال في حالات النزاع المسلح",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=29"
  },
  {
    ID: 144,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "هيئة الأمم المتحدة لمراقبة الهدنة",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "هيئة الأمم المتحدة لمراقبة الهدنة",
    Title: "تعزيز المراقبة على ةول خط وقف إةالق النار وفي المنطقة العازلة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=49"
  },
  {
    ID: 145,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "هيئة الأمم المتحدة لمراقبة الهدنة",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "هيئة الأمم المتحدة لمراقبة الهدنة",
    Title: "زيادة المشاركة في ولية وعمل هيئة األمم المتحدة لمراقبة الهدنة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=50"
  },
  {
    ID: 146,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "هيئة الأمم المتحدة لمراقبة الهدنة",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "هيئة الأمم المتحدة لمراقبة الهدنة",
    Title: "تعزيز القدرة التنظيمية على التنيف مع بيئات العمل المت يرة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين أداء وسلامة وأمن بعثات حفظ السلام، بما يشمل كفالة الانتقال السلس في أعقاب تنفيذ قرارات مجلس الأمن",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=50"
  },
  {
    ID: 147,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "هيئة الأمم المتحدة لمراقبة الهدنة",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "هيئة الأمم المتحدة لمراقبة الهدنة",
    Title: "تعزيز آليات التخطيط والتنسيق في جنوب لبنان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين أداء وسلامة وأمن بعثات حفظ السلام، بما يشمل كفالة الانتقال السلس في أعقاب تنفيذ قرارات مجلس الأمن",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=51"
  },
  {
    ID: 148,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "فريق مراقبي الأمم المتحدة العسكريين في الهند وباكستان",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "فريق مراقبي الأمم المتحدة العسكريين في الهند وباكستان",
    Title: "ورود عدد محدود من الشكاوى بشأن انتهاكات مزعومة لوقف إةالق النار",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=59"
  },
  {
    ID: 149,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "فريق مراقبي الأمم المتحدة العسكريين في الهند وباكستان",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "فريق مراقبي الأمم المتحدة العسكريين في الهند وباكستان",
    Title: "تحسين ا لمام بالحالة من خالل استخدام نظم المعلومات الج رافية المكانية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=60"
  },
  {
    ID: 150,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "فريق مراقبي الأمم المتحدة العسكريين في الهند وباكستان",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "فريق مراقبي الأمم المتحدة العسكريين في الهند وباكستان",
    Title: "استمرار التواجد عند خط المراقبة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=61"
  },
  {
    ID: 151,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "فريق مراقبي الأمم المتحدة العسكريين في الهند وباكستان",
    Programme: "عمليات حفظ السلام",
    Subprogramme: "فريق مراقبي الأمم المتحدة العسكريين في الهند وباكستان",
    Title: "تعزيز التفاهم المتبادل من خالل تعزيز التصال والتوامل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=ar#page=61"
  },
  {
    ID: 152,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "مكتب شؤون الفضاء الخارجي",
    Programme: "استخدام الفضاء الخارجي في الأغراض السلمية",
    Subprogramme: "استخدام الفضاء الخارجي في الأغراض السلمية",
    Title: "تعزيز التخطيط والتأهب لمواجهة الأجسام القريبة من الأرض المحتمل أن تشكل خطراً",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "6COPUOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=ar#page=6"
  },
  {
    ID: 153,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "مكتب شؤون الفضاء الخارجي",
    Programme: "استخدام الفضاء الخارجي في الأغراض السلمية",
    Subprogramme: "استخدام الفضاء الخارجي في الأغراض السلمية",
    Title: "زيادة إمكانية الوصول إلى الفضاء",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=ar#page=6"
  },
  {
    ID: 154,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "مكتب شؤون الفضاء الخارجي",
    Programme: "استخدام الفضاء الخارجي في الأغراض السلمية",
    Subprogramme: "استخدام الفضاء الخارجي في الأغراض السلمية",
    Title: "زيادة فرص الوصول إلى الحلول والشراكات وبناء القدرات في مجال الفضاء والمشاركة في حوكمة أنشطة الفضاء الخارجي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=ar#page=7"
  },
  {
    ID: 155,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "مكتب شؤون الفضاء الخارجي",
    Programme: "استخدام الفضاء الخارجي في الأغراض السلمية",
    Subprogramme: "استخدام الفضاء الخارجي في الأغراض السلمية",
    Title: "زيادة استخدام التكنولوجيا والبيانات الفضائية في إدارة الكوارث والاستجابة لحالات الطوارئ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "صون السلام والأمن الدوليين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=ar#page=8"
  },
  {
    ID: 156,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "محكمة العدل الدولية",
    Programme: "محكمة العدل الدولية",
    Subprogramme: "قلم المحكمة",
    Title: "تحسين فهم الجمهور العام لأنشطة المحكمة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=ar#page=5"
  },
  {
    ID: 157,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "محكمة العدل الدولية",
    Programme: "محكمة العدل الدولية",
    Subprogramme: "قلم المحكمة",
    Title: "تحسين عملية إرسال واستلام الوثائق المتعلقة بالإجراءات القضائية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=ar#page=6"
  },
  {
    ID: 158,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "محكمة العدل الدولية",
    Programme: "محكمة العدل الدولية",
    Subprogramme: "قلم المحكمة",
    Title: "زيادة توافر المعلومات عن المحكمة على منصات التواصل الاجتماعي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=ar#page=6"
  },
  {
    ID: 159,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "محكمة العدل الدولية",
    Programme: "محكمة العدل الدولية",
    Subprogramme: "قلم المحكمة",
    Title: "زيادة إبراز صورة أنشطة المحكمة وتحسين فهم الشباب لها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=ar#page=7"
  },
  {
    ID: 160,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "تقديم الخدمات القانونية إلى منظومة الأمم المتحدة ككل",
    Title: "الأطر القانونية لإنشاء عملية ميدانية جديدة للأمم المتحدة في هايتي وتقديم الدعم لقوة قمع العصابات المتعددة الجنسيات في هايتي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "8OLA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=11"
  },
  {
    ID: 161,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "تقديم الخدمات القانونية إلى منظومة الأمم المتحدة ككل",
    Title: "إبرام اتفاق بشأن المهام المتبقية المستمرة للدوائر الاستثنائية في محاكم كمبوديا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KH",
    Image: "8OLA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=12"
  },
  {
    ID: 162,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "تقديم الخدمات القانونية إلى منظومة الأمم المتحدة ككل",
    Title: "الإطار القانوني والإجرائي لمؤتمرات الأمم المتحدة، بما فيها مؤتمر الأمم المتحدة المعني بالمياه لعام 2026 للتعجيل بتنفيذ الهدف 6 من أهداف التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SN,AE",
    Image: "8OLA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=12"
  },
  {
    ID: 163,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "تقديم الخدمات القانونية إلى منظومة الأمم المتحدة ككل",
    Title: "النهوض بالإصلاحات التنظيمية وعمليات الانتقال المؤسسي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=13"
  },
  {
    ID: 164,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "الخدمات القانونية العامة المقدمة إلى أجهزة الأمم المتحدة وبرامجها",
    Title: "اطِّلاع المكاتب المتلقية للخدمات على نماذج العقود الموحدة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=16"
  },
  {
    ID: 165,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "الخدمات القانونية العامة المقدمة إلى أجهزة الأمم المتحدة وبرامجها",
    Title: "حصول المكاتب المتلقية للخدمات على المشورة القانونية التي ييسِّرها نظام إدارة المسائل المحدَّث",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=16"
  },
  {
    ID: 166,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "الخدمات القانونية العامة المقدمة إلى أجهزة الأمم المتحدة وبرامجها",
    Title: "حصول المكاتب المتلقية للخدمات على الصيغة المحدَّثة من الشروط العامة لعقود الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=17"
  },
  {
    ID: 167,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "الخدمات القانونية العامة المقدمة إلى أجهزة الأمم المتحدة وبرامجها",
    Title: "اطلاع المكاتب المتلقية للخدمات على صيغة محدّثة من العقد النموذجي لتقديم خدمات الشحن الجوي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=17"
  },
  {
    ID: 168,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "التطوير التدريجي للقانون الدولي وتدوينه",
    Title: "اعتمدت اللجنة الخاصة المعنية بميثاق الأمم المتحدة وبتعزيز دور المنظمة تقريراً موضوعياً",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=19"
  },
  {
    ID: 169,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "التطوير التدريجي للقانون الدولي وتدوينه",
    Title: "تقديم عدد أكبر من الدول طلباتٍ للمشاركة في برامج التدريب في مجال القانون الدولي في إطار برنامج المساعدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=20"
  },
  {
    ID: 170,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "التطوير التدريجي للقانون الدولي وتدوينه",
    Title: "زيادة إمكانية اطلاع أوساط القانون الدولي على المواد الوثائقية ذات الطابع القانوني المتصلة بالأمم المتحدة والمنظمات الحكومية الدولية ذات الصلة في الحولية القانونية للأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=21"
  },
  {
    ID: 171,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "التطوير التدريجي للقانون الدولي وتدوينه",
    Title: "تحسين فهم المسائل القانونية المتعلقة بتسوية المنازعات التي تكون المنظمات الدولية أطرافاً فيها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=21"
  },
  {
    ID: 172,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "قانون البحار وشؤون المحيطات",
    Title: "الشروط المطلوبة لبدء نفاذ اتفاق حفظ التنوع البيولوجي البحري في المناطق الواقعة خارج حدود الولاية الوطنية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=24"
  },
  {
    ID: 173,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "قانون البحار وشؤون المحيطات",
    Title: "تعزيز التزام الدول الأعضاء بحفظ المحيطات ومواردها واستخدامها على نحو مستدام عن طريق تنفيذ القانون الدولي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=25"
  },
  {
    ID: 174,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "قانون البحار وشؤون المحيطات",
    Title: "تعزيز الترابط بين العلوم والسياسات من أجل حماية البيئة البحرية وحفظ الموارد البحرية واستخدامها على نحو مستدام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=25"
  },
  {
    ID: 175,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "قانون البحار وشؤون المحيطات",
    Title: "تعزيز دور لجنة حدود الجرف القاري ولجانها الفرعية وفقاً لاتفاقية الأمم المتحدة لقانون البحار",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=26"
  },
  {
    ID: 176,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "تنسيق القانون التجاري الدولي وتحديثه وتوحيده تدريجيا",
    Title: "تعزيز القدرة القضائية على تطبيق الإرشادات الواردة في نصوص لجنة الأمم المتحدة للقانون التجاري الدولي (الأونسيترال) بشأن قانون الإعسار",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=30"
  },
  {
    ID: 177,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "تنسيق القانون التجاري الدولي وتحديثه وتوحيده تدريجيا",
    Title: "زيادة اليقين القانوني في ما يتعلق بمعاملات البيانات التجارية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=31"
  },
  {
    ID: 178,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "تنسيق القانون التجاري الدولي وتحديثه وتوحيده تدريجيا",
    Title: "نظر لجنة الأمم المتحدة للقانون التجاري الدولي في صلة صكوكها بإطار تنظيم الشراء العمومي()",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=32"
  },
  {
    ID: 179,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "تنسيق القانون التجاري الدولي وتحديثه وتوحيده تدريجيا",
    Title: "تنفيذ الإصلاحات المتعلقة بتسوية المنازعات بين المستثمرين والدول من خلال آلية متعددة الأطراف للاتفاقية الإطارية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=32"
  },
  {
    ID: 180,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "إيداع المعاهدات وتسجيلها ونشرها",
    Title: "فتح باب التوقيع على اتفاقية الأمم المتحدة لمكافحة الجريمة السيبرانية؛ تعزيز التعاون الدولي لمكافحة جرائم معينة مرتكبة بواسطة نظم تكنولوجيا المعلومات والاتصالات ولتبادل الأدلة في شكل إلكتروني على الجرائم الخطيرة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=35"
  },
  {
    ID: 181,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "إيداع المعاهدات وتسجيلها ونشرها",
    Title: "مضي الدول الأعضاء قدماً في مناقشة الممارسات المتعلقة بالمعاهدات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=36"
  },
  {
    ID: 182,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "إيداع المعاهدات وتسجيلها ونشرها",
    Title: "إتاحة المعاهدات والإجراءات التعاهدية للجمهور في مجموعة معاهدات الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=37"
  },
  {
    ID: 183,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "مكتب الشؤون القانونية",
    Programme: "الشؤون القانونية",
    Subprogramme: "إيداع المعاهدات وتسجيلها ونشرها",
    Title: "تناول الدول الأعضاء دور التعاون الدولي، بما في ذلك دوره في استخدام التكنولوجيا وبناء القدرات، في تعزيز الإطار التعاهدي الدولي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=37"
  },
  {
    ID: 184,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "آلية التحقيق المستقلة لميانمار",
    Programme: "الشؤون القانونية",
    Subprogramme: "آلية التحقيق المستقلة لميانمار",
    Title: "اطّلاع السلطات المختصة على التحليل الجنائي للمعلومات المستمدة من مصادر علنية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=63"
  },
  {
    ID: 185,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "آلية التحقيق المستقلة لميانمار",
    Programme: "الشؤون القانونية",
    Subprogramme: "آلية التحقيق المستقلة لميانمار",
    Title: "مشاركة الضحايا والناجين والمجتمع المدني والجهات المقدِّمة للمعلومات في عمليات المساءلة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=64"
  },
  {
    ID: 186,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "آلية التحقيق المستقلة لميانمار",
    Programme: "الشؤون القانونية",
    Subprogramme: "آلية التحقيق المستقلة لميانمار",
    Title: "زيادة فرص الاطلاع على الأدلة ذات أوسع مقبولية ممكنة في المحاكم الوطنية والإقليمية والدولية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=65"
  },
  {
    ID: 187,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "آلية التحقيق المستقلة لميانمار",
    Programme: "الشؤون القانونية",
    Subprogramme: "آلية التحقيق المستقلة لميانمار",
    Title: "مساهمة الشهود والمصادر في جهود المساءلة بشكل آمن ومع توفير الدعم النفسي - الاجتماعي اللازم",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=65"
  },
  {
    ID: 188,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "الآلية الدولية المحايدة والمستقلة للمساعدة في التحقيق والملاحقة القضائية للأشخاص المسؤولين عن الجرائم الأشد خطورة وفق القانون الدولي المرتكبة في الجمهورية العربية السورية منذ آذار/مارس 2011",
    Programme: "الشؤون القانونية",
    Subprogramme: "الآلية الدولية المحايدة والمستقلة للمساعدة في التحقيق والملاحقة القضائية للأشخاص المسؤولين عن الجرائم الأشد خطورة وفق القانون الدولي المرتكبة في الجمهورية العربية السورية منذ آذار/مارس 2011",
    Title: "الخطوات المتخذة نحو تحقيق العدالة الانتقالية بقيادة سورية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=75"
  },
  {
    ID: 189,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "الآلية الدولية المحايدة والمستقلة للمساعدة في التحقيق والملاحقة القضائية للأشخاص المسؤولين عن الجرائم الأشد خطورة وفق القانون الدولي المرتكبة في الجمهورية العربية السورية منذ آذار/مارس 2011",
    Programme: "الشؤون القانونية",
    Subprogramme: "الآلية الدولية المحايدة والمستقلة للمساعدة في التحقيق والملاحقة القضائية للأشخاص المسؤولين عن الجرائم الأشد خطورة وفق القانون الدولي المرتكبة في الجمهورية العربية السورية منذ آذار/مارس 2011",
    Title: "تعزيز الحماية والدعم المقدَّمين للضحايا أو الشهود أو المصادر الأخرى المتعاونة مع الآلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SY",
    Image: "8OLA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=76"
  },
  {
    ID: 190,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "الآلية الدولية المحايدة والمستقلة للمساعدة في التحقيق والملاحقة القضائية للأشخاص المسؤولين عن الجرائم الأشد خطورة وفق القانون الدولي المرتكبة في الجمهورية العربية السورية منذ آذار/مارس 2011",
    Programme: "الشؤون القانونية",
    Subprogramme: "الآلية الدولية المحايدة والمستقلة للمساعدة في التحقيق والملاحقة القضائية للأشخاص المسؤولين عن الجرائم الأشد خطورة وفق القانون الدولي المرتكبة في الجمهورية العربية السورية منذ آذار/مارس 2011",
    Title: "اتباع نهج متكامل إزاء إقامة العدل إنصافاً للجميع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SY",
    Image: "8OLA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=76"
  },
  {
    ID: 191,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "الآلية الدولية المحايدة والمستقلة للمساعدة في التحقيق والملاحقة القضائية للأشخاص المسؤولين عن الجرائم الأشد خطورة وفق القانون الدولي المرتكبة في الجمهورية العربية السورية منذ آذار/مارس 2011",
    Programme: "الشؤون القانونية",
    Subprogramme: "الآلية الدولية المحايدة والمستقلة للمساعدة في التحقيق والملاحقة القضائية للأشخاص المسؤولين عن الجرائم الأشد خطورة وفق القانون الدولي المرتكبة في الجمهورية العربية السورية منذ آذار/مارس 2011",
    Title: "عملية يقودها السوريون ويملكون زمامها لكشف الحقيقة وتحقيق العدالة والمساءلة عن الجرائم الأشد خطورة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز العدالة والقانون الدولي",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=ar#page=77"
  },
  {
    ID: 192,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الدعم الحكومي الدولي والتنسيق من أجل التنمية المستدامة",
    Title: "إعادة تأكيد الالتزامات السياسية بخطة التنمية المستدامة لعام 2030، بمناسبة الذكرى العاشرة لإقرارها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=17"
  },
  {
    ID: 193,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الدعم الحكومي الدولي والتنسيق من أجل التنمية المستدامة",
    Title: "تعزيز دور المجلس الاقتصادي والاجتماعي في دعم الدول الأعضاء في ترجمة الالتزامات الصادرة عن مؤتمر القمة المعني بأهداف التنمية المستدامة إلى إجراءات وسياسات وطنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=18"
  },
  {
    ID: 194,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الدعم الحكومي الدولي والتنسيق من أجل التنمية المستدامة",
    Title: "التعجيل بتحقيق أهداف التنمية المستدامة من خلال عملية فعالة لإعداد الاستعراضات الوطنية الطوعية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=19"
  },
  {
    ID: 195,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الدعم الحكومي الدولي والتنسيق من أجل التنمية المستدامة",
    Title: "تعزيز التوجيهات التي يقدّمها المجلس الاقتصادي والاجتماعي إلى منظومة الأمم المتحدة الإنمائية حتى تحسّن إنجاز الأنشطة التنفيذية من أجل التنمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=20"
  },
  {
    ID: 196,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التنمية الاجتماعية الشاملة",
    Title: "التقرير الاجتماعي العالمي لعام 2025 أثرى الحوار السياسات الاجتماعية الدائر في الهيئات الحكومية الدولية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=23"
  },
  {
    ID: 197,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التنمية الاجتماعية الشاملة",
    Title: "تحسين اتساق جهود منظومة الأمم المتحدة في تلبية احتياجات الشعوب الأصلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=24"
  },
  {
    ID: 198,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التنمية الاجتماعية الشاملة",
    Title: "تسريع وتيرة التنمية الاجتماعية من خلال مؤتمر القمة العالمي الثاني للتنمية الاجتماعية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=25"
  },
  {
    ID: 199,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التنمية الاجتماعية الشاملة",
    Title: "تحسين نوعية حياة كبار السن من خلال خامس استعراض وتقييم لتنفيذ خطة عمل مدريد الدولية للشيخوخة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=25"
  },
  {
    ID: 200,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التنمية المستدامة",
    Title: "إطلاق خطة تنفيذ عقد الأمم المتحدة للنقل المستدام (2026-2035)",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=28"
  },
  {
    ID: 201,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التنمية المستدامة",
    Title: "تسريع وتيرة التقدم نحو تحقيق الهدف 14 من أهداف التنمية المستدامة من خلال مؤتمر الأمم المتحدة الثالث المعني بالمحيط",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=29"
  },
  {
    ID: 202,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التنمية المستدامة",
    Title: "التعجيل بتحقيق الهدف 6 من أهداف التنمية المستدامة من خلال مؤتمر الأمم المتحدة المعني بالمياه لعام 2026",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=30"
  },
  {
    ID: 203,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التنمية المستدامة",
    Title: "تقرير التنمية المستدامة على الصعيد العالمي لعام 2027 يوجّه عملية تنفيذ خطة عام 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=30"
  },
  {
    ID: 204,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الإحصاءات",
    Title: "أصبح لدى المستخدمين فهم أفضل لإحصاءات الهجرة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=34"
  },
  {
    ID: 205,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الإحصاءات",
    Title: "تحديث بوابة بيانات الأمم المتحدة undata",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=34"
  },
  {
    ID: 206,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الإحصاءات",
    Title: "تحسين القدرة العالمية على رصد التقدم المحرز في تحقيق أهداف التنمية المستدامة بناء على الأدلة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=35"
  },
  {
    ID: 207,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الإحصاءات",
    Title: "الدول الأعضاء تطبّق نظام الحسابات القومية لعام 2025",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=36"
  },
  {
    ID: 208,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "السكان",
    Title: "التوقعات السكانية على المستوى الوطني ومستوى المقاطعات، التي تم إعدادها باستخدام أساليب احتمالية معترف بها دولياً",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UG",
    Image: "9DESA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=40"
  },
  {
    ID: 209,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "السكان",
    Title: "تعزيز إمكانية مقارنة تقديرات وتوقعات التوسع الحضري والتوزيع المكاني بالنسبة لأهداف التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=40"
  },
  {
    ID: 210,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "السكان",
    Title: "تحسين الأدوات الإلكترونية للتحليل والتَوقُّع والعرض البصري في المجال الديمغرافي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=41"
  },
  {
    ID: 211,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "السكان",
    Title: "قاعدة أدلة معزّزة عن الهجرة الدولية تدعم تقرير السياسات وتشجّع على إرساء خطاب عام مستنير",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=42"
  },
  {
    ID: 212,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التحليلات والسياسات الاقتصادية",
    Title: "أدوات رقمية محسّنة تعزز معرفة المسؤولين الحكوميين بالاقتصاد الكلي والتجارة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=45"
  },
  {
    ID: 213,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التحليلات والسياسات الاقتصادية",
    Title: "استخدام أدوات متقدمة لمحاكاة السياسات بغرض وضع السياسات القائمة على البيانات والمستنيرة بالأدلة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=46"
  },
  {
    ID: 214,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التحليلات والسياسات الاقتصادية",
    Title: "زيادة المشاركة واستخدام المنتجات التحليلية في صنع السياسات القائم على الأدلة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=47"
  },
  {
    ID: 215,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "التحليلات والسياسات الاقتصادية",
    Title: "البلدان الأقل نمواً مستعدة للتعاطي مع عملية الرفع من قائمة البلدان الأقل نمواً ومع مشهد ما بعد الرفع من القائمة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "9DESA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=47"
  },
  {
    ID: 216,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "المؤسسات والتحول الرقمي",
    Title: "الأجهزة العليا للرقابة المالية والمحاسبة أجرت تقييما لمدى تنفيذ الهدف 13 من أهداف التنمية المستدامة المتعلق بالعمل المناخي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=51"
  },
  {
    ID: 217,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "المؤسسات والتحول الرقمي",
    Title: "التنفيذ الوطني لمبادئ الحوكمة الفعالة من أجل التنمية المستدامة من أجل توطيد الثقة في المؤسسات العامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=52"
  },
  {
    ID: 218,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "المؤسسات والتحول الرقمي",
    Title: "الاستجابة الفعالة والمرنة للتحديات والفرص المستقبلية بهدف تسريع التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=53"
  },
  {
    ID: 219,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "المؤسسات والتحول الرقمي",
    Title: "الموظفون العموميون يطبّقون التصوّرات السلوكية ويأخذون بالممارسات الجيدة لتعزيز الابتكار والتحول الرقمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=53"
  },
  {
    ID: 220,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الإدارة المستدامة للغابات",
    Title: "الدول الأعضاء تشرع في تنفيذ برنامج العمل الرباعي السنوات الجديد (2025-2028) من أجل التعجيل بتنفيذ الخطة الاستراتيجية للأمم المتحدة بشأن الغابات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=57"
  },
  {
    ID: 221,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الإدارة المستدامة للغابات",
    Title: "زيادة نطاق منتدى الأمم المتحدة المعني بالغابات وزيادة مساهمة الغابات في خطة عام 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=58"
  },
  {
    ID: 222,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الإدارة المستدامة للغابات",
    Title: "النهوض بأهداف التنمية المستدامة من خلال خطة الأمم المتحدة الاستراتيجية للغابات للفترة 2017-2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=58"
  },
  {
    ID: 223,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "الإدارة المستدامة للغابات",
    Title: "تعزيز التزام الترتيب الدولي المتعلق بالغابات وإجراءاته من أجل تحقيق الأهداف العالمية للغابات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=59"
  },
  {
    ID: 224,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "تمويل التنمية المستدامة",
    Title: "إطار تمويل جديد، هو التزام إشبيلية، المعتمَد في إطار متابعة خطة عمل أديس أبابا",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=62"
  },
  {
    ID: 225,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "تمويل التنمية المستدامة",
    Title: "تعزيز مشاركة الدول الأعضاء في عملية متابعة تمويل التنمية لتحسين الاتساق وتنفيذ النتائج المتفق عليها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=63"
  },
  {
    ID: 226,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "تمويل التنمية المستدامة",
    Title: "تعزيز مشاركة البلدان النامية في صياغة المعايير الضريبية الدولية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=64"
  },
  {
    ID: 227,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "إدارة الشؤون الاقتصادية والاجتماعية",
    Programme: "الشؤون الاقتصادية والاجتماعية",
    Subprogramme: "تمويل التنمية المستدامة",
    Title: "تفعيل هيكل الديون الدولية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=ar#page=65"
  },
  {
    ID: 228,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "أقل البلدان نمواً",
    Title: "تسريع وتيرة تنفيذ برنامج عمل الدوحة لصالح أقل البلدان نمواً وتعزيز رصده",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=8"
  },
  {
    ID: 229,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "أقل البلدان نمواً",
    Title: "إرساء آلية جديدة لتخزين الأغذية للحد من انعدام الأمن الغذائي في أقل البلدان نموا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=9"
  },
  {
    ID: 230,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "أقل البلدان نمواً",
    Title: "تعزيز القدرة على الصمود أمام الصدمات الخارجية في أقل البلدان نمواً",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=10"
  },
  {
    ID: 231,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "أقل البلدان نمواً",
    Title: "تعزيز أقل البلدان نمواً مساراتها نحو الخروج على نحو مستدام ولا رجعة فيه من فئة أقل البلدان نموا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=10"
  },
  {
    ID: 232,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "البلدان النامية غير الساحلية",
    Title: "اعتماد إعلان أوازا السياسي في مؤتمر الأمم المتحدة الثالث المعني بالبلدان النامية غير الساحلية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=13"
  },
  {
    ID: 233,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "البلدان النامية غير الساحلية",
    Title: "توفير التمويل الاستراتيجي لمبادرات التنمية لتعزيز قدرة البلدان النامية غير الساحلية على الصمود في المجال الاقتصادي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=14"
  },
  {
    ID: 234,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "البلدان النامية غير الساحلية",
    Title: "النهوض بقضايا حرية المرور العابر للبلدان النامية غير الساحلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=15"
  },
  {
    ID: 235,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "البلدان النامية غير الساحلية",
    Title: "إدماج برنامج عمل أوازا لصالح البلدان النامية غير الساحلية في الاستراتيجيات الإنمائية الوطنية والقطاعية وأطر التعاون الإنمائي والخطط الاستراتيجية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=15"
  },
  {
    ID: 236,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "الدول الجزرية الصغيرة النامية",
    Title: "تعزيز قدرة الدول الجزرية الصغيرة النامية على تحمل الديون",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=18"
  },
  {
    ID: 237,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "الدول الجزرية الصغيرة النامية",
    Title: "اتخاذ قرارات تستند إلى البيانات لمعالجة أوجه الضعف الهيكلي للدول الجزرية الصغيرة النامية وقدرتها على الصمود",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=19"
  },
  {
    ID: 238,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "الدول الجزرية الصغيرة النامية",
    Title: "استخدام الدول الجزرية الصغيرة النامية لإطار الرصد والإبلاغ الخاص بخطة عمل أنتيغوا وبربودا للدول الجزرية الصغيرة النامية للاسترشاد به في وضع استراتيجيات التخطيط الوطنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=20"
  },
  {
    ID: 239,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "الدول الجزرية الصغيرة النامية",
    Title: "تسخير الشراكات الاستراتيجية لتسريع وتيرة تنفيذ خطة عمل أنتيغوا وبربودا للدول الجزرية الصغيرة النامية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=20"
  },
  {
    ID: 240,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "الدعوة والتوعية والتحليل",
    Title: "تعزيز إدماج برامج العمل الثلاثة في العمليات الحكومية الدولية ذات الصلة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=23"
  },
  {
    ID: 241,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "مكتب الممثلة السامية لأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Programme: "أقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية",
    Subprogramme: "الدعوة والتوعية والتحليل",
    Title: "توفير تحليلات آنية وأعمال رصد لبرامج العمل الثلاثة للاسترشاد بها في صياغة السياسات والتخطيط واتخاذ القرارات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=ar#page=24"
  },
  {
    ID: 242,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "إدارة البيانات والمعارف من أجل إيجاد سياسات وأنشطة دعوية مرتكزة على الأدلة دعماً لخطة عام 2063",
    Title: "تطبيق صانعي السياسات الأفارقة نُهجاً تحليلية متكاملة لدعم تحقيق النتائج على صعيدي السلام والتنمية على المدى الطويل",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: " ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=9"
  },
  {
    ID: 243,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "إدارة البيانات والمعارف من أجل إيجاد سياسات وأنشطة دعوية مرتكزة على الأدلة دعماً لخطة عام 2063",
    Title: "الحلول الرقمية لتحويل النظم المالية وإدارة الديون في أفريقيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=10"
  },
  {
    ID: 244,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "إدارة البيانات والمعارف من أجل إيجاد سياسات وأنشطة دعوية مرتكزة على الأدلة دعماً لخطة عام 2063",
    Title: "تزويدُ المنظومات السياساتية القوى العاملة في أفريقيا بالمهارات اللازمة في اقتصاد رقمي عالمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=10"
  },
  {
    ID: 245,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "إدارة البيانات والمعارف من أجل إيجاد سياسات وأنشطة دعوية مرتكزة على الأدلة دعماً لخطة عام 2063",
    Title: "تعزيزُ السياسات المتعلقة بتعليم الشباب وتنمية مهاراتهم من أجل التصدي لانعدام الأمن الغذائي وتدعيم القدرة على الصمود في وجه تغير المناخ في أفريقيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=11"
  },
  {
    ID: 246,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "التنسيق الإقليمي للدعم المقدّم من الأمم المتحدة من أجل التنفيذ المتكامل لخطة التنمية المستدامة لعام 2030 وخطة عام 2063",
    Title: "اعتمادُ استراتيجية تعبئة الموارد المحلية لتمويل الخطة العشرية الثانية لتنفيذ خطة عام 2063",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=14"
  },
  {
    ID: 247,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "التنسيق الإقليمي للدعم المقدّم من الأمم المتحدة من أجل التنفيذ المتكامل لخطة التنمية المستدامة لعام 2030 وخطة عام 2063",
    Title: "وضع استراتيجيات طويلة الأجل لإدارة الديون في أفريقيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=15"
  },
  {
    ID: 248,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "التنسيق الإقليمي للدعم المقدّم من الأمم المتحدة من أجل التنفيذ المتكامل لخطة التنمية المستدامة لعام 2030 وخطة عام 2063",
    Title: "تعزيز استجابة المؤسسات العامة ومساءلتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "الإدارة العامة",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=15"
  },
  {
    ID: 249,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "التنسيق الإقليمي للدعم المقدّم من الأمم المتحدة من أجل التنفيذ المتكامل لخطة التنمية المستدامة لعام 2030 وخطة عام 2063",
    Title: "وضع الدول الأعضاء الأفريقية سياسات للتصدي لآثار تغير المناخ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=16"
  },
  {
    ID: 250,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "الأنشطة الإعلامية وأنشطة التوعية الرامية إلى دعم خطة عام 2063",
    Title: "تسليط الشراكة الإعلامية بوصولها إلى 130 مليون شخص الضوء على وجهات النظر الأفريقية بشأن الذكاء الاصطناعي والعمالة الرقمية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=19"
  },
  {
    ID: 251,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "الأنشطة الإعلامية وأنشطة التوعية الرامية إلى دعم خطة عام 2063",
    Title: "إشراك عامة الجمهور في مسألة عبء الدين في أفريقيا والحلول الممكنة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=20"
  },
  {
    ID: 252,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "الأنشطة الإعلامية وأنشطة التوعية الرامية إلى دعم خطة عام 2063",
    Title: "تعزيز التوعية من قبل الشركاء الإعلاميين بشأن التعليم والعمل اللائق والحماية الاجتماعية في أفريقيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=20"
  },
  {
    ID: 253,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "مكتب المستشار الخاص لشؤون أفريقيا",
    Programme: "دعم منظومة الأمم المتحدة لخطة الاتحاد الأفريقي لعام 2063: أفريقيا التي نصبو إليها",
    Subprogramme: "الأنشطة الإعلامية وأنشطة التوعية الرامية إلى دعم خطة عام 2063",
    Title: "زيادة إبراز الحلول التي يقودها الشباب من أجل بناء القدرة على الصمود في وجه تغير المناخ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الدول الأعضاء في أفريقيا",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=ar#page=21"
  },
  {
    ID: 254,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "العولمة والترابط والتنمية",
    Title: "استرشاد المناقشات والاستجابات السياساتية العالمية بتقرير ”توقعات التجارة والتنمية“",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=13"
  },
  {
    ID: 255,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "العولمة والترابط والتنمية",
    Title: "تعزيز شفافية البيانات المتعلقة بالديون في البلدان النامية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EC,EG,QG,JO",
    Image: "12UNCTAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=14"
  },
  {
    ID: 256,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "العولمة والترابط والتنمية",
    Title: "قيام الاقتصادات النامية بتصميم سياسات لتحقيق التحول الصناعي والهيكلي المستدام من خلال التعاون فيما بين بلدان الجنوب والتعاون الثلاثي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KZ,MY,PK,TR",
    Image: "12UNCTAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=14"
  },
  {
    ID: 257,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "العولمة والترابط والتنمية",
    Title: "زيادة الكفاءة والاستدامة في إدارة الديون من جانب البلدان المقترِضة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=15"
  },
  {
    ID: 258,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "الاستثمار والمشاريع",
    Title: "تعزيز منظومات ريادة الأعمال من أجل الشمول والابتكار في تنمية المشاريع",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: " ",
    SpecificResult: "مباشرة الأعمال الحرة وزيادة القدرة التنافسية للمشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=19"
  },
  {
    ID: 259,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "الاستثمار والمشاريع",
    Title: "تسريع وتيرة الاستثمار في أهداف التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=20"
  },
  {
    ID: 260,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "الاستثمار والمشاريع",
    Title: "تهيئة الدول الأعضاء لمناخ مواتٍ للأعمال التجارية والاستثمار",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=21"
  },
  {
    ID: 261,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "الاستثمار والمشاريع",
    Title: "زيادة اعتماد ممارسات الاستثمار المستدام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=21"
  },
  {
    ID: 262,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "التجارة الدولية والسلع الأساسية",
    Title: "تعزيز سلامة المنتجات الاستهلاكية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=27"
  },
  {
    ID: 263,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "التجارة الدولية والسلع الأساسية",
    Title: "تعزيز تنفيذ المساهمات المحددة وطنيا من خلال السياسات التجارية من جانب البلدان النامية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GM",
    Image: "12UNCTAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=28"
  },
  {
    ID: 264,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "التجارة الدولية والسلع الأساسية",
    Title: "تسخير الدول الأعضاء للمعادن الحرجة للانتقال الطاقي من أجل التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NA,ZM",
    Image: "12UNCTAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=28"
  },
  {
    ID: 265,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "التجارة الدولية والسلع الأساسية",
    Title: "توفير بيانات آنية عن التدابير غير الجمركية من أجل تحسين الممارسات التنظيمية وتعزيز التنمية الاقتصادية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=29"
  },
  {
    ID: 266,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "التكنولوجيا واللوجستيات",
    Title: "نهوض البلدان النامية بعملية وضع المفاهيم الخاصة بمجمعات العلم والتكنولوجيا والابتكار وتطوير هذه المجمعات من أجل التنمية المستدامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,MN,MZ,UZ",
    Image: "12UNCTAD13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=35"
  },
  {
    ID: 267,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "التكنولوجيا واللوجستيات",
    Title: "تحسين توافر إحصاءات الاقتصاد الرقمي في البلدان النامية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=36"
  },
  {
    ID: 268,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "التكنولوجيا واللوجستيات",
    Title: "تعزيز كفاءة الإجراءات التجارية واستدامتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JM,VC,TJ,TL,VU,ZW",
    Image: "12UNCTAD15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=37"
  },
  {
    ID: 269,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "التكنولوجيا واللوجستيات",
    Title: "تعزيز الشمول في مجال تيسير التجارة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=37"
  },
  {
    ID: 270,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "أفريقيا وأقل البلدان نموا والبرامج الخاصة",
    Title: "تَوصُّل أقل البلدان نموا إلى موقف مشترك بشأن قواعد المنشأ وجدول أعمال للمؤتمر الوزاري الرابع عشر لمنظمة التجارة العالمية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "12UNCTAD17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=43"
  },
  {
    ID: 271,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "أفريقيا وأقل البلدان نموا والبرامج الخاصة",
    Title: "تعزيز القدرة الإحصائية لأقل البلدان نموا والبلدان النامية الأخرى، للمساعدة على تبني تحول نموذجي في صياغة سياسات التنويع الاقتصادي الكلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,ET,KE,NG",
    Image: "12UNCTAD18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=44"
  },
  {
    ID: 272,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "أفريقيا وأقل البلدان نموا والبرامج الخاصة",
    Title: "تعزيز قدرة الدول الجزرية الصغيرة النامية على بناء القدرات الإنتاجية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,KM,DO,MV,JM,VC,TT",
    Image: "12UNCTAD19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=44"
  },
  {
    ID: 273,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "مؤتمر الأمم المتحدة للتجارة والتنمية",
    Programme: "التجارة والتنمية",
    Subprogramme: "أفريقيا وأقل البلدان نموا والبرامج الخاصة",
    Title: "تمكين أقل البلدان نموا من صياغة وتنفيذ سياسات تجارية متسقة وشاملة للجميع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BF,TD,TZ",
    Image: "12UNCTAD20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=ar#page=45"
  },
  {
    ID: 274,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "مركز التجارة الدولية",
    Programme: "مركز التجارة الدولية",
    Subprogramme: "الجوانب التشغيلية لتشجيع التجارة وتنمية الصادرات",
    Title: "تعزيز الابتكار والأعمال التجارية وفرص العمل في أفريقيا وأمريكا اللاتينية للشركات الناشئة للشباب ومباشري الأعمال الحرة من الشباب",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "مباشرة الأعمال الحرة وزيادة القدرة التنافسية للمشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,UG",
    Image: "13ITC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=ar#page=6"
  },
  {
    ID: 275,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "مركز التجارة الدولية",
    Programme: "مركز التجارة الدولية",
    Subprogramme: "الجوانب التشغيلية لتشجيع التجارة وتنمية الصادرات",
    Title: "تعزيز الخدمات التي تقدمها منظمات دعم الأعمال المحلية لفائدة الشركات الصغيرة للاستفادة من منطقة التجارة الحرة القارية الأفريقية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    SpecificResult: "مباشرة الأعمال الحرة وزيادة القدرة التنافسية للمشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "13ITC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=ar#page=7"
  },
  {
    ID: 276,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "مركز التجارة الدولية",
    Programme: "مركز التجارة الدولية",
    Subprogramme: "الجوانب التشغيلية لتشجيع التجارة وتنمية الصادرات",
    Title: "تحول المؤسسات الصغيرة والمتوسطة العاملة في قطاع المنسوجات والملابس في أفريقيا ومنطقة آسيا والمحيط الهادئ إلى عمليات مستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    SpecificResult: "مباشرة الأعمال الحرة وزيادة القدرة التنافسية للمشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "13ITC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=ar#page=8"
  },
  {
    ID: 277,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "مركز التجارة الدولية",
    Programme: "مركز التجارة الدولية",
    Subprogramme: "الجوانب التشغيلية لتشجيع التجارة وتنمية الصادرات",
    Title: "تعزيز القدرة التنافسية التصديرية للمؤسسات الصغيرة والمتوسطة من أوروبا الشرقية ووسط آسيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: " ",
    SpecificResult: "مباشرة الأعمال الحرة وزيادة القدرة التنافسية للمشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,KZ,KG,TJ,UZ",
    Image: "13ITC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=ar#page=9"
  },
  {
    ID: 278,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المناخي",
    Title: "التزام المدن بأهداف التبريد المستدام",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=11"
  },
  {
    ID: 279,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المناخي",
    Title: "وضع الدول الأعضاء خرائط طريق وخطط عمل وطنية بشأن الميثان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=12"
  },
  {
    ID: 280,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المناخي",
    Title: "اعتماد الدول الأعضاء تكنولوجيات سليمة بيئيا للتخفيف من آثار تغيّر المناخ والتكيّف معه",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=13"
  },
  {
    ID: 281,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المناخي",
    Title: "قيام الحكومات على المستويين الوطني ودون الوطني باعتماد استراتيجيات وسياسات للتكيّف مع آثار تغيّر المناخ، بما في ذلك خطط التكيّف الوطنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=13"
  },
  {
    ID: 282,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "التحولات الرقمية في دعم العمل البيئي",
    Title: "تمكُّن الحكومات وصانعي السياسات من الوصول إلى بوابة إلكترونية لشؤون البيئة مدعومة بالذكاء الاصطناعي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=16"
  },
  {
    ID: 283,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "التحولات الرقمية في دعم العمل البيئي",
    Title: "زيادة قابلية التشغيل المتبادل للبيانات البيئية العالمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=17"
  },
  {
    ID: 284,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "التحولات الرقمية في دعم العمل البيئي",
    Title: "تعزيز القدرات الرقمية للنهوض بالاستدامة البيئية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=17"
  },
  {
    ID: 285,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "التحولات الرقمية في دعم العمل البيئي",
    Title: "استرشاد عملية اتخاذ القرارات السياساتية بغرفة متابعة الحالة البيئية العالمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=18"
  },
  {
    ID: 286,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المتعلق بالطبيعة",
    Title: "التزام الدول الأعضاء بحماية التنوع البيولوجي البحري خارج الحدود الوطنية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=21"
  },
  {
    ID: 287,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المتعلق بالطبيعة",
    Title: "قيام مؤسسات القطاع العام بإدراج المساهمة الاقتصادية للتنوع البيولوجي وخدمات النظم الإيكولوجية في عملية اتخاذ القرارات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=21"
  },
  {
    ID: 288,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المتعلق بالطبيعة",
    Title: "تعزيز قدرة النظم الإيكولوجية للشعاب المرجانية الساحلية والمجتمعات المحلية على الصمود",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=22"
  },
  {
    ID: 289,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المتعلق بالطبيعة",
    Title: "توسيع النظم الإيكولوجية التي تخضع للإدارة والإصلاح المستدامين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=23"
  },
  {
    ID: 290,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "الإدارة البيئية",
    Title: "قيام الدول الأعضاء بتعزيز الأطر القانونية والاستراتيجيات الوطنية للتصدي للاتجار غير المشروع بالنفايات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=25"
  },
  {
    ID: 291,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "الإدارة البيئية",
    Title: "خفض إنتاج واستهلاك الهيدروكلوروفلوروكربونات من خلال تنفيذ تعديل كيغالي لبروتوكول مونتريال المتعلق بالمواد المستنفِدة لطبقة الأوزون",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=26"
  },
  {
    ID: 292,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "الإدارة البيئية",
    Title: "قيام أصحاب المصلحة في المجال القانوني بتعزيز تنفيذ القانون البيئي وإنفاذه",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "النهوض بالقانون الدولي وتعزيز آليات تسوية المنازعات الدولية",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=27"
  },
  {
    ID: 293,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "الإدارة البيئية",
    Title: "دمج الأهداف البيئية في السياسات والأطر القانونية الوطنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=28"
  },
  {
    ID: 294,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المتعلق بالمواد الكيميائية والتلوث",
    Title: "الحد من المواد الكيميائية التي تثير قلقا عالميا ومن نفاياتها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=30"
  },
  {
    ID: 295,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المتعلق بالمواد الكيميائية والتلوث",
    Title: "اعتماد السياسات والممارسات لدعم نُهج الاقتصاد الدائري في القطاعات ذات التأثير الكبير لخفض التلوث",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=31"
  },
  {
    ID: 296,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المتعلق بالمواد الكيميائية والتلوث",
    Title: "اعتماد سياسات واستراتيجيات لمعالجة الأبعاد البيئية لمقاومة مضادات الميكروبات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=32"
  },
  {
    ID: 297,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "العمل المتعلق بالمواد الكيميائية والتلوث",
    Title: "اعتماد الدول الأعضاء سياسات أو قوانين أو تنظيمات بشأن إدارة المواد الكيميائية والنفايات في القطاعات الرئيسية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=32"
  },
  {
    ID: 298,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "التحولات المالية والاقتصادية",
    Title: "التزام شركات التأمين بتطبيق نهج الاستدامة في ممارساتها لتسيير الأعمال",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=35"
  },
  {
    ID: 299,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "التحولات المالية والاقتصادية",
    Title: "زيادة توافر الأدوات والتدابير اللازمة لتحويل الخيارات وسلوك الحكومات ومؤسسات الأعمال وفرادى المستهلكين من أجل تحقيق الاستدامة البيئية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=36"
  },
  {
    ID: 300,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "التحولات المالية والاقتصادية",
    Title: "التعجيل بالتقدم نحو أنماط الاستهلاك والإنتاج المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=37"
  },
  {
    ID: 301,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "التحولات المالية والاقتصادية",
    Title: "اعتماد الدول الأعضاء سياسات تهدف إلى زيادة التمويل المستدام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=37"
  },
  {
    ID: 302,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "السياسة العلمية",
    Title: "تنفيذ البلدان لنظام المحاسبة البيئية – الاقتصادية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=40"
  },
  {
    ID: 303,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "السياسة العلمية",
    Title: "تحسين رصد النفايات الإلكترونية وجمعها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=41"
  },
  {
    ID: 304,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "السياسة العلمية",
    Title: "تعزيز التفاعل بين العلوم والسياسات في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE",
    Image: "14UNEP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=42"
  },
  {
    ID: 305,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "برنامج الأمم المتحدة للبيئة",
    Programme: "البيئة",
    Subprogramme: "السياسة العلمية",
    Title: "استرشاد الحكومات والمؤسسات بمعارف برنامج الأمم المتحدة للبيئة وبياناته وإحصاءاته وتقييماته في تقرير السياسات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=ar#page=42"
  },
  {
    ID: 306,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "الإسكان والأراضي والخدمات الأساسية والبيئة الحضرية",
    Title: "دمج التنقل المستدام مع السكن القريب من وسائل النقل العام من أجل توسيع نطاق الوصول العادل إلى وسائل نقل عام آمنة ومنصفة في المدن، ولا سيما في ضواحيها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,KE,NG,UG",
    Image: "15UN-Habitat1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=13"
  },
  {
    ID: 307,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "الإسكان والأراضي والخدمات الأساسية والبيئة الحضرية",
    Title: "التزام المدن والبلدان بتوفير سكن لائق للجميع والتصدي للتشرد والاستبعاد من السكن",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,KM,CU,MX",
    Image: "15UN-Habitat2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=14"
  },
  {
    ID: 308,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "الإسكان والأراضي والخدمات الأساسية والبيئة الحضرية",
    Title: "زيادة ضمان حقوق حيازة الأراضي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NP",
    Image: "15UN-Habitat3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=15"
  },
  {
    ID: 309,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "الإسكان والأراضي والخدمات الأساسية والبيئة الحضرية",
    Title: "زيادة فرص الحصول على السكن اللائق والأراضي والخدمات الأساسية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=16"
  },
  {
    ID: 310,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "التخطيط والسياسة المالية والتوطين والحوكمة",
    Title: "إصلاحات قانون التخطيط تعزز الحوكمة المتعددة المستويات من أجل بناء مدن قادرة على الصمود ومستدامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BW,SL,ZW",
    Image: "15UN-Habitat5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=20"
  },
  {
    ID: 311,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "التخطيط والسياسة المالية والتوطين والحوكمة",
    Title: "رفع مستوى نظم الإيرادات المتأتية من مصادر خاصة من أجل تحسين أداء الحكومات المحلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=21"
  },
  {
    ID: 312,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "التخطيط والسياسة المالية والتوطين والحوكمة",
    Title: "يؤدي توطين أهداف التنمية المستدامة إلى حدوث تغيير على مستوى النظم وإلى تحول عمراني من خلال تنمية الحوكمة الشاملة المتعددة المستويات، ومشاركة أصحاب المصلحة، والقدرات المؤسسية، وتوفير التمويل للحلول المحلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=21"
  },
  {
    ID: 313,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "المعارف، والبيانات، والرقمنة، وتنمية القدرات",
    Title: "يتمتع الممارسون في مجال التوسع الحضري بإمكانية الوصول غير المقيد إلى المعارف العملية والإرشادات بعدة لغات للمساعدة في التعجيل بتنفيذ الخطة الحضرية الجديدة وأهداف التنمية المستدامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=25"
  },
  {
    ID: 314,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "المعارف، والبيانات، والرقمنة، وتنمية القدرات",
    Title: "التحول الرقمي من أجل التنمية الحضرية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=26"
  },
  {
    ID: 315,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "المعارف، والبيانات، والرقمنة، وتنمية القدرات",
    Title: "تعمل السلطات الوطنية والمحلية على زيادة وتحسين إنتاج البيانات المصنفة ذات الصلة بالسياسات في مجالات الإسكان والأراضي والخدمات الأساسية (النتيجة التراكمية)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=27"
  },
  {
    ID: 316,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "الشراكات والتحالفات والدعوة والتواصل",
    Title: "يعمل المنتدى العالمي لأصحاب المصلحة على تعزيز التنمية الحضرية الشاملة والمسؤولة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=30"
  },
  {
    ID: 317,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "الشراكات والتحالفات والدعوة والتواصل",
    Title: "الاستفادة من المنتدى الحضري العالمي للنهوض بالالتزامات العالمية الرامية إلى كفالة توفير السكن اللائق والأراضي والخدمات الأساسية للجميع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=30"
  },
  {
    ID: 318,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "تعزيز الإجراءات المتعلقة بالمناخ وتحسين البيئة الحضرية",
    Title: "زيادة اشتمال المساهمات المحددة وطنيا على محتوى حضري",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=34"
  },
  {
    ID: 319,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "تعزيز الإجراءات المتعلقة بالمناخ وتحسين البيئة الحضرية",
    Title: "خطط العمل المناخي في المناطق الحضرية لبناء قدرة الفئات الأكثر ضعفاً على الصمود",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=35"
  },
  {
    ID: 320,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "العمل بفعالية على منع حدوث الأزمات الحضرية والتصدي لها",
    Title: "الإدماج المستدام للمجتمعات المحلية النازحة في المناطق الحضرية في الصومال",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SO",
    Image: "15UN-Habitat15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=37"
  },
  {
    ID: 321,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "برنامج الأمم المتحدة للمستوطنات البشرية",
    Programme: "المستوطنات البشرية",
    Subprogramme: "العمل بفعالية على منع حدوث الأزمات الحضرية والتصدي لها",
    Title: "التخطيط الحضري المتكامل والتشاركي والتنمية الشاملة للجميع",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SO",
    Image: "15UN-Habitat16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=ar#page=37"
  },
  {
    ID: 322,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "مكافحة الجريمة المنظمة عبر الوطنية",
    Title: "تعزيز التعاون الدولي في مكافحة الجريمة السيبرانية وتبادل الأدلة في شكل إلكتروني على الجرائم الخطيرة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=20"
  },
  {
    ID: 323,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "مكافحة الجريمة المنظمة عبر الوطنية",
    Title: "تحسين تسجيل وتعقب الأسلحة النارية وأجزائها ومكوناتها وذخيرتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "HN,SN",
    Image: "16UNODC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=21"
  },
  {
    ID: 324,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "مكافحة الجريمة المنظمة عبر الوطنية",
    Title: "تعزيز الكشف عن الاتجار جوا وبحرا وبرا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=22"
  },
  {
    ID: 325,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "مكافحة الجريمة المنظمة عبر الوطنية",
    Title: "تعزيز التدابير المعيارية والسياساتية والمؤسسية لمكافحة الجريمة المنظمة على الصعيد العالمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=23"
  },
  {
    ID: 326,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "الأخذ بنهج شامل ومتوازن لمواجهة مشكلة المخدرات العالمية",
    Title: "تعزيز قدرة الدول الأعضاء على تفكيك الشبكات الإجرامية الضالعة في الاتجار بالمخدرات من خلال تعزيز التعاون الدولي على أساس الحالات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,BR,CV,CL,CI,DE,PE",
    Image: "16UNODC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=26"
  },
  {
    ID: 327,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "الأخذ بنهج شامل ومتوازن لمواجهة مشكلة المخدرات العالمية",
    Title: "تنفيذ الدول الأعضاء في أفريقيا جنوب الصحراء الكبرى تدخلات أقوى في مجالي الصحة والتنمية في سياق التصدي لمشكلة المخدرات العالمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "16UNODC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=27"
  },
  {
    ID: 328,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "الأخذ بنهج شامل ومتوازن لمواجهة مشكلة المخدرات العالمية",
    Title: "سد الثغرات العالمية في تقديم الخدمات من خلال إطلاق مبادرات جديدة في مجالي الصحة والتنمية وتنفيذها على الصعيد الوطني",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=27"
  },
  {
    ID: 329,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "الأخذ بنهج شامل ومتوازن لمواجهة مشكلة المخدرات العالمية",
    Title: "تأهيل موظفي المختبرات الجنائية لتحليل وكشف المخدرات الاصطناعية والسلائف الكيميائية المستخدمة في تصنيعها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=28"
  },
  {
    ID: 330,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "مكافحة الفساد",
    Title: "قيام الدول الأعضاء بالتحقيق في قضايا جرائم الفساد الدولية المعقدة وملاحقة مرتكبيها قضائيا والفصل فيها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DO,KE,MY,PA,TZ,VN",
    Image: "16UNODC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=32"
  },
  {
    ID: 331,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "مكافحة الفساد",
    Title: "تعزيز استخدام الدول للمعلومات المتعلقة بالملكية النفعية في جهود مكافحة الفساد",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GT,HN,PY,PH,VN,ZM",
    Image: "16UNODC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=32"
  },
  {
    ID: 332,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "مكافحة الفساد",
    Title: "تعزيز التعاون بين الدول على الصعيد الإقليمي لمكافحة الفساد",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=33"
  },
  {
    ID: 333,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "مكافحة الفساد",
    Title: "امتلاك الدول أطرا قانونية وسياساتية فعالة لمكافحة الفساد بما يتماشى مع اتفاقية الأمم المتحدة لمكافحة الفساد",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=34"
  },
  {
    ID: 334,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "منع الإرهاب",
    Title: "تعزيز تدابير العدالة الجنائية لمكافحة تمويل الإرهاب في كوت ديفوار",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI",
    Image: "16UNODC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=37"
  },
  {
    ID: 335,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "منع الإرهاب",
    Title: "حدوث تغيير مؤسسي في الجنوب الأفريقي بهدف بناء نظم عدالة جنائية قوية وخاضعة للمساءلة ومكافحة الإرهاب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MZ",
    Image: "16UNODC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=37"
  },
  {
    ID: 336,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "منع الإرهاب",
    Title: "زيادة إسهامات الموظفات في تعزيز نظم العدالة الجنائية لمكافحة الإرهاب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=38"
  },
  {
    ID: 337,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "منع الإرهاب",
    Title: "زيادة استعداد الدول لمواجهة الإرهاب الإشعاعي والنووي من خلال الاتفاقية الدولية لقمع أعمال الإرهاب النووي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=39"
  },
  {
    ID: 338,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "العدالة",
    Title: "تحسين امتثال نظم السجون الوطنية للمعايير الدولية من أجل تعزيز إعادة التأهيل",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=42"
  },
  {
    ID: 339,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "العدالة",
    Title: "بذل جهود منع الجريمة وإصلاح العدالة الجنائية مع إيلاء الاحترام الكامل لحقوق الإنسان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=43"
  },
  {
    ID: 340,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "العدالة",
    Title: "تمكين الأطفال والشباب لمنع انخراطهم في الجريمة والعنف",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=43"
  },
  {
    ID: 341,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "العدالة",
    Title: "تعزيز المسؤولية الوطنية عن المبادرات في مجال منع الجريمة والعدالة الجنائية من خلال الشراكات المؤسسية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=44"
  },
  {
    ID: 342,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "الأبحاث وتحليل الاتجاهات والأدلة الجنائية",
    Title: "تعزيز قدرات وخبرات العاملين في مجالي إنفاذ القانون والأدلة الجنائية من الأمريكتين فيما يخص التحقيق في مسرح الجريمة وفحص الوثائق الأمنية المزورة والمزيفة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,CL,CR,DO,EC,SV,GT,GY,HN,JM,PA,PY,PE,TT,UY",
    Image: "16UNODC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=47"
  },
  {
    ID: 343,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "الأبحاث وتحليل الاتجاهات والأدلة الجنائية",
    Title: "رصدُ مختبرات الدول الأعضاء المختصة في اختبارات الكشف عن تعاطي المخدرات وعلم السموم أداءها في إطار ممارسات ضمان الجودة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=48"
  },
  {
    ID: 344,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "الأبحاث وتحليل الاتجاهات والأدلة الجنائية",
    Title: "زيادة إمكانية الوصول إلى الأدلة التي تحتاجها الدول الأعضاء لفهم الاتجار بالأشخاص ومكافحته",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=49"
  },
  {
    ID: 345,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "الأبحاث وتحليل الاتجاهات والأدلة الجنائية",
    Title: "تزايد استخدام الدول الأعضاء لأبحاث مكتب الأمم المتحدة المعني بالمخدرات والجريمة في صياغة سياساتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=49"
  },
  {
    ID: 346,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "دعم السياسات",
    Title: "تلقِّي ضحايا الاتجار بالأشخاص دعماً شاملاً يركز على احتياجات الضحية من خلال صندوق الأمم المتحدة الاستئماني للتبرعات لضحايا الاتجار بالأشخاص، وبخاصة النساء والأطفال",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=52"
  },
  {
    ID: 347,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "دعم السياسات",
    Title: "مشاركة الشباب مشاركة هادفة في عمليات صنع القرار بشأن المخدرات والجريمة والفساد",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الشباب",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=53"
  },
  {
    ID: 348,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "دعم السياسات",
    Title: "تنفيذ مبادرات الشراكة بين القطاعين العام والخاص في سياق اتفاقية الأمم المتحدة لمكافحة الجريمة السيبرانية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DO,NG",
    Image: "16UNODC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=54"
  },
  {
    ID: 349,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "دعم السياسات",
    Title: "زيادة الوعي العام بالمخاطر التي تشكلها المخدرات والجريمة والفساد والإرهاب من خلال نشر محتوى محدد الأهداف على وسائل التواصل الاجتماعي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=54"
  },
  {
    ID: 350,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "التعاون التقني والدعم الميداني",
    Title: "تعزيز المساءلة وفعالية نظام العدالة في هايتي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "16UNODC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=57"
  },
  {
    ID: 351,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "التعاون التقني والدعم الميداني",
    Title: "مواجهة التحديات في مجال السلامة البحرية من خلال تعزيز نظم إدارة السلامة البحرية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,KM,KE,MG,MU,MZ,NA,SC,TZ",
    Image: "16UNODC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=58"
  },
  {
    ID: 352,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "التعاون التقني والدعم الميداني",
    Title: "تعزيز الشفافية والكفاءة في إدارة الأصول من أجل تحسين منع الجريمة وثقة الجمهور",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "MZ",
    Image: "16UNODC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=59"
  },
  {
    ID: 353,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "التعاون التقني والدعم الميداني",
    Title: "منع الأنشطة الإجرامية المنظمة والتصدي لها في الأراضي والأقاليم التي تسكنها تقليديا الشعوب الأصلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التقيد بسيادة القانون؛ وتعزيز منع الجريمة والعدالة الجنائية؛ والحد من الفساد؛ ومنع الإرهاب ومكافحته",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR",
    Image: "16UNODC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=60"
  },
  {
    ID: 354,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "توفير خدمات الأمانة والدعم الفني للجنة المخدرات ولجنة منع الجريمة والعدالة الجنائية ومؤتمر الأمم المتحدة لمنع الجريمة والعدالة الجنائية",
    Title: "إحراز تقدم في الأعمال التحضيرية لمؤتمر الأمم المتحدة الخامس عشر لمنع الجريمة والعدالة الجنائية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT,CR,ET,MA,TH",
    Image: "16UNODC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=63"
  },
  {
    ID: 355,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "توفير خدمات الأمانة والدعم الفني للجنة المخدرات ولجنة منع الجريمة والعدالة الجنائية ومؤتمر الأمم المتحدة لمنع الجريمة والعدالة الجنائية",
    Title: "تعزيز تنفيذ الالتزامات الدولية المتعلقة بسياسات منع الجريمة والعدالة الجنائية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=63"
  },
  {
    ID: 356,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "توفير خدمات الأمانة والدعم الفني للجنة المخدرات ولجنة منع الجريمة والعدالة الجنائية ومؤتمر الأمم المتحدة لمنع الجريمة والعدالة الجنائية",
    Title: "تسريع العمل على منع الجريمة والعدالة الجنائية وسيادة القانون من خلال اعتماد إعلان أبوظبي وتنفيذه",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=64"
  },
  {
    ID: 357,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "توفير خدمات الأمانة والدعم الفني للجنة المخدرات ولجنة منع الجريمة والعدالة الجنائية ومؤتمر الأمم المتحدة لمنع الجريمة والعدالة الجنائية",
    Title: "التعجيل بتنفيذ الالتزامات الدولية المتعلقة بسياسات مكافحة المخدرات من أجل التصدي بفعالية لمشكلة المخدرات العالمية ومواجهتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز تعددية الأطراف",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=65"
  },
  {
    ID: 358,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "توفير خدمات الأمانة والدعم الفني للهيئة الدولية لمراقبة المخدرات",
    Title: "الأداء الفعال للنظام الدولي لتقديرات وتقييمات التجارة المشروعة بالمخدرات والمؤثرات العقلية للأغراض الطبية والعلمية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=69"
  },
  {
    ID: 359,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "توفير خدمات الأمانة والدعم الفني للهيئة الدولية لمراقبة المخدرات",
    Title: "انخفاض الاتجار في المؤثرات النفسانية الجديدة والمؤثرات الأفيونية الاصطناعية غير الطبية الشديدة المفعول",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=70"
  },
  {
    ID: 360,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "توفير خدمات الأمانة والدعم الفني للهيئة الدولية لمراقبة المخدرات",
    Title: "تعزيز قدرة الدول الأعضاء على ضمان توافر المواد الخاضعة للمراقبة الدولية للأغراض الطبية والعلمية على النحو الكافي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=70"
  },
  {
    ID: 361,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "مكتب الأمم المتحدة المعني بالمخدرات والجريمة",
    Programme: "المراقبة الدولية للمخدرات، ومنع الجريمة والإرهاب، والعدالة الجنائية",
    Subprogramme: "توفير خدمات الأمانة والدعم الفني للهيئة الدولية لمراقبة المخدرات",
    Title: "انخفاض توافر السلائف الكيميائية، والمواد الكيميائية غير المدرجة في الجداول، لأغراض استخدامها في التصنيع غير المشروع للمخدرات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "مراقبة المخدرات ومنع الجريمة ومكافحة الجريمة المنظمة والإرهاب الدولي بجميع أشكاله ومظاهره",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز الرقابة على المخدرات والسلع المحظورة والاتجار بالأشخاص؛ وخفض التدفقات المالية غير المشروعة",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=ar#page=71"
  },
  {
    ID: 362,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "هيئة الأمم المتحدة للمساواة بين الجنسين وتمكين المرأة",
    Programme: "هيئة الأمم المتحدة للمرأة",
    Subprogramme: "الدعم الحكومي الدولي والتنسيق والشراكات الاستراتيجية",
    Title: "تحديد الإجراءات ذات الأولوية والمضي فيها للتعجيل في تنفيذ منهاج عمل بيجين",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ar#page=9"
  },
  {
    ID: 363,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "هيئة الأمم المتحدة للمساواة بين الجنسين وتمكين المرأة",
    Programme: "هيئة الأمم المتحدة للمرأة",
    Subprogramme: "الدعم الحكومي الدولي والتنسيق والشراكات الاستراتيجية",
    Title: "عُززت القواعد والمعايير العالمية المتعلقة بالمساواة بين الجنسين وتمكين جميع النساء والفتيات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ar#page=10"
  },
  {
    ID: 364,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "هيئة الأمم المتحدة للمساواة بين الجنسين وتمكين المرأة",
    Programme: "هيئة الأمم المتحدة للمرأة",
    Subprogramme: "الدعم الحكومي الدولي والتنسيق والشراكات الاستراتيجية",
    Title: "عُمم منظور جنساني في أطر الأمم المتحدة للتعاون من أجل التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: " ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ar#page=10"
  },
  {
    ID: 365,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "هيئة الأمم المتحدة للمساواة بين الجنسين وتمكين المرأة",
    Programme: "هيئة الأمم المتحدة للمرأة",
    Subprogramme: "الدعم الحكومي الدولي والتنسيق والشراكات الاستراتيجية",
    Title: "تم تحسين إدماج المنظور الجنساني من خلال خطة العمل على نطاق منظومة الأمم المتحدة بشأن المساواة بين الجنسين وتمكين المرأة 3,0",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ar#page=11"
  },
  {
    ID: 366,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "هيئة الأمم المتحدة للمساواة بين الجنسين وتمكين المرأة",
    Programme: "هيئة الأمم المتحدة للمرأة",
    Subprogramme: "الأنشطة المتعلقة بالسياسات والبرامج",
    Title: "تستخدم الدول الأعضاء بيانات استخدام الوقت ليُسترشَد بها في وضع السياسات المرتكزة على الأدلة للاعتراف بأعمال الرعاية غير المدفوعة الأجر والحد منها وإعادة توزيعها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ar#page=14"
  },
  {
    ID: 367,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "هيئة الأمم المتحدة للمساواة بين الجنسين وتمكين المرأة",
    Programme: "هيئة الأمم المتحدة للمرأة",
    Subprogramme: "الأنشطة المتعلقة بالسياسات والبرامج",
    Title: "الحكومات تُنفّذ سياسات ضريبية وتأخذ بميزنة مراعية للمنظور الجنساني من أجل تعزيز المساواة بين الجنسين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: " ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ar#page=15"
  },
  {
    ID: 368,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "هيئة الأمم المتحدة للمساواة بين الجنسين وتمكين المرأة",
    Programme: "هيئة الأمم المتحدة للمرأة",
    Subprogramme: "الأنشطة المتعلقة بالسياسات والبرامج",
    Title: "الحكومات تعتمد خطط عمل وطنية للقضاء على العنف ضد النساء والفتيات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: " ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ar#page=16"
  },
  {
    ID: 369,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "هيئة الأمم المتحدة للمساواة بين الجنسين وتمكين المرأة",
    Programme: "هيئة الأمم المتحدة للمرأة",
    Subprogramme: "الأنشطة المتعلقة بالسياسات والبرامج",
    Title: "تحرز الحكومات تقدماً في إصلاح القوانين التمييزية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=ar#page=16"
  },
  {
    ID: 370,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "سياسات الاقتصاد الكلي، والشؤون المالية، والحوكمة",
    Title: "تعزيز استراتيجيات إدارة الديون والتمويل المستدام في الدول الجزرية الصغيرة النامية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM",
    Image: "18ECA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=13"
  },
  {
    ID: 371,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "سياسات الاقتصاد الكلي، والشؤون المالية، والحوكمة",
    Title: "اتباع أعضاء اللجنة الاقتصادية لأفريقيا نُهجا مبتكرة لتعبئة الموارد المحلية ورأس المال الخاص الخارجي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BW,ET,GN,MR,UG,TZ",
    Image: "18ECA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=14"
  },
  {
    ID: 372,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "سياسات الاقتصاد الكلي، والشؤون المالية، والحوكمة",
    Title: "تعزيز توقعات الاقتصاد الكلي والتخطيط الإنمائي من أجل نمو مستدام وشامل للجميع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BW",
    Image: "18ECA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=15"
  },
  {
    ID: 373,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "سياسات الاقتصاد الكلي، والشؤون المالية، والحوكمة",
    Title: "تحسين الحوكمة الاقتصادية والمالية من أجل تعزيز التحول الهيكلي والتنمية الشاملة للجميع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,ET,GN,UG,ZM",
    Image: "18ECA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=15"
  },
  {
    ID: 374,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التكامل والتجارة على الصعيد الإقليمي",
    Title: "تحسين استعداد إثيوبيا للتجارة في إطار منطقة التجارة الحرة القارية الأفريقية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ET",
    Image: "18ECA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=19"
  },
  {
    ID: 375,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التكامل والتجارة على الصعيد الإقليمي",
    Title: "استراتيجيات التجارة المستدامة للتخفيف من أثر تغير المناخ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=20"
  },
  {
    ID: 376,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التكامل والتجارة على الصعيد الإقليمي",
    Title: "اعتماد أعضاء اللجنة الاقتصادية لأفريقيا تدابير للحد من المخاطر على الاستثمارات في سلاسل القيمة الإقليمية والمناطق الاقتصادية الخاصة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=20"
  },
  {
    ID: 377,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التكامل والتجارة على الصعيد الإقليمي",
    Title: "تحسين السياسات الوطنية والبيئة المؤسسية لمشاركة القطاع الخاص في التجارة بين البلدان الأفريقية من خلال منطقة التجارة الحرة القارية الأفريقية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=21"
  },
  {
    ID: 378,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التكنولوجيا والابتكار والربط وتطوير البنية التحتية",
    Title: "يمكن للدول الأعضاء استخدام أداة لمحاكاة السياسات الضريبية لدعم وضع السياسات المرتكز على الأدلة من أجل توفير الربط الميسور التكلفة، وتحقيق نمو اقتصادي شامل للجميع، وإيجاد فرص عمل في أفريقيا",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=25"
  },
  {
    ID: 379,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التكنولوجيا والابتكار والربط وتطوير البنية التحتية",
    Title: "زيادة استخدام أعضاء اللجنة الاقتصادية لأفريقيا للتكنولوجيات الجديدة، معززة بأطر تنظيمية قوية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=26"
  },
  {
    ID: 380,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التكنولوجيا والابتكار والربط وتطوير البنية التحتية",
    Title: "استفادة أعضاء اللجنة الاقتصادية لأفريقيا من التكنولوجيا والابتكار في إدارة بنيتهم التحتية للنقل والطاقة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,GH,KE,MG",
    Image: "18ECA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=27"
  },
  {
    ID: 381,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التكنولوجيا والابتكار والربط وتطوير البنية التحتية",
    Title: "تعزيز الاستراتيجيات والسياسات المتعلقة بتطوير البنية التحتية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SZ,GM",
    Image: "18ECA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=27"
  },
  {
    ID: 382,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "البيانات والإحصاءات",
    Title: "يقوم أعضاء اللجنة الاقتصادية لأفريقيا بإنتاج واستخدام إحصاءات اقتصادية محسّنة فيما يتعلق بسياسات التكامل الإقليمي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=31"
  },
  {
    ID: 383,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "البيانات والإحصاءات",
    Title: "التقدم المحرز صوب وضع أُطر متكاملة للمعلومات الإحصائية والجغرافية المكانية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ER,GH,NA",
    Image: "18ECA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=32"
  },
  {
    ID: 384,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "البيانات والإحصاءات",
    Title: "تحسين نظم التسجيل المدني وإحصاءات الأحوال المدنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,KE,NA,TZ",
    Image: "18ECA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=33"
  },
  {
    ID: 385,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "البيانات والإحصاءات",
    Title: "تعزيز النظم الإحصائية الوطنية بما يتيح الإنتاج المنتظم للمنتجات الإحصائية المبتكرة واستخدامها في صياغة السياسات من أجل وضع القرارات المرتكز على الأدلة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=33"
  },
  {
    ID: 386,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "تغير المناخ والأمن الغذائي والموارد الطبيعية",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا بتعزيز الأطر السياساتية والمؤسسية لسلاسل القيمة الزراعية القادرة على التكيف مع تغير المناخ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI,GH,ZM,ZW",
    Image: "18ECA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=39"
  },
  {
    ID: 387,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "تغير المناخ والأمن الغذائي والموارد الطبيعية",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا بوضع وتنفيذ أطر وطنية وإقليمية للسياسات والتعاون من أجل الاستخدام المستدام للموارد الطبيعية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=40"
  },
  {
    ID: 388,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "تغير المناخ والأمن الغذائي والموارد الطبيعية",
    Title: "منظومات الأغذية الزراعية القادرة على الصمود والشاملة للجميع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=40"
  },
  {
    ID: 389,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "تغير المناخ والأمن الغذائي والموارد الطبيعية",
    Title: "تعزيز الطموحات والإجراءات المتعلقة بالمناخ في أفريقيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=41"
  },
  {
    ID: 390,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التمكين السياسي والاقتصادي للمرأة والشباب",
    Title: "تعزيز جمع البيانات، والرصد والإبلاغ بشأن المساواة بين الجنسين وتمكين المرأة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,SS,II",
    Image: "18ECA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=46"
  },
  {
    ID: 391,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التمكين السياسي والاقتصادي للمرأة والشباب",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا بإدماج منظور جنساني في السياسات المالية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "ET,KE,RW,UG,TZ",
    Image: "18ECA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=47"
  },
  {
    ID: 392,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التمكين السياسي والاقتصادي للمرأة والشباب",
    Title: "اتخاذ أعضاء اللجنة الاقتصادية لأفريقيا إجراءات لتحسين الشمول المالي للمرأة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "GM,SL",
    Image: "18ECA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=47"
  },
  {
    ID: 393,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التمكين السياسي والاقتصادي للمرأة والشباب",
    Title: "استفادة أعضاء اللجنة الاقتصادية لأفريقيا من الرقمنة لتمكين رواد الأعمال الشباب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "مباشرة الأعمال الحرة وزيادة القدرة التنافسية للمشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ZA",
    Image: "18ECA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=48"
  },
  {
    ID: 394,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في شمال أفريقيا ",
    Title: "اتخاذ أعضاء اللجنة الاقتصادية لأفريقيا إجراءات لتعزيز التمويل المستدام",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,SL",
    Image: "18ECA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=51"
  },
  {
    ID: 395,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في شمال أفريقيا ",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا بتعبئة التمويل من أجل التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LY",
    Image: "18ECA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=52"
  },
  {
    ID: 396,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في شمال أفريقيا ",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا بتسريع وتيرة النمو المستدام والشامل للجميع من خلال زيادة الإنتاجية والتنويع وإضافة القيمة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "مباشرة الأعمال الحرة وزيادة القدرة التنافسية للمشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=52"
  },
  {
    ID: 397,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في شمال أفريقيا ",
    Title: "اتخاذ أعضاء اللجنة الاقتصادية لأفريقيا إجراءات لتعظيم أثر مشاركة الشتات باعتبارها مصادر بديلة لتمويل التنمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=53"
  },
  {
    ID: 398,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في غرب أفريقيا",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا في غرب أفريقيا بإدماج تحليل سلاسل القيمة الزراعية في أطر التخطيط",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=56"
  },
  {
    ID: 399,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في غرب أفريقيا",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا بتقييم القدرة على تحمل الديون ووضع استراتيجيات مالية أطول أجلا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SL",
    Image: "18ECA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=57"
  },
  {
    ID: 400,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في غرب أفريقيا",
    Title: "زيادة تفعيل الاستراتيجيات الوطنية لمنطقة التجارة الحرة القارية الأفريقية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CV,GH,LR",
    Image: "18ECA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=58"
  },
  {
    ID: 401,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في غرب أفريقيا",
    Title: "تعزيز نظم الميزنة والرصد الوطنية للاستفادة من العائد الديمغرافي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=58"
  },
  {
    ID: 402,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في وسط أفريقيا",
    Title: "قيام سان تومي وبرينسيبي بوضع أول حسابات السياحة الفرعية الخاصة بها وإقرارها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ST",
    Image: "18ECA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=61"
  },
  {
    ID: 403,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في وسط أفريقيا",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا بإنشاء مناطق اقتصادية خاصة من أجل تحقيق التنويع الاقتصادي المستدام والشامل للجميع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CM,CG,CD,GA",
    Image: "18ECA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=62"
  },
  {
    ID: 404,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في وسط أفريقيا",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا من وسط أفريقيا بتعزيز تقييم الأصول الطبيعية ورسملتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CG,ST",
    Image: "18ECA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=63"
  },
  {
    ID: 405,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في وسط أفريقيا",
    Title: "تعزيز نظم تيسير التجارة والقدرات المؤسسية من أجل تسريع التكامل الاقتصادي الإقليمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,CM,CF,TD,GQ,CD,GA,CG,RW,ST",
    Image: "18ECA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=63"
  },
  {
    ID: 406,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في شرق أفريقيا",
    Title: "إطلاق رؤية الصومال المئوية لعام 2060 وتصديقها على الاتفاق المؤسس لمنطقة التجارة الحرة القارية الأفريقية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "18ECA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=67"
  },
  {
    ID: 407,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في شرق أفريقيا",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا والمنظمات الإقليمية بوضع استراتيجيات لتشجيع الاستثمار",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=67"
  },
  {
    ID: 408,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في شرق أفريقيا",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا بتنفيذ أطر إقليمية بشأن السياحة والاقتصاد الأزرق",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=68"
  },
  {
    ID: 409,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في شرق أفريقيا",
    Title: "تعزيز الربط والبنية التحتية من أجل تكامل إقليمي أعمق",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=69"
  },
  {
    ID: 410,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في الجنوب الأفريقي ",
    Title: "تسريع التجارة والاستثمار البينيين داخل منطقة الجماعة الإنمائية للجنوب الأفريقي من خلال التكنولوجيا الرقمية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,CD,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,TZ,ZM,ZW",
    Image: "18ECA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=73"
  },
  {
    ID: 411,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في الجنوب الأفريقي ",
    Title: "تسريع وتيرة الانتقال نحو اقتصادات أكثر استدامة في الجنوب الأفريقي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=74"
  },
  {
    ID: 412,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في الجنوب الأفريقي ",
    Title: "التصنيع الشامل للجميع من خلال تطوير سلاسل القيمة في الجنوب الأفريقي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=74"
  },
  {
    ID: 413,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الأنشطة دون الإقليمية لأغراض التنمية: الأنشطة دون الإقليمية في الجنوب الأفريقي ",
    Title: "تسريع تنفيذ الاتفاق المؤسس لمنطقة التجارة الحرة القارية الأفريقية والاتفاقات التجارية الأخرى في الجنوب الأفريقي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=75"
  },
  {
    ID: 414,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التنمية الاقتصادية والتخطيط",
    Title: "تحول أعضاء اللجنة الاقتصادية لأفريقيا من النهج المجزأة إلى النهج المتكاملة في مجال الحماية الاجتماعية من خلال وضع استراتيجيات وطنية للحماية الاجتماعية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CM,SN,ZW",
    Image: "18ECA45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=78"
  },
  {
    ID: 415,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التنمية الاقتصادية والتخطيط",
    Title: "قيام أعضاء اللجنة الاقتصادية لأفريقيا بإنشاء قوة عاملة جاهزة للمستقبل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=79"
  },
  {
    ID: 416,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التنمية الاقتصادية والتخطيط",
    Title: "تعزيز التخطيط والتمويل الإنمائيين على المستوى المحلي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=80"
  },
  {
    ID: 417,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "التنمية الاقتصادية والتخطيط",
    Title: "تحسين نظم التدريب في مجال الإدارة العامة من أجل تعزيز تخطيط التنمية الوطنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DJ",
    Image: "18ECA48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=80"
  },
  {
    ID: 418,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الفقر وعدم المساواة والسياسة الاجتماعية",
    Title: "اتفاق أعضاء اللجنة الاقتصادية لأفريقيا على موقف مشترك لأفريقيا بشأن أولويات التنمية الاجتماعية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=83"
  },
  {
    ID: 419,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الفقر وعدم المساواة والسياسة الاجتماعية",
    Title: "تحسين نظم الحماية الاجتماعية للفئات الأكثر ضعفا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GH,NA,SN,TZ",
    Image: "18ECA50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=84"
  },
  {
    ID: 420,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الفقر وعدم المساواة والسياسة الاجتماعية",
    Title: "تعزيز الاستعراضات الوطنية والإقليمية للأطر المتعلقة بالسكان للنهوض بالتنمية المستدامة وعدم ترك أحد خلف الركب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=85"
  },
  {
    ID: 421,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "اللجنة الاقتصادية لأفريقيا",
    Programme: "التنمية الاقتصادية والاجتماعية في أفريقيا",
    Subprogramme: "الفقر وعدم المساواة والسياسة الاجتماعية",
    Title: "تعزيز سياسات العمالة المرتكزة على الأدلة للاستفادة من العائد الديمغرافي لأفريقيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تنمية أفريقيا",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "الدول الأعضاء في أفريقيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=ar#page=85"
  },
  {
    ID: 422,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "سياسات الاقتصاد الكلي والحد من الفقر وتمويل التنمية",
    Title: "أولويات بلدان آسيا والمحيط الهادئ الواردة في خطة تمويل التنمية على الصعيد العالمي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: "الإدارة العامة",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=17"
  },
  {
    ID: 423,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "سياسات الاقتصاد الكلي والحد من الفقر وتمويل التنمية",
    Title: "تحسين وضع السياسات المتعلقة بقضايا الاقتصاد الكلي وتمويل التنمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SD,QQ,BT,KH,MV,MN,PK,LK",
    Image: "19ESCAP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=18"
  },
  {
    ID: 424,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "سياسات الاقتصاد الكلي والحد من الفقر وتمويل التنمية",
    Title: "استحداث الدول الأعضاء مبادرات وإصلاحات سياساتية جديدة لتسريع تمويل التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SD,QQ,BT,KH,LK",
    Image: "19ESCAP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=18"
  },
  {
    ID: 425,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "سياسات الاقتصاد الكلي والحد من الفقر وتمويل التنمية",
    Title: "قيام الدول الأعضاء بتصميم أو تقييم أو تنفيذ سياسات الاقتصاد الكلي لتسريع التقدم نحو التنمية القادرة على التكيف مع المناخ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=19"
  },
  {
    ID: 426,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "التجارة والاستثمار والابتكار",
    Title: "الدول تعزز المفاوضات المتعلقة بالاتفاقات التجارية بإجراء تحليلات مخصصة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: "الإدارة العامة",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=23"
  },
  {
    ID: 427,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "التجارة والاستثمار والابتكار",
    Title: "عمليات تجارية أكثر استدامة وكفاءة من خلال زيادة التدابير الرقمية وتدابير تيسير التجارة المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=23"
  },
  {
    ID: 428,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "التجارة والاستثمار والابتكار",
    Title: "تعهّد هيئات ترويج الاستثمار بالالتزام بتعزيز المساواة بين الجنسين من خلال الاستثمار الأجنبي المباشر",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=24"
  },
  {
    ID: 429,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "التجارة والاستثمار والابتكار",
    Title: "تحسين سبل الحصول على فرص نقل التكنولوجيا والمعارف المتعلقة بالتكنولوجيات الناشئة والمبتكرة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=25"
  },
  {
    ID: 430,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "النقل",
    Title: "قيام الدول الأعضاء بشكل متزايد بدمج مبادئ النقل الشامل في ما تقوم به من عمليات التخطيط ووضع السياسات من أجل نظم نقل أكثر يُسراً وأشمل لفئات المجتمع في مدن آسيا والمحيط الهادئ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: " ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AZ,LA,MN,NP,FJ,KI,PG,SB,TL",
    Image: "19ESCAP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=29"
  },
  {
    ID: 431,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "النقل",
    Title: "زيادة الكفاءة والمرونة في شبكات الربط واللوجستيات في مجال النقل في آسيا والمحيط الهادئ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "مباشرة الأعمال الحرة وزيادة القدرة التنافسية للمشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=29"
  },
  {
    ID: 432,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "النقل",
    Title: "تسريع وتيرة الانتقال إلى وسائل النقل المنخفضة الانبعاثات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=30"
  },
  {
    ID: 433,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "النقل",
    Title: "تعزيز التعاون الإقليمي من أجل تنمية النقل على نحو مستدام وشامل وقادر على الصمود",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: " ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=31"
  },
  {
    ID: 434,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "البيئة والتنمية والحد من مخاطر الكوارث وإدارتها",
    Title: "التعجيل بتنفيذ الإجراءات المتعلقة بالمناخ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BT,PG",
    Image: "19ESCAP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=34"
  },
  {
    ID: 435,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "البيئة والتنمية والحد من مخاطر الكوارث وإدارتها",
    Title: "قيام الدول الأعضاء في آسيا والمحيط الهادئ بزيادة التعاون للنهوض بالنُّهُج التشاركية بشأن المسائل البيئية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=35"
  },
  {
    ID: 436,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "البيئة والتنمية والحد من مخاطر الكوارث وإدارتها",
    Title: "زيادة التعاون الإقليمي بشأن العمل المناخي المتعلق بالمحيطات، بما في ذلك من خلال النهج القائمة على النظم الإيكولوجية والحلول القائمة على الطبيعة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=36"
  },
  {
    ID: 437,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "البيئة والتنمية والحد من مخاطر الكوارث وإدارتها",
    Title: "توسيع نطاق التعاون الإقليمي والشراكات والمبادرات المتعلقة بالتنمية الحضرية المستدامة وتعزيزها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=36"
  },
  {
    ID: 438,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "تكنولوجيا المعلومات والاتصالات والتطبيقات الفضائية",
    Title: "تعزيز تنفيذ مبادرة نظم الإنذار المبكر للجميع",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=40"
  },
  {
    ID: 439,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "تكنولوجيا المعلومات والاتصالات والتطبيقات الفضائية",
    Title: "زيادة اعتماد الابتكارات المدفوعة رقميا لإتاحة التكيف مع تغير المناخ المفضي إلى التحول",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,LA",
    Image: "19ESCAP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=41"
  },
  {
    ID: 440,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "تكنولوجيا المعلومات والاتصالات والتطبيقات الفضائية",
    Title: "توسيع نطاق التطبيقات الجغرافية المكانية من قبل البلدان التي تواجه أوضاعاً خاصة لتحقيق خطة عام 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=41"
  },
  {
    ID: 441,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "تكنولوجيا المعلومات والاتصالات والتطبيقات الفضائية",
    Title: "تعزيز التعاون الإقليمي على الاستفادة من تطبيق التكنولوجيات الناشئة، ولا سيما الذكاء الاصطناعي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=42"
  },
  {
    ID: 442,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "التنمية الاجتماعية",
    Title: "تعزيز الحوار والمشاركة الإقليميين بشأن الهجرة الآمنة والمنظمة والنظامية في آسيا والمحيط الهادئ وإجراء استعراض مشترك لها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=46"
  },
  {
    ID: 443,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "التنمية الاجتماعية",
    Title: "قيام الدول الأعضاء بوضع تدابير سياسة عامة بشأن تقييم اقتصاد الرعاية والاستثمار فيه",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LA,TL",
    Image: "19ESCAP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=47"
  },
  {
    ID: 444,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "التنمية الاجتماعية",
    Title: "تعزيز القدرة الوطنية على وضع سياسات شاملة لشيخوخة السكان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=48"
  },
  {
    ID: 445,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "التنمية الاجتماعية",
    Title: "تحدد الدول الأعضاء مسارات وطنية لسياسات الحماية الاجتماعية التي تدمج القدرة على تحمل تغير المناخ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=48"
  },
  {
    ID: 446,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الإحصاءات",
    Title: "الاستفادة من البيانات للدفع بعجلة التقدم في مجال التسجيل المدني",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=52"
  },
  {
    ID: 447,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الإحصاءات",
    Title: "تحسين حوكمة البيانات من جانب مكاتب الإحصاء الوطنية في جميع أنحاء آسيا والمحيط الهادئ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=53"
  },
  {
    ID: 448,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الإحصاءات",
    Title: "إنشاء منصات وطنية لأهداف التنمية المستدامة لرصد التقدم المحرز نحو تحقيق خطة التنمية المستدامة لعام 2030 في آسيا والمحيط الهادئ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=53"
  },
  {
    ID: 449,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الإحصاءات",
    Title: "تعزيز النظم الإحصائية الوطنية من خلال نهج يشمل المجتمع بأسره",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: "الإدارة العامة",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=54"
  },
  {
    ID: 450,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في منطقة المحيط الهادئ",
    Title: "تعزيز قدرة حكومات دول المحيط الهادئ على إدماج التقييم الاقتصادي لسلع وخدمات النظم الإيكولوجية في السياسات والتخطيط",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=57"
  },
  {
    ID: 451,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في منطقة المحيط الهادئ",
    Title: "مسارات لتعميم خطة عمل أنتيغوا وبربودا للدول الجزرية الصغيرة النامية في الاستراتيجيات الإنمائية الوطنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=58"
  },
  {
    ID: 452,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في منطقة المحيط الهادئ",
    Title: "زيادة الفعالية في إعداد واستخدام المؤشرات الأساسية للإبلاغ على الصعد الوطني والإقليمي والعالمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=59"
  },
  {
    ID: 453,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في منطقة المحيط الهادئ",
    Title: "تعزيز صوت منطقة المحيط الهادئ للنهوض بمؤشر الأمم المتحدة للضعف المتعدد الأبعاد الأكثر ملاءمة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=59"
  },
  {
    ID: 454,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في شرق آسيا وشمال شرقها",
    Title: "تعزيز تبادل المعرفة للنهوض بتعزيز الإجراءات المحلية المتعلقة بالمناخ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=63"
  },
  {
    ID: 455,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في شرق آسيا وشمال شرقها",
    Title: "الإدارة الفعالة للنقل والمرور العابر بالسكك الحديدية عبر الحدود",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "مباشرة الأعمال الحرة وزيادة القدرة التنافسية للمشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,KR,RU,KU",
    Image: "19ESCAP34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=63"
  },
  {
    ID: 456,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في شرق آسيا وشمال شرقها",
    Title: "تعزيز التعاون عبر الحدود في التصدي للتصحر وتدهور الأراضي في شرق آسيا وشمال شرقها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=64"
  },
  {
    ID: 457,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في شرق آسيا وشمال شرقها",
    Title: "تعزيز التعاون بشأن المناطق البحرية المحمية في شمال شرق آسيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=65"
  },
  {
    ID: 458,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في شمال آسيا ووسطها",
    Title: "الدول الأعضاء في شمال آسيا ووسطها التي تضع توصيات لتعزيز التجارة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: "الإدارة العامة",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=68"
  },
  {
    ID: 459,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في شمال آسيا ووسطها",
    Title: "تعزيز أدوات التعاون لبرنامج الأمم المتحدة الخاص المعني باقتصادات وسط آسيا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "مباشرة الأعمال الحرة وزيادة القدرة التنافسية للمشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=69"
  },
  {
    ID: 460,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في شمال آسيا ووسطها",
    Title: "نهوض الدول الأعضاء بسياسات التحول الرقمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=70"
  },
  {
    ID: 461,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في شمال آسيا ووسطها",
    Title: "تعزيز التعاون دون الإقليمي في مجال تحديث شبكات الكهرباء ودمج الطاقة المتجددة في شمال آسيا ووسطها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=70"
  },
  {
    ID: 462,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في جنوب آسيا وجنوب غربها",
    Title: "تعزيز التعاون فيما بين أصحاب المصلحة المتعددين بشأن العلاقة بين المياه وتغير المناخ في جنوب آسيا",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=73"
  },
  {
    ID: 463,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في جنوب آسيا وجنوب غربها",
    Title: "تسريع وتيرة الانتقال إلى الطاقة المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=74"
  },
  {
    ID: 464,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في جنوب آسيا وجنوب غربها",
    Title: "سد الفجوة الرقمية حتى لا يتخلف أحد عن الركب في جنوب آسيا وجنوب غربها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=74"
  },
  {
    ID: 465,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في جنوب آسيا وجنوب غربها",
    Title: "تعزيز الربط التجاري عبر الحدود في جنوب آسيا وجنوب غربها، مع التركيز على رائدات الأعمال والمؤسسات الناشئة في المناطق الحدودية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=75"
  },
  {
    ID: 466,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في جنوب شرق آسيا",
    Title: "مشاركة متكاملة لأصحاب المصلحة المتعددين من أجل التنمية المستدامة في جنوب شرق آسيا",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: " ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=78"
  },
  {
    ID: 467,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في جنوب شرق آسيا",
    Title: "مواءمة سياسات وأنظمة الاستثمار من أجل تحقيق أهداف التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=78"
  },
  {
    ID: 468,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في جنوب شرق آسيا",
    Title: "استنهاض الشباب بهدف تحقيق أهداف التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=79"
  },
  {
    ID: 469,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الأنشطة دون الإقليمية من أجل التنمية: الأنشطة دون الإقليمية من أجل التنمية في جنوب شرق آسيا",
    Title: "تعزيز الحوار والتعاون الإقليميين بشأن التحول الرقمي من أجل التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الدول الأعضاء في آسيا والمحيط الهادئ",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "19ESCAP48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=80"
  },
  {
    ID: 470,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الطاقة",
    Title: "سياسات معززة تتعلق بالانتقال إلى الطاقة المستدامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KH,FJ,FM,TO,VN",
    Image: "19ESCAP49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=83"
  },
  {
    ID: 471,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الطاقة",
    Title: "اعتماد البلدان خطط عمل وطنية في مجال التبريد",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "VN",
    Image: "19ESCAP50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=84"
  },
  {
    ID: 472,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الطاقة",
    Title: "زيادة التعاون بين الدول الأعضاء في منطقة آسيا والمحيط الهادئ بشأن مشاريع الربط بين شبكات الكهرباء عبر الحدود",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=85"
  },
  {
    ID: 473,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لآسيا والمحيط الهادئ",
    Programme: "التنمية الاقتصادية والاجتماعية في آسيا والمحيط الهادئ",
    Subprogramme: "الطاقة",
    Title: "معالم جديدة متفق عليها بين الحكومات الدولية لتعزيز الربط بين شبكات الطاقة الكهربائية الإقليمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في آسيا والمحيط الهادئ",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=ar#page=85"
  },
  {
    ID: 474,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "البيئة",
    Title: "تطبق الدول الأعضاء نُهجاً استشرافية لوضع توصيات للسياسات البيئية من أجل سد الثغرات والتعامل مع المسائل الناشئة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=14"
  },
  {
    ID: 475,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "البيئة",
    Title: "قاعدة بيانات مُحدّثة عن الملوثات من أجل تمكين اتخاذ قرارات متجاوبة قائمة على الحقائق",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=15"
  },
  {
    ID: 476,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "البيئة",
    Title: "تعزيز قاعدة المعارف البيئية لعموم أوروبا من أجل رسم سياسات مستنيرة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=15"
  },
  {
    ID: 477,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "البيئة",
    Title: "تحسين الإبلاغ عن بيانات الانبعاثات الجوية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=16"
  },
  {
    ID: 478,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "النقل",
    Title: "إتاحة البرمجيات المفتوحة المصدر تنفيذ المرفق 11 من الاتفاقية المتعلقة بالنقل الدولي للبضائع بمقتضى دفاتر النقل الدولي البري",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=20"
  },
  {
    ID: 479,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "النقل",
    Title: "زيادة عدد حالات الانضمام إلى الاتفاقيات الأساسية المتعلقة بالسلامة على الطرق كخطوة أولية للمساهمة في تقليل عدد الوفيات والإصابات الناجمة عن حوادث المرور في جميع أنحاء العالم",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=21"
  },
  {
    ID: 480,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "النقل",
    Title: "الإطار التنظيمي المعزز لنظم النقل الداخلي المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=22"
  },
  {
    ID: 481,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "النقل",
    Title: "تسريع رقمنة الصكوك القانونية في مجال النقل الداخلي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=22"
  },
  {
    ID: 482,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الإحصاءات",
    Title: "اعتماد الدول الأعضاء لمعايير إحصائية عالمية معززة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=26"
  },
  {
    ID: 483,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الإحصاءات",
    Title: "قاعدة بيانات اللجنة الاقتصادية لأوروبا للإحصاءات من أجل تحسين البحث وصنع القرار",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=27"
  },
  {
    ID: 484,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الإحصاءات",
    Title: "تحسين إعداد التقارير لرصد تحقيق أهداف التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=28"
  },
  {
    ID: 485,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الإحصاءات",
    Title: "تعزيز توافر الإحصاءات المتعلقة بتغير المناخ وإمكانية الحصول عليها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=28"
  },
  {
    ID: 486,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "التعاون والتكامل الاقتصاديان",
    Title: "ميثاق اللجنة الاقتصادية لأوروبا الخاص بالابتكار المحدِث للتحول الذي اعتمدته الدول الأعضاء",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=31"
  },
  {
    ID: 487,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "التعاون والتكامل الاقتصاديان",
    Title: "تقييم المزيد من مشاريع البنية التحتية التي تنفذ من خلال الشراكات بين القطاعين العام والخاص على أنها متوافقة مع أهداف التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=32"
  },
  {
    ID: 488,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "التعاون والتكامل الاقتصاديان",
    Title: "تحسين سياسات ومبادرات الابتكار من أجل التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=32"
  },
  {
    ID: 489,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "التعاون والتكامل الاقتصاديان",
    Title: "إقامة شراكات بين القطاعين العام والخاص تتماشى مع المعايير والمبادئ التوجيهية للجنة الاقتصادية لأوروبا بشأن الشراكات بين القطاعين العام والخاص دعماً لأهداف التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=33"
  },
  {
    ID: 490,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الطاقة المستدامة",
    Title: "تعزيز التعاون عبر الحدود فيما يتعلق بالترابط في مجال الطاقة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=36"
  },
  {
    ID: 491,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الطاقة المستدامة",
    Title: "إدارة أكثر استدامة ومرونة للموارد الطبيعية استنادا إلى تصنيف الأمم المتحدة الإطاري للموارد",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=37"
  },
  {
    ID: 492,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الطاقة المستدامة",
    Title: "زيادة اعتماد وسائل النقل الكهربائية من أجل انتقال طاقي مستدام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=38"
  },
  {
    ID: 493,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الطاقة المستدامة",
    Title: "خفض انبعاثات غازات الدفيئة في الصناعات ذات الكثافة العالية للانبعاثات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=39"
  },
  {
    ID: 494,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "التجارة",
    Title: "تعزيز خطط العمل الجنسانية المعتمدة لبنية تحتية شاملة للجودة في مجال التجارة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=42"
  },
  {
    ID: 495,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "التجارة",
    Title: "تعزيز رقمنة التجارة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=42"
  },
  {
    ID: 496,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "التجارة",
    Title: "تحسين شفافية وإمكانية تتبع سلاسل القيمة في القطاعات الحيوية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=43"
  },
  {
    ID: 497,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "التجارة",
    Title: "تنقيح معايير الجودة الزراعية بهدف الحد من فاقد الأغذية والهدر الغذائي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=44"
  },
  {
    ID: 498,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الغابات والصناعة الحرجية",
    Title: "تعزيز دمج حلول الحراجة الحضرية المستدامة في التخطيط الوطني",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=47"
  },
  {
    ID: 499,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الغابات والصناعة الحرجية",
    Title: "التخطيط والعمل القائمان على الأدلة من أجل الإنتاج والاستهلاك المستدامين للمنتجات الحرجية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=48"
  },
  {
    ID: 500,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الغابات والصناعة الحرجية",
    Title: "تعزيز إمكانية الوصول إلى البيانات المتعلقة بالغابات والصناعة الحرجية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=48"
  },
  {
    ID: 501,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الغابات والصناعة الحرجية",
    Title: "التخطيط الاستشرافي من أجل صناعة حرجية مستدامة وقادرة على الصمود",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=49"
  },
  {
    ID: 502,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الإسكان وإدارة الأراضي والسكان",
    Title: "التزام الدول الأعضاء بتحسين كل من يسر تكلفة السكن واستدامته",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=53"
  },
  {
    ID: 503,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الإسكان وإدارة الأراضي والسكان",
    Title: "سياسات أكثر مراعاة للعمر وشمولا من أجل التعامل مع الفرص والتحديات المرتبطة بشيخوخة الأفراد والسكان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=53"
  },
  {
    ID: 504,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الإسكان وإدارة الأراضي والسكان",
    Title: "تسريع وتيرة تكييف الحكومات المحلية والإقليمية لأهداف التنمية المستدامة مع السياق المحلي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=54"
  },
  {
    ID: 505,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "اللجنة الاقتصادية لأوروبا",
    Programme: "التنمية الاقتصادية في أوروبا",
    Subprogramme: "الإسكان وإدارة الأراضي والسكان",
    Title: "إطار سياسة إقليمية استباقية بشأن الشيخوخة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=ar#page=54"
  },
  {
    ID: 506,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التجارة الدولية والتكامل والبنى التحتية",
    Title: "وضع جدول إقليمي للمدخلات والمخرجات للاسترشاد به في صنع السياسات القائم على الأدلة في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=17"
  },
  {
    ID: 507,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التجارة الدولية والتكامل والبنى التحتية",
    Title: "تحسين تنسيق السياسات المتعلقة بتجارة الأغذية المستدامة والقادرة على الصمود ونظم النقل والخدمات اللوجستية من أجل تحسين الأمن الغذائي الإقليمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=18"
  },
  {
    ID: 508,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التجارة الدولية والتكامل والبنى التحتية",
    Title: "وضع سياسات تحسّن التكامل المادي والبنية التحتية والنقل والخدمات اللوجستية بطريقة شاملة وميسّرة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=19"
  },
  {
    ID: 509,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التجارة الدولية والتكامل والبنى التحتية",
    Title: "تنويع الدول الأعضاء سلة صادراتها من خلال زيادة مبيعاتها الخارجية للخدمات المقدمة رقمياً",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=19"
  },
  {
    ID: 510,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الإنتاج والابتكار",
    Title: "تعزيز إدماج المنظور الجنساني في سياسات التنمية الإنتاجية الإقليمية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UY",
    Image: "21ECLAC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=23"
  },
  {
    ID: 511,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الإنتاج والابتكار",
    Title: "زيادة وتعزيز المبادرات المتعلقة بالتجمعات وغيرها من مبادرات الربط الإنتاجي الإقليمي ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=23"
  },
  {
    ID: 512,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الإنتاج والابتكار",
    Title: "تعزيز سياسات التنمية الإنتاجية لدفع عجلة نمو الإنتاجية في جميع القطاعات الرئيسية ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=24"
  },
  {
    ID: 513,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الإنتاج والابتكار",
    Title: "سياسات تنمية إنتاجية تعزز التطوير الإنتاجي والتنويع والتغيير الهيكلي من أجل تحقيق المساواة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=25"
  },
  {
    ID: 514,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "سياسات الاقتصاد الكلي والنمو",
    Title: "مضي كوستاريكا قدما في استحداث السندات ذات الأثر الاجتماعي من أجل تعزيز تعبئة الموارد المحلية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR",
    Image: "21ECLAC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=28"
  },
  {
    ID: 515,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "سياسات الاقتصاد الكلي والنمو",
    Title: "سياسات الاقتصاد الكلي وتمويل التنمية من أجل تحقيق النمو الاقتصادي والاستثمار والاستدامة المالية والقدرة على الصمود في وجه تغير المناخ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=28"
  },
  {
    ID: 516,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "سياسات الاقتصاد الكلي والنمو",
    Title: "تعزيز عملية تقرير سياسات النفقات الضريبية دعما لأهداف التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=29"
  },
  {
    ID: 517,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "سياسات الاقتصاد الكلي والنمو",
    Title: "توسيع نطاق تعبئة الموارد العامة المحلية بما يتماشى مع أهداف التزام إشبيلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=30"
  },
  {
    ID: 518,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التنمية الاجتماعية والمساواة",
    Title: "إنشاء باراغواي للسجل الاجتماعي للأسر المعيشية من أجل المساعدة في تعزيز نظامها للحماية الاجتماعية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PY",
    Image: "21ECLAC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=32"
  },
  {
    ID: 519,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التنمية الاجتماعية والمساواة",
    Title: "توسيع نظم الحماية الاجتماعية لتشمل العمال غير النظاميين والمستقلين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=33"
  },
  {
    ID: 520,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التنمية الاجتماعية والمساواة",
    Title: "تحسين السياسات المتعلقة بالإدماج في سوق العمل، بما يشمل آثار تغير المناخ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=34"
  },
  {
    ID: 521,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التنمية الاجتماعية والمساواة",
    Title: "تصميم أدوات سياسات مشتركة بين القطاعات من أجل الإدماج والتحول الرقميين بهدف الحد من عدم المساواة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=34"
  },
  {
    ID: 522,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "المساواة بين الجنسين واستقلالية المرأة",
    Title: "عقد من العمل لتحقيق المساواة الفعلية بين الجنسين ومجتمع الرعاية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=37"
  },
  {
    ID: 523,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "المساواة بين الجنسين واستقلالية المرأة",
    Title: "إحراز تقدم في إنتاج إحصاءات جنسانية بشأن استخدام الوقت وأعمال الرعاية غير المدفوعة الأجر",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=37"
  },
  {
    ID: 524,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "المساواة بين الجنسين واستقلالية المرأة",
    Title: "تعميم مراعاة المنظور الجنساني في السياسات الخارجية والتعاون الدولي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=38"
  },
  {
    ID: 525,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "المساواة بين الجنسين واستقلالية المرأة",
    Title: "قيام البلدان بحساب أثر الاستثمار في سياسات الرعاية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=38"
  },
  {
    ID: 526,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "السكان والتنمية",
    Title: "دولة بوليفيا المتعددة القوميات تنشر نتائج التعداد الذي أجرته للسكان والمساكن",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BO",
    Image: "21ECLAC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=42"
  },
  {
    ID: 527,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "السكان والتنمية",
    Title: "تعزيز التحليل الديمغرافي للسياسة العامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=42"
  },
  {
    ID: 528,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "السكان والتنمية",
    Title: "تنفيذ خطة عمل مدريد الدولية للشيخوخة على المستوى القطري",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=43"
  },
  {
    ID: 529,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "السكان والتنمية",
    Title: "تعد البلدان تقديراتها وتوقعاتها المستكملة بشأن السكان والقوة العاملة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=44"
  },
  {
    ID: 530,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التنمية المستدامة والمستوطنات البشرية",
    Title: "تعزيز نظم تقييم الأثر البيئي في أمريكا اللاتينية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=47"
  },
  {
    ID: 531,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التنمية المستدامة والمستوطنات البشرية",
    Title: "وضع استراتيجيات بشأن أنماط الاستهلاك والإنتاج المستدامة، بما في ذلك الاقتصاد الدائري، لتحقيق أداء بيئي أفضل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=47"
  },
  {
    ID: 532,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التنمية المستدامة والمستوطنات البشرية",
    Title: "تحسين عمليات المحاكاة للآثار المحتملة لتغير المناخ للاسترشاد بها في صياغة السياسات وخيارات الاستثمار",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=48"
  },
  {
    ID: 533,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التنمية المستدامة والمستوطنات البشرية",
    Title: "وضع أولويات وطنية استناداً إلى إطار مشترك لتنفيذ اتفاق إسكاسو",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=49"
  },
  {
    ID: 534,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الموارد الطبيعية",
    Title: "تعزيز الحوار السياسي والحوكمة الإقليمية في قطاع التعدين",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=51"
  },
  {
    ID: 535,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الموارد الطبيعية",
    Title: "توفير بلدان المنطقة للمعادن الحيوية اللازمة للانتقال الطاقي مع زيادة الاستدامة الاقتصادية والاجتماعية والبيئية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=52"
  },
  {
    ID: 536,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الموارد الطبيعية",
    Title: "إطلاق مبادرات جديدة لتعزيز الانتقال الطاقي في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=53"
  },
  {
    ID: 537,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الموارد الطبيعية",
    Title: "تعزيز الحوكمة والسياسات المحيطية لتعزيز الاستخدام والإدارة المستدامين للمحيطات في المنطقة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=53"
  },
  {
    ID: 538,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التخطيط والإدارة العامة لأغراض التنمية",
    Title: "اعتماد الخطة الإقليمية للحوكمة في مجال التخطيط والإدارة العامة من أجل التنمية المستدامة في أمريكا اللاتينية ومنطقة البحر الكاريبي لتوجيه التخطيط الاستراتيجي الطويل الأجل",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=56"
  },
  {
    ID: 539,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التخطيط والإدارة العامة لأغراض التنمية",
    Title: "وضع سياسات إنمائية متكاملة لبناء أقاليم أكثر قدرة على الصمود لتسريع وتيرة تنفيذ خطة عام 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=57"
  },
  {
    ID: 540,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التخطيط والإدارة العامة لأغراض التنمية",
    Title: "تحسين ما لدى المؤسسات العامة من قدرات تقنية وتشغيلية وسياسية وقدرات مرتقبة على إدارة التحولات ومواجهة التحديات المعقدة في البيئات المتغيرة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=57"
  },
  {
    ID: 541,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "التخطيط والإدارة العامة لأغراض التنمية",
    Title: "تضع الدول الأعضاء خططًا إنمائية وطنية ودون وطنية طويلة الأجل تدمج المجالات الاستراتيجية الأربعة للخطة الإقليمية للحوكمة في مجال التخطيط والإدارة العامة من أجل التنمية المستدامة في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=58"
  },
  {
    ID: 542,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الإحصاءات",
    Title: "تحسين دقة البيانات للاسترشاد بها في صياغة السياسات المتعلقة بالفقر، وانعدام المساواة، والعمالة، والتعليم، وظروف المعيشة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=61"
  },
  {
    ID: 543,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الإحصاءات",
    Title: "زيادة تنفيذ الإطار المتكامل للمعلومات الجغرافية المكانية على الصعيد الوطني",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=62"
  },
  {
    ID: 544,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الإحصاءات",
    Title: "تعزيز استخدام السجلات الإدارية لأغراض إنتاج الإحصاءات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=63"
  },
  {
    ID: 545,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الإحصاءات",
    Title: "تحديث النظم الإحصائية الوطنية لقياس النشاط الاقتصادي في بلدان أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=63"
  },
  {
    ID: 546,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: " الأنشطة دون الإقليمية في أمريكا الوسطى والجمهورية الدومينيكية وكوبا والمكسيك وهايتي",
    Title: "البلدان تعزز التنمية الإنتاجية القائمة على سلاسل القيمة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=65"
  },
  {
    ID: 547,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: " الأنشطة دون الإقليمية في أمريكا الوسطى والجمهورية الدومينيكية وكوبا والمكسيك وهايتي",
    Title: "تسريع وتيرة تنفيذ أهداف التنمية المستدامة بمعالجة الفجوات الهيكلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=66"
  },
  {
    ID: 548,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: " الأنشطة دون الإقليمية في أمريكا الوسطى والجمهورية الدومينيكية وكوبا والمكسيك وهايتي",
    Title: "تحسين الحوكمة الاستباقية لإثراء عملية صنع السياسات في المنطقة دون الإقليمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=67"
  },
  {
    ID: 549,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: " الأنشطة دون الإقليمية في أمريكا الوسطى والجمهورية الدومينيكية وكوبا والمكسيك وهايتي",
    Title: "تحسين الاستراتيجيات العامة الرامية إلى تعزيز التنمية الإنتاجية في مناطق وقطاعات محددة على المستوى دون الوطني",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=68"
  },
  {
    ID: 550,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الأنشطة دون الإقليمية في منطقة البحر الكاريبي",
    Title: "وضع نهج متكامل لإدارة الموارد الطبيعية من أجل إدارة طحالب السرغاسوم في منطقة البحر الكاريبي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=70"
  },
  {
    ID: 551,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الأنشطة دون الإقليمية في منطقة البحر الكاريبي",
    Title: "الشمول الرقمي في منطقة البحر الكاريبي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=71"
  },
  {
    ID: 552,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الأنشطة دون الإقليمية في منطقة البحر الكاريبي",
    Title: "إدماج خطة عمل أنتيغوا وبربودا للدول الجزرية الصغيرة النامية في العمليات والخطط الإنمائية الوطنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=72"
  },
  {
    ID: 553,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: "الأنشطة دون الإقليمية في منطقة البحر الكاريبي",
    Title: "التنويع الاقتصادي من خلال تعزيز التعاون فيما بين بلدان الجنوب مع اقتصادات أمريكا اللاتينية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=72"
  },
  {
    ID: 554,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: " دعم العمليات والمنظمات الهادفة إلى تحقيق التكامل والتعاون على الصعيدين الإقليمي ودون الإقليمي",
    Title: "توافق آراء إقليمي بشأن قياس التنمية المستدامة بما يتجاوز الناتج المحلي الإجمالي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=75"
  },
  {
    ID: 555,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: " دعم العمليات والمنظمات الهادفة إلى تحقيق التكامل والتعاون على الصعيدين الإقليمي ودون الإقليمي",
    Title: "وجود مبادرات معززة للجهات المتعددة صاحبة المصلحة في مجالَي التعاون فيما بين بلدان الجنوب والتعاون الثلاثي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=76"
  },
  {
    ID: 556,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: " دعم العمليات والمنظمات الهادفة إلى تحقيق التكامل والتعاون على الصعيدين الإقليمي ودون الإقليمي",
    Title: "تعاوُن بلدان أمريكا اللاتينية ومنطقة البحر الكاريبي مع الجهات الفاعلة من خارج المنطقة في إطار التعاون فيما بين بلدان الجنوب والتعاون الثلاثي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=77"
  },
  {
    ID: 557,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "اللجنة الاقتصادية لأمريكا اللاتينية ومنطقة البحر الكاريبي",
    Programme: "التنمية الاقتصادية والاجتماعية في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    Subprogramme: " دعم العمليات والمنظمات الهادفة إلى تحقيق التكامل والتعاون على الصعيدين الإقليمي ودون الإقليمي",
    Title: "تعزيز التعاون بين بلدان الجنوب والتعاون الثلاثي والتكامل الإقليمي بما يتمشى مع التزام إشبيلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=ar#page=78"
  },
  {
    ID: 558,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "تغيّر المناخ واستدامة الموارد الطبيعية",
    Title: "تحوُّل أقل البلدان العربية نموا إلى طاقة ميسورة التكلفة وموثوقة ومستدامة وحديثة مدعومة بنشر أدوات لتخفيف المخاطر في نماذج الأعمال التجارية والنماذج المالية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=12"
  },
  {
    ID: 559,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "تغيّر المناخ واستدامة الموارد الطبيعية",
    Title: "التحوُّل إلى نظم غذائية مستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز الأطر التنظيمية والإدارة البيئية؛ وزيادة الإجراءات المتعلقة بالمناخ من أجل التنمية المستدامة",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "22ESCWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=12"
  },
  {
    ID: 560,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "تغيّر المناخ واستدامة الموارد الطبيعية",
    Title: "تحديد الدول الأعضاء لإجراءات مشتركة ذات أولوية في مجال مكافحة العواصف الرملية والترابية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=13"
  },
  {
    ID: 561,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "تغيّر المناخ واستدامة الموارد الطبيعية",
    Title: "تحسُّن قدرة أحواض المياه السطحية والجوفية في المنطقة العربية على الصمود",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المناخ والبيئة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=13"
  },
  {
    ID: 562,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "العدل بين الجنسين، والسكان، والتنمية الشاملة",
    Title: "ربط الشباب في المنطقة العربية بفرص العمل",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=17"
  },
  {
    ID: 563,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "العدل بين الجنسين، والسكان، والتنمية الشاملة",
    Title: "اعتماد الدول الأعضاء لنهج متعدد الأبعاد إزاء الحد من الفقر",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "زيادة القدرة على الإبلاغ عن التقدم المحرز نحو تحقيق أهداف التنمية المستدامة؛ وزيادة عدد الاستعراضات الوطنية الطوعية وتحسين نوعيتها",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=17"
  },
  {
    ID: 564,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "العدل بين الجنسين، والسكان، والتنمية الشاملة",
    Title: "استفادة الدول الأعضاء من تعلُّم الآلة في التنبؤ باحتياجات برامج المساعدة الاجتماعية من موارد الميزانية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=18"
  },
  {
    ID: 565,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "العدل بين الجنسين، والسكان، والتنمية الشاملة",
    Title: "تحديد الدول الأعضاء إجراءات ذات أولوية هدفها تمكين الأشخاص ذوي الإعاقة اقتصاديا وشروعها في تنفيذ هذه الإجراءات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحقيق تنمية أكثر شمولا للجميع لكي لا يتخلف أحد عن الركب؛ والقضاء على الفقر والحد من أوجه عدم المساواة؛ والحد من التمييز ضد النساء والفتيات وتعزيز المساواة بين الجنسين",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=19"
  },
  {
    ID: 566,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الازدهار الاقتصادي المشترك",
    Title: "وضع كل من الأردن وتونس سياسات اقتصاد كلية ومالية عامة تهدف إلى تعزيز تمويل القطاع الاجتماعي والاستدامة المالية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=22"
  },
  {
    ID: 567,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الازدهار الاقتصادي المشترك",
    Title: "تعزيز القدرة على تحمُّل الدين من أجل زيادة الاستثمار في أولويات التنمية المستدامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين المعلومات المتعلقة بالسكان والهجرة والتسجيلات المدنية والخصائص الديمغرافية، بما في ذلك الإحصاءات المصنفة حسب نوع الجنس",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=23"
  },
  {
    ID: 568,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الازدهار الاقتصادي المشترك",
    Title: "توصُّل الدول الأعضاء إلى اتفاقات تجارية ثنائية خارج نطاق المنطقة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "القطاع الخاص، بما في ذلك المشاريع المتناهية الصغر والصغيرة والمتوسطة الحجم",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=23"
  },
  {
    ID: 569,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الازدهار الاقتصادي المشترك",
    Title: "إجراء الدول العربية تقييمات للأثر على الاقتصاد الكلي من أجل التنويع الاقتصادي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=24"
  },
  {
    ID: 570,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الإحصاءات، ومجتمع المعلومات، والتكنولوجيا",
    Title: "تعزيز الحسابات القومية في المنطقة العربية للاستفادة منها في صنع السياسات القائم على الأدلة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=27"
  },
  {
    ID: 571,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الإحصاءات، ومجتمع المعلومات، والتكنولوجيا",
    Title: "تعزيز عملية صنع القرار والتخطيط الإنمائي في المنطقة العربية بالأدلة الإحصائية الجغرافية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=28"
  },
  {
    ID: 572,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الإحصاءات، ومجتمع المعلومات، والتكنولوجيا",
    Title: "إنتاج الدول العربية الأعضاء، بما فيها أقل البلدان نموا، لإحصاءات في مجال التجارة الخارجية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تحسين القياس والإحصاءات فيما يخص السياسات القائمة على الأدلة من أجل التنمية المستدامة",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=28"
  },
  {
    ID: 573,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الإحصاءات، ومجتمع المعلومات، والتكنولوجيا",
    Title: "استخدام صانعي السياسات لمنصة البيانات الإقليمية المتكاملة في صنع السياسات القائم على الأدلة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=29"
  },
  {
    ID: 574,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "تنسيق العمل بشأن خطة عام 2030 وأهداف التنمية المستدامة",
    Title: "اتفاق الدول الأعضاء على موقف مشترك للتفاوض بشأن الإعلان السياسي لمؤتمر القمة العالمي الثاني للتنمية الاجتماعية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=33"
  },
  {
    ID: 575,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "تنسيق العمل بشأن خطة عام 2030 وأهداف التنمية المستدامة",
    Title: "زيادة استثمارات القطاع الخاص في أولويات التنمية المستدامة الإقليمية والوطنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز فهم احتياجات التمويل، وتحسين خيارات السياسة العامة لتمويل استثمارات رؤوس الأموال المستدامة، وزيادة الالتزام والمشاركة في تمويل المشاريع المستدامة",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=34"
  },
  {
    ID: 576,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "تنسيق العمل بشأن خطة عام 2030 وأهداف التنمية المستدامة",
    Title: "قيام الدول الأعضاء بتحديد ومعالجة الثغرات التي تعتري سياساتها المتعلقة بتنفيذ خطة عام 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=34"
  },
  {
    ID: 577,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "تنسيق العمل بشأن خطة عام 2030 وأهداف التنمية المستدامة",
    Title: "إيجاد رؤية إقليمية لتحديد مسارات التنمية الإقليمية في الأجلين المتوسط والطويل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=35"
  },
  {
    ID: 578,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الحوكمة ومنع نشوب النزاعات",
    Title: "اتِّباع عمان لنهج التخطيط الإنمائي المحلي القائم على الأدلة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "OM",
    Image: "22ESCWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=38"
  },
  {
    ID: 579,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الحوكمة ومنع نشوب النزاعات",
    Title: "تحديث نظم الإدارة العامة من أجل كفالة فعالية الحوكمة العامة وشفافيتها وتحقيق التنمية الاجتماعية الاقتصادية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز المؤسسات وسيادة القانون ومنع نشوب النزاعات",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=38"
  },
  {
    ID: 580,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الحوكمة ومنع نشوب النزاعات",
    Title: "قيام الدول الأعضاء بوضع وتعميم سياسات إنمائية قادرة على مواجهة الهشاشة والصدمات المفاجئة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=39"
  },
  {
    ID: 581,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "اللجنة الاقتصادية والاجتماعية لغربي آسيا",
    Programme: "التنمية الاقتصادية والاجتماعية في غربي آسيا",
    Subprogramme: "الحوكمة ومنع نشوب النزاعات",
    Title: "تعزيز حوكمة المنافسة من أجل كفالة شفافية الأسواق وشمول الجميع فيها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: "الدول الأعضاء في أوروبا ووسط آسيا وغرب آسيا",
    SpecificResult: "تعزيز القدرات وتذليل العقبات، بما في ذلك عن طريق التجارة الإلكترونية والاقتصاد الرقمي، من أجل تحسين التجارة والقدرة التنافسية",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=ar#page=40"
  },
  {
    ID: 582,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: تعميم مراعاة حقوق الإنسان",
    Title: "إدماج قواعد ومعايير حقوق الإنسان في التحليلات القطرية المشتركة وأطر الأمم المتحدة للتعاون من أجل التنمية المستدامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=16"
  },
  {
    ID: 583,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: تعميم مراعاة حقوق الإنسان",
    Title: "إدماج المعايير الدولية لحقوق الإنسان المتعلقة بالحقوق الاقتصادية والاجتماعية والثقافية في وضع ميزانيات الدول",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=17"
  },
  {
    ID: 584,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: تعميم مراعاة حقوق الإنسان",
    Title: "زيادة تعزيز وحماية حقوق الإنسان في السياسات والممارسات الوطنية من خلال القطب المعرفي في مجال الحقوق الاقتصادية والاجتماعية والثقافية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=18"
  },
  {
    ID: 585,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: تعميم مراعاة حقوق الإنسان",
    Title: "اعتماد الدول الأعضاء قوانين لمكافحة الإرهاب وتنفيذها لتدابير تكون منسجمة مع الحقوق المكرسة في الإعلان العالمي لحقوق الإنسان ومع التزاماتها بموجب القانون الدولي لحقوق الإنسان وتكفل تطبيقها بطريقة تراعي تلك الحقوق مراعاةً كاملةً",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=18"
  },
  {
    ID: 586,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: الحق في التنمية",
    Title: "الدول الأعضاء وغيرها من الجهات صاحبة المصلحة مستعدة لتفعيل الحق في التنمية في إطار السعي إلى تحقيق أهداف التنمية المستدامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=21"
  },
  {
    ID: 587,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: الحق في التنمية",
    Title: "سياسات وممارسات مكافحة الفساد الرامية إلى معالجة الأثر السلبي للفساد على التمتع بحقوق الإنسان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=22"
  },
  {
    ID: 588,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: الحق في التنمية",
    Title: "تقوية تعزيز الحق في التنمية وحمايته",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=22"
  },
  {
    ID: 589,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: الحق في التنمية",
    Title: "النهوض بتعزيز الحق في التنمية على الصعيدين الإقليمي والوطني",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "أقل البلدان نموا، والبلدان النامية غير الساحلية، والدول الجزرية الصغيرة النامية، والبلدان النامية الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=23"
  },
  {
    ID: 590,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: البحوث والابتكارات",
    Title: "قيام الدول الأعضاء بتعزيز القوانين والسياسات والممارسات المتصلة بالمخدرات والتي تكون ممتثِلة لأحكام القانون الدولي لحقوق الإنسان",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CO,PK",
    Image: "24UHCHR9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=26"
  },
  {
    ID: 591,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: البحوث والابتكارات",
    Title: "تعميق المدافعين الشباب عن حقوق الإنسان من مجتمعات السكان الأصليين والأقليات والسكان المنحدرين من أصل أفريقي فهمهم لحقوق الإنسان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=27"
  },
  {
    ID: 592,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: البحوث والابتكارات",
    Title: "تحسين فهم الدول الأعضاء وأصحاب المصلحة الآخرين لآثار التكنولوجيات الرقمية على حقوق الإنسان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=27"
  },
  {
    ID: 593,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "تعميم مراعاة حقوق الإنسان، والحق في التنمية، والبحث والتحليل: البحوث والابتكارات",
    Title: "قيام الدول الأعضاء باعتماد وتنفيذ سياسات وإجراءات لمكافحة العنصرية قائمة على الأدلة، تُعزز المساواة وعدم التمييز والتسامح والتمتع بجميع حقوق الإنسان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=28"
  },
  {
    ID: 594,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "دعم هيئات معاهدات حقوق الإنسان",
    Title: "تزايد اعتماد الهيئات المنشأة بموجب معاهدات لقوائم المسائل وقوائم القضايا المحالة قبل تقديم التقارير",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=31"
  },
  {
    ID: 595,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "دعم هيئات معاهدات حقوق الإنسان",
    Title: "زيادة التعاون الدولي لدعم الآليات الوطنية للتنفيذ والإبلاغ والمتابعة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=31"
  },
  {
    ID: 596,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "دعم هيئات معاهدات حقوق الإنسان",
    Title: "تحسين وصول الدول الأطراف والجهات صاحبة المصلحة إلى توصيات الهيئات المنشأة بموجب معاهدات لتيسير تنفيذها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=32"
  },
  {
    ID: 597,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "دعم هيئات معاهدات حقوق الإنسان",
    Title: "وجود مركز جامع للاطلاع على المعلومات المتعلقة بأعمال الهيئات المنشأة بموجب معاهدات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=33"
  },
  {
    ID: 598,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "الخدمات الاستشارية والتعاون التقني والأنشطة الميدانية",
    Title: "تسهم التحقيقات التي يصدر مجلس حقوق الإنسان تكليفاً بإجرائها في عمليات المساءلة وذلك بتقديم تحليلات شاملة ومستقلة وقائمة على الأدلة لانتهاكات حقوق الإنسان وتجاوزات القانون الدولي الإنساني والقانون الدولي لحقوق الإنسان",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=37"
  },
  {
    ID: 599,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "الخدمات الاستشارية والتعاون التقني والأنشطة الميدانية",
    Title: "تعزيز فعالية المؤسسات الوطنية لحقوق الإنسان تمشيا مع مبادئ باريس",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=38"
  },
  {
    ID: 600,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "الخدمات الاستشارية والتعاون التقني والأنشطة الميدانية",
    Title: "زيادة التعاون التقني لدعم الدول الأعضاء في الجماعة الكاريبية في جهودها الرامية إلى تعزيز حقوق الإنسان وحمايتها وإعمالها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "الدول الأعضاء في أمريكا اللاتينية ومنطقة البحر الكاريبي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,DM,GD,GY,HT,JM,MS,LC,KN,VC,SR,TT,AI,BM,VG,KY,TC",
    Image: "24UHCHR19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=39"
  },
  {
    ID: 601,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "الخدمات الاستشارية والتعاون التقني والأنشطة الميدانية",
    Title: "تتخذ الدول الأعضاء وغيرها من الجهات صاحبة المصلحة الإجراءات اللازمة لمعالجة حالات حقوق الإنسان على الصعيدين القطري والإقليمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=40"
  },
  {
    ID: 602,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "دعم مجلس حقوق الإنسان وهيئاته الفرعية وآلياته",
    Title: "تعزيز تأثير الإجراءات الخاصة لمجلس حقوق الإنسان على الصعيد العالمي والإقليمي والوطني",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=43"
  },
  {
    ID: 603,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "دعم مجلس حقوق الإنسان وهيئاته الفرعية وآلياته",
    Title: "تعزيز مساهمة المؤسسات الوطنية لحقوق الإنسان في آلية الاستعراض الدوري الشامل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=44"
  },
  {
    ID: 604,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "دعم مجلس حقوق الإنسان وهيئاته الفرعية وآلياته",
    Title: "تعزيز مشاركة أفرقة الأمم المتحدة القطرية في الاستعراض الدوري الشامل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "أوجه التقدم المحرز في حماية حقوق الإنسان والتمتع بها، والحد من أوجه عدم المساواة والتمييز؛ ومواصلة إدماج الحق في التنمية",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=45"
  },
  {
    ID: 605,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "دعم مجلس حقوق الإنسان وهيئاته الفرعية وآلياته",
    Title: "تحسين إمكانية وصول الأشخاص ذوي الإعاقة إلى عمل مجلس حقوق الإنسان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=46"
  },
  {
    ID: 606,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "مكتب المداف عن حقوق الضحايا",
    Title: "تعزيز تنفيت استراتيجية الأمين العام عل نطاق المن ومة التي تهدف إل وضب حقوق الضبحايا وكرامتهم في صميم الوقاية من الاستغلال والانتهاك الجنسيين والتصدي لهما",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=116"
  },
  {
    ID: 607,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لحقوق الإنسان",
    Programme: "حقوق الإنسان",
    Subprogramme: "مكتب المداف عن حقوق الضحايا",
    Title: "تعزيز الدعم المقدم للضببحايا من ملال الاسببتفادة من الخبرات والمعارف المتنوعة لموظفي حقوق الضحايا في سياقات حفظ السلام والعمل الإنساني والتنمية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تعزيز حقوق الإنسان",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ET,HT,ML,UA",
    Image: "24UHCHR26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=ar#page=116"
  },
  {
    ID: 608,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لشؤون اللاجئين",
    Programme: "توفير الحماية الدولية والحلول الدائمة والمساعدة للاجئين",
    Subprogramme: "توفير الحماية الدولية والحلول الدائمة والمساعدة للاجئين",
    Title: "المنتدى العالمي للاجئين يتعهد بتعزيز تقاسم المسؤوليات ودعم اللاجئين والمجتمعات المضيفة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=ar#page=6"
  },
  {
    ID: 609,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لشؤون اللاجئين",
    Programme: "توفير الحماية الدولية والحلول الدائمة والمساعدة للاجئين",
    Subprogramme: "توفير الحماية الدولية والحلول الدائمة والمساعدة للاجئين",
    Title: "زيادة معدل وجود الجهات الشريكة الوطنية والمحلية في خطط الاستجابة للاجئين على الصعيد العالمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=ar#page=7"
  },
  {
    ID: 610,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لشؤون اللاجئين",
    Programme: "توفير الحماية الدولية والحلول الدائمة والمساعدة للاجئين",
    Subprogramme: "توفير الحماية الدولية والحلول الدائمة والمساعدة للاجئين",
    Title: "تعزيز حماية اللاجئين وطالبي اللجوء وإمكانية حصولهم على الخدمات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=ar#page=8"
  },
  {
    ID: 611,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "مفوضية الأمم المتحدة السامية لشؤون اللاجئين",
    Programme: "توفير الحماية الدولية والحلول الدائمة والمساعدة للاجئين",
    Subprogramme: "توفير الحماية الدولية والحلول الدائمة والمساعدة للاجئين",
    Title: "زيادة الالتزام بالاتفاقيات الدولية المتعلقة بحالة انعدام الجنسية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=ar#page=8"
  },
  {
    ID: 612,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حماية اللاجئين الفلسطينيين من خلال إعمال حقوقهم المنصوص عليها في القانون الدولي",
    Title: "زيادة فرص حصول اللاجئين الفلسطينيين ذوي الإعاقة على دعم إعادة التأهيل",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=8"
  },
  {
    ID: 613,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حماية اللاجئين الفلسطينيين من خلال إعمال حقوقهم المنصوص عليها في القانون الدولي",
    Title: "تعزيز سلامة وكرامة اللاجئين الفلسطينيين المستفيدين من خدمات الوكالة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=9"
  },
  {
    ID: 614,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حماية اللاجئين الفلسطينيين من خلال إعمال حقوقهم المنصوص عليها في القانون الدولي",
    Title: "تعزيز حماية اللاجئين الفلسطينيين من العنف الجنساني",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=9"
  },
  {
    ID: 615,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حماية اللاجئين الفلسطينيين من خلال إعمال حقوقهم المنصوص عليها في القانون الدولي",
    Title: "تحسين فعالية تدخلات العمل الاجتماعي لفائدة اللاجئين الفلسطينيين الضعفاء",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=10"
  },
  {
    ID: 616,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "يتمتع اللاجئون الفلسطينيون بإمكانية الحصول الشامل على رعاية صحية أولية جيدة النوعية، وإمكانية الحصول الموجه على الرعاية من المستوى الثانوي والثالث، بما يفضي إلى تحسين النتائج الصحية",
    Title: "تحسين السيطرة على الأمراض غير السارية لدى اللاجئين الفلسطينيين",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=12"
  },
  {
    ID: 617,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "يتمتع اللاجئون الفلسطينيون بإمكانية الحصول الشامل على رعاية صحية أولية جيدة النوعية، وإمكانية الحصول الموجه على الرعاية من المستوى الثانوي والثالث، بما يفضي إلى تحسين النتائج الصحية",
    Title: "تحسُّن سبل حصول اللاجئين الفلسطينيين على خدمات الرعاية قبل الحمل وخدمات التخطيط للإنجاب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=13"
  },
  {
    ID: 618,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "يتمتع اللاجئون الفلسطينيون بإمكانية الحصول الشامل على رعاية صحية أولية جيدة النوعية، وإمكانية الحصول الموجه على الرعاية من المستوى الثانوي والثالث، بما يفضي إلى تحسين النتائج الصحية",
    Title: "السيطرة على حالات الأمراض المعدية في مجتمعات اللاجئين الفلسطينيين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=14"
  },
  {
    ID: 619,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "يتمتع اللاجئون الفلسطينيون بإمكانية الحصول الشامل على رعاية صحية أولية جيدة النوعية، وإمكانية الحصول الموجه على الرعاية من المستوى الثانوي والثالث، بما يفضي إلى تحسين النتائج الصحية",
    Title: "استدامة حصول اللاجئين الفلسطينيين الذين جرى تحديد احتياجاتهم على خدمات الصحة النفسية والدعم النفسي الاجتماعي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=14"
  },
  {
    ID: 620,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حصول اللاجئين الفلسطينيين على تعليم جيد النوعية شامل ومنصف",
    Title: "استمرار مشاركة أطفال اللاجئين الفلسطينيين في التعليم الابتدائي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=16"
  },
  {
    ID: 621,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حصول اللاجئين الفلسطينيين على تعليم جيد النوعية شامل ومنصف",
    Title: "تعزيز سلامة البيئة التعليمية في مدارس الوكالة وشمولها لجميع الطلاب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=17"
  },
  {
    ID: 622,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حصول اللاجئين الفلسطينيين على تعليم جيد النوعية شامل ومنصف",
    Title: "حماية النمو الاجتماعي والعاطفي للاجئين الفلسطينيين الأطفال",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=18"
  },
  {
    ID: 623,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حصول اللاجئين الفلسطينيين على تعليم جيد النوعية شامل ومنصف",
    Title: "توسيع نطاق توفير التعلم المختلط والمكيف في جميع مناطق عمل الأونروا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=19"
  },
  {
    ID: 624,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "تمتّع اللاجئين الفلسطينيين بفرص مستدامة ومعززة، حيثما أمكن ذلك، للحصول على عمل لائق وتوليد الدخل، من خلال تنمية المهارات ودعم المشاريع وتيسير الوصول المنصف إلى أسواق العمل",
    Title: "توسيع فرص العمل من خلال أعمال البنية التحتية وتحسين المخيمات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=21"
  },
  {
    ID: 625,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "تمتّع اللاجئين الفلسطينيين بفرص مستدامة ومعززة، حيثما أمكن ذلك، للحصول على عمل لائق وتوليد الدخل، من خلال تنمية المهارات ودعم المشاريع وتيسير الوصول المنصف إلى أسواق العمل",
    Title: "توفير فرص عمل في القطاع الخاص",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=22"
  },
  {
    ID: 626,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "تمتّع اللاجئين الفلسطينيين بفرص مستدامة ومعززة، حيثما أمكن ذلك، للحصول على عمل لائق وتوليد الدخل، من خلال تنمية المهارات ودعم المشاريع وتيسير الوصول المنصف إلى أسواق العمل",
    Title: "تحسين توظيف الشباب من خلال التدريب المهني",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=23"
  },
  {
    ID: 627,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "تمتّع اللاجئين الفلسطينيين بفرص مستدامة ومعززة، حيثما أمكن ذلك، للحصول على عمل لائق وتوليد الدخل، من خلال تنمية المهارات ودعم المشاريع وتيسير الوصول المنصف إلى أسواق العمل",
    Title: "توسيع نطاق استفادة النساء اللاجئات الفلسطينيات من الخدمات المالية الشاملة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "النساء والفتيات",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=24"
  },
  {
    ID: 628,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حصول اللاجئين الفلسطينيين على البنية التحتية الأساسية وبنية الخدمات العامة في بيئات مخيمات آمنة ومستدامة تصون صحتهم وكرامتهم",
    Title: "الحد من المخاطر الصحية المرتبطة بالمياه والصرف الصحي بالنسبة للاجئين الفلسطينيين في المخيمات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=26"
  },
  {
    ID: 629,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حصول اللاجئين الفلسطينيين على البنية التحتية الأساسية وبنية الخدمات العامة في بيئات مخيمات آمنة ومستدامة تصون صحتهم وكرامتهم",
    Title: "تحسين سلامة وكرامة اللاجئين الفلسطينيين المقيمين في المخيمات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=27"
  },
  {
    ID: 630,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حصول اللاجئين الفلسطينيين على البنية التحتية الأساسية وبنية الخدمات العامة في بيئات مخيمات آمنة ومستدامة تصون صحتهم وكرامتهم",
    Title: "تحسين نوعية المياه للاجئين الفلسطينيين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=27"
  },
  {
    ID: 631,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "حصول اللاجئين الفلسطينيين على البنية التحتية الأساسية وبنية الخدمات العامة في بيئات مخيمات آمنة ومستدامة تصون صحتهم وكرامتهم",
    Title: "تحسين ظروف العيش للاجئين الفلسطينيين في المخيمات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=28"
  },
  {
    ID: 632,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "تلقّي اللاجئين الفلسطينيين الأشد ضعفاً مساعدة اجتماعية أشد أثراً وأفضل استهدافاً",
    Title: "تحسين حصول شباب اللاجئين الفلسطينيين الضعفاء على فرص العمل",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=30"
  },
  {
    ID: 633,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "تلقّي اللاجئين الفلسطينيين الأشد ضعفاً مساعدة اجتماعية أشد أثراً وأفضل استهدافاً",
    Title: "ضمان الحصول على رعاية ميسورة التكلفة في المستشفيات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=30"
  },
  {
    ID: 634,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "تلقّي اللاجئين الفلسطينيين الأشد ضعفاً مساعدة اجتماعية أشد أثراً وأفضل استهدافاً",
    Title: "تأمين التحويلات الاجتماعية للاجئين الفلسطينيين الأشد ضعفا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=31"
  },
  {
    ID: 635,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "تلقّي اللاجئين الفلسطينيين الأشد ضعفاً مساعدة اجتماعية أشد أثراً وأفضل استهدافاً",
    Title: "تحسين قدرة الأسر المعيشية المتلقية للتحويلات الاجتماعية على الصمود",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=32"
  },
  {
    ID: 636,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "تسجيل اللاجئين الفلسطينيين تسجيلاً دقيقاً والحفاظ على وضعهم بصورة آمنة",
    Title: "صون وتأمين السجلات الأسرية التاريخية من خلال الرقمنة الواسعة النطاق",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,LU,PS,SY",
    Image: "26UNRWA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=33"
  },
  {
    ID: 637,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "وكالة الأمم المتحدة لإغاثة وتشغيل لاجئي فلسطين في الشرق الأدنى",
    Programme: "اللاجئون الفلسطينيون",
    Subprogramme: "تسجيل اللاجئين الفلسطينيين تسجيلاً دقيقاً والحفاظ على وضعهم بصورة آمنة",
    Title: "تحسن إمكانية وصول اللاجئين الفلسطينيين المسجلين رقميا إلى سجلاتهم وخدماتهم",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز حماية حقوق اللاجئين، وتحسين ظروفهم المعيشية، بما في ذلك الصحة والتعليم، وتحسين الاستجابة لمتطلباتهم والمشاركة في تحمل أعبائهم",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=ar#page=34"
  },
  {
    ID: 638,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "السياسة العامة والتحليل",
    Title: "أسهمت المشاورات التي تقودها الجهات المحلية في تحديد أولويات الاستجابة الإنسانية والتمويل وإجراءات التأهب",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,PH,SO",
    Image: "27OCHA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=9"
  },
  {
    ID: 639,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "السياسة العامة والتحليل",
    Title: "زيادة مشاركة المجتمعات المحلية في الاستجابة الإنسانية لتلبية احتياجاتها بفعالية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,NE,PH,SS,II,SO",
    Image: "27OCHA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=9"
  },
  {
    ID: 640,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "السياسة العامة والتحليل",
    Title: "تحسين التعلّم الجماعي من خلال إدماج المنظورات المحلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=10"
  },
  {
    ID: 641,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "السياسة العامة والتحليل",
    Title: "استجابات إنسانية أكثر كفاءة وتنظيما لصالح المجتمعات المتضررة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=11"
  },
  {
    ID: 642,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "تنسيق العمل الإنساني والاستجابة لحالات الطوارئ",
    Title: "الوصول إلى المحتاجين في ظل نقص حاد في التمويل",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=13"
  },
  {
    ID: 643,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "تنسيق العمل الإنساني والاستجابة لحالات الطوارئ",
    Title: "زيادة مشاركة الجهات الفاعلة المحلية والوطنية في آليات تنسيق العمل الإنساني",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=14"
  },
  {
    ID: 644,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "تنسيق العمل الإنساني والاستجابة لحالات الطوارئ",
    Title: "توسيع نطاق استخدام النهج الاستباقية ونظم الإنذار المبكر - العمل المبكر",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=15"
  },
  {
    ID: 645,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "تنسيق العمل الإنساني والاستجابة لحالات الطوارئ",
    Title: "تعزيز الدبلوماسية على نطاق المنظومة للدفاع عن المبادئ الإنسانية، وتأمين الوصول، وحماية المدنيين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=16"
  },
  {
    ID: 646,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "خدمات الدعم في حالات الطوارئ",
    Title: "تعزيز الاستجابة الدولية لحالات الطوارئ من خلال تحديث الإرشادات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=19"
  },
  {
    ID: 647,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "خدمات الدعم في حالات الطوارئ",
    Title: "تعزيز الشراكة مع القطاع الخاص في العمل الإنساني الجماعي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SD,QQ,SB",
    Image: "27OCHA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=19"
  },
  {
    ID: 648,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "خدمات الدعم في حالات الطوارئ",
    Title: "تلقّي الأشخاص المتضررين من الأزمات مساعدة إنسانية طارئة في أعقاب وقوع الكارثة مباشرة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=20"
  },
  {
    ID: 649,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "خدمات الدعم في حالات الطوارئ",
    Title: "تعزيز الجاهزية العالمية لأفرقة البحث والإنقاذ في المناطق الحضرية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=21"
  },
  {
    ID: 650,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "المعلومات وأنشطة الدعوة فيما يتصل بحالات الطوارئ الإنسانية",
    Title: "تلقى المتضررون من الأزمات دعما قائما على البيانات من الجهات الفاعلة في المجال الإنساني",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=23"
  },
  {
    ID: 651,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "المعلومات وأنشطة الدعوة فيما يتصل بحالات الطوارئ الإنسانية",
    Title: "شبكة موثوقة وخدمات اتصال للمستجيبين في مجال العمل الإنساني",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=24"
  },
  {
    ID: 652,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "المعلومات وأنشطة الدعوة فيما يتصل بحالات الطوارئ الإنسانية",
    Title: "تعزيز إمكانية الوصول إلى البيانات والمعلومات البالغة الأهمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز اتساق الاستجابة الإنسانية وحسن توقيتها وفعاليتها ونطاقها؛ وخفض مخاطر الكوارث إلى حد كبير",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=25"
  },
  {
    ID: 653,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "مكتب تنسيق الشؤون الإنسانية",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "المعلومات وأنشطة الدعوة فيما يتصل بحالات الطوارئ الإنسانية",
    Title: "تعزيز الوعي العام بالأزمات الإنسانية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=25"
  },
  {
    ID: 654,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "مكتب الأمم المتحدة للحد من مخاطر الكوارث",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "مكتب الأمم المتحدة للحد من مخاطر الكوارث",
    Title: "قيام الدول الأعضاء والجهات صاحبة المصلحة باستعراض التقدم المحرز في تنفيذ إطار سنداي وتحديد توصيات لتعزيز الحد من مخاطر الكوارث",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=45"
  },
  {
    ID: 655,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "مكتب الأمم المتحدة للحد من مخاطر الكوارث",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "مكتب الأمم المتحدة للحد من مخاطر الكوارث",
    Title: "تعزيز نظم الإنذار المبكر بالأخطار المتعددة الشاملة للجميع التي تصل إلى أشد الفئات ضعفا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=46"
  },
  {
    ID: 656,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "مكتب الأمم المتحدة للحد من مخاطر الكوارث",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "مكتب الأمم المتحدة للحد من مخاطر الكوارث",
    Title: "توافر استراتيجيات وطنية لتمويل الحد من مخاطر الكوارث",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=47"
  },
  {
    ID: 657,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "مكتب الأمم المتحدة للحد من مخاطر الكوارث",
    Programme: "المساعدة الإنسانية",
    Subprogramme: "مكتب الأمم المتحدة للحد من مخاطر الكوارث",
    Title: "قيام الحكومات بتقييم جاهزيتها للتعافي القادر على الصمود من أجل إعادة البناء على نحو أفضل، وتعزيزها وإضفاء الطابع المؤسسي عليها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنسيق الفعال لجهود المساعدة الإنسانية ودعم اللاجئين",
    Beneficiary: "الإدارة العامة",
    BeneficiaryTwo: " ",
    SpecificResult: "التعافي من الكوارث على نحو شامل للجميع ومستدام؛ وبناء القدرة على الصمود لمواجهة الكوارث في المستقبل",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=ar#page=48"
  },
  {
    ID: 658,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "خدمات الحملات والعمليات القطرية",
    Title: "تعزيز تفاعل الجمهور مع القضايا ذات الأولوية بالنسبة للأمم المتحدة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=6"
  },
  {
    ID: 659,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "خدمات الحملات والعمليات القطرية",
    Title: "زيادة العمل من أجل تنفيذ خطة التنمية المستدامة لعام 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=7"
  },
  {
    ID: 660,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "خدمات الحملات والعمليات القطرية",
    Title: "زيادة فهم الجمهور للقضايا الحاسمة المتصلة بأهداف التنمية المستدامة وزيادة تفاعله معها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "زيادة التعاون وتبادل المعلومات وأفضل الممارسات من أجل إحراز تقدم نحو تحقيق أهداف التنمية المستدامة",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=8"
  },
  {
    ID: 661,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "خدمات الحملات والعمليات القطرية",
    Title: "توسيع نطاق الوصول إلى مواد الدعوة والرسائل المتعلقة بالقضايا ذات الأولوية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=9"
  },
  {
    ID: 662,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "الخدمات الإخبارية",
    Title: "زيادة وصول الجمهور إلى تغطية أخبار الأمم المتحدة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=11"
  },
  {
    ID: 663,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "الخدمات الإخبارية",
    Title: "تفاعل أعمق للجماهير من خلال أدوات وتنسيقات التدوين المباشر",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=12"
  },
  {
    ID: 664,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "الخدمات الإخبارية",
    Title: "زيادة تفاعل الجمهور ودعم الاحتفالات الدولية للأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=12"
  },
  {
    ID: 665,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "الخدمات الإخبارية",
    Title: "تعزيز الاطلاع العالمي على أخبار الأمم المتحدة في الوقت المناسب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=13"
  },
  {
    ID: 666,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "خدمات التوعية والخدمات المعرفية",
    Title: "تعزيز الدعم العالمي والإجراءات على الصعيد العالمي من أجل عمل الأمم المتحدة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=15"
  },
  {
    ID: 667,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "خدمات التوعية والخدمات المعرفية",
    Title: "حصول الصحافيين الشباب على إمكانية الاطلاع على عمل الأمم المتحدة واكتساب رؤى متعمقة عنه",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=16"
  },
  {
    ID: 668,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "خدمات التوعية والخدمات المعرفية",
    Title: "النهوض بتنفيذ أهداف التنمية المستدامة عن طريق مؤسسات التعليم العالي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "التنمية المستدامة",
    Beneficiary: "الشباب",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين التعاون والشراكات وزيادة الاتساق وأوجه التآزر والحد من التداخل من خلال التواصل بصورة متسقة",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=17"
  },
  {
    ID: 669,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "إدارة التواصل العالمي",
    Programme: "التواصل العالمي",
    Subprogramme: "خدمات التوعية والخدمات المعرفية",
    Title: "زيادة عدد زوار مقر الأمم المتحدة من خلال الجولات المواضيعية المصحوبة بمرشدين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "المجتمع الدولي",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=ar#page=18"
  },
  {
    ID: 670,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: أداة التخطيط المركزي للموارد",
    Title: "التحول الرقمي باستخدام نظام أوموجا من أجل تحسين الكفاءة وفعالية اتخاذ القرارات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=10"
  },
  {
    ID: 671,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: أداة التخطيط المركزي للموارد",
    Title: "أفكار متعمقة قابلة للتنفيذ ومستندة إلى البيانات من خلال منصة تحليلات نظام أوموجا من الجيل التالي (nextgen umoja analytics)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=11"
  },
  {
    ID: 672,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: أداة التخطيط المركزي للموارد",
    Title: "تيسير عملية اتخاذ القرار من خلال إدخال تحسينات على بوابات الدول الأعضاء",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=12"
  },
  {
    ID: 673,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: أداة التخطيط المركزي للموارد",
    Title: "الترقية إلى تكنولوجيا الجيل التالي من النظام المركزي لتخطيط الموارد (nextgen erp)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=12"
  },
  {
    ID: 674,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: الخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق",
    Title: "دعم عمليات اللجنة الخامسة من خلال توسيع نطاق المعلومات والإبلاغ بكفاءة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=14"
  },
  {
    ID: 675,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: الخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق",
    Title: "تحسين إمكانية وصول أعضاء اللجنة الخامسة ولجنة البرنامج والتنسيق إلى المعلومات، بما في ذلك المعلومات المتاحة قبل الدورات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=15"
  },
  {
    ID: 676,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: الخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق",
    Title: "تبسيط وترشيد العمليات وتحسين الخدمات المقدمة للمشاركين في الاجتماعات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=16"
  },
  {
    ID: 677,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: الخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق",
    Title: "تعزيز الدعم فيما يتعلق بالعمليات المتصلة بالانتخابات والتعيينات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=16"
  },
  {
    ID: 678,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: الخدمات الاستشارية الإدارية",
    Title: "الردود في الوقت المناسب على طلبات التقييم الإداري",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=19"
  },
  {
    ID: 679,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: الخدمات الاستشارية الإدارية",
    Title: "إضفاء الطابع المؤسسي على نظام إدارة قدرة المنظمة على مواجهة الطوارئ في مؤسسات منظومة الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=19"
  },
  {
    ID: 680,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: الخدمات الاستشارية الإدارية",
    Title: "قبول توصيات لجنة العقود في المقر من جانب المسؤولين المفوضين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=20"
  },
  {
    ID: 681,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "أداة التخطيط المركزي للموارد، والخدمات المقدمة إلى اللجنة الخامسة للجمعية العامة وإلى لجنة البرنامج والتنسيق، والخدمات الاستشارية الإدارية: الخدمات الاستشارية الإدارية",
    Title: "تعزيز فهم موظفي المنظمة لنظامها الرسمي لإقامة العدل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=21"
  },
  {
    ID: 682,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: الشؤون المالية",
    Title: "تحسين الوصول إلى معلومات موحدة بشأن استرداد التكاليف من أجل اتخاذ القرار من قبل كيانات الأمانة العامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=23"
  },
  {
    ID: 683,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: الشؤون المالية",
    Title: "تحسين تجربة الجهات المستفيدة من الخدمات مع نظم الدفع العالمية للأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=24"
  },
  {
    ID: 684,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: الشؤون المالية",
    Title: "تنفيذ التحديثات المعتمدة للمعايير المحاسبية الدولية للقطاع العام وتحليل أثر التغييرات المقبلة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=24"
  },
  {
    ID: 685,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: الشؤون المالية",
    Title: "تعزيز الإطار التنظيمي للإدارة المالية من خلال أدوات سياسة عامة مستحدثة ومحدَّثة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=25"
  },
  {
    ID: 686,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: الشؤون المالية للعمليات الميدانية",
    Title: "تعزيز الرقابة والمساءلة في إدارة الممتلكات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=28"
  },
  {
    ID: 687,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: الشؤون المالية للعمليات الميدانية",
    Title: "التنسيق والتبادل من أجل تحقيق التآزر والتوحيد في إدارة المرافق",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=29"
  },
  {
    ID: 688,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: الشؤون المالية للعمليات الميدانية",
    Title: "مشاريع التشييد الرئيسية العالية الجودة والفعالة من حيث التكلفة التي تضطلع بها المنظمة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=30"
  },
  {
    ID: 689,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: الشؤون المالية للعمليات الميدانية",
    Title: "زيادة الشفافية والكفاءة في صياغة الاحتياجات من الموارد للبعثات السياسية الخاصة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=31"
  },
  {
    ID: 690,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: تخطيط البرامج وميزنتها",
    Title: "اختتام ناجح للمداولات المتعلقة بالميزانية بشأن مبادرة الأمم المتحدة 80 ضمن إطار زمني مختصر",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=33"
  },
  {
    ID: 691,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: تخطيط البرامج وميزنتها",
    Title: "تعزيز الشفافية بشأن عملية الآثار المترتبة في الميزانية البرنامجية على الدول الأعضاء",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=34"
  },
  {
    ID: 692,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: تخطيط البرامج وميزنتها",
    Title: "تحسين المعلومات المتعلقة بالميزانية المتاحة على المشروع التجريبي المتعلق بمعلومات الميزانية لدعم عملية اتخاذ القرار لدى الدول الأعضاء",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=35"
  },
  {
    ID: 693,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية: تخطيط البرامج وميزنتها",
    Title: "زيادة الكفاءة على نحو ينعكس في الاحتياجات من الموارد في جميع كيانات الأمانة العامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=36"
  },
  {
    ID: 694,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "الموارد البشرية: الاستراتيجيات والسياسات العالمية",
    Title: "تعامل الموظفون والمديرون وكبار القيادات مع التغيير التنظيمي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=39"
  },
  {
    ID: 695,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "الموارد البشرية: الاستراتيجيات والسياسات العالمية",
    Title: "انخفاض عدد الدول الأعضاء غير الممثلة والممثلة تمثيلا ناقصا في نظام النطاقات المستصوبة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=40"
  },
  {
    ID: 696,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "الموارد البشرية: الاستراتيجيات والسياسات العالمية",
    Title: "نظام يتسم بالإنصاف والفعالية والكفاءة والمرونة لاختيار الموظفين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=41"
  },
  {
    ID: 697,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "الموارد البشرية: الاستراتيجيات والسياسات العالمية",
    Title: "اتباع نهج شامل إزاء المواهب الشابة يعزز قدرة المنظمة على استقطاب المواهب في بداية المسار المهني وتنميتها والاحتفاظ بها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=41"
  },
  {
    ID: 698,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "الموارد البشرية: القانون الإداري",
    Title: "توسيع استخدام أدوات الفرز في المسائل المتعلقة بالسلوك والانضباط",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=44"
  },
  {
    ID: 699,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "الموارد البشرية: القانون الإداري",
    Title: "إدخال تعديلات على إطار سياسات الأمانة العامة وممارساتها الإدارية التي يسرتها الأحكام الصادرة عن محكمة الأمم المتحدة للمنازعات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "الأطر القانونية والتنظيمية التمكينية؛ وتقليل مدى التعرض للمسؤولية القانونية",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=44"
  },
  {
    ID: 700,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "الموارد البشرية: القانون الإداري",
    Title: "تعزيز قدرة القيادة العليا على اتخاذ القرار في التعامل مع مسائل السلوك والانضباط",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=45"
  },
  {
    ID: 701,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "الموارد البشرية: القانون الإداري",
    Title: "تعزيز المساءلة من خلال الكفاءة والاتساق في استعراض القضايا التأديبية والبت فيها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=46"
  },
  {
    ID: 702,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "التحوّل في تسيير الأعمال والمساءلة",
    Title: "حل المشكلات باستخدام الذكاء الاصطناعي التوليدي لتحسين الكفاءة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=48"
  },
  {
    ID: 703,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "التحوّل في تسيير الأعمال والمساءلة",
    Title: "زيادة استخدام التقييم الداخلي من جانب الكيانات الأصغر حجما للاسترشاد بها في اتخاذ القرارات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=49"
  },
  {
    ID: 704,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "التحوّل في تسيير الأعمال والمساءلة",
    Title: "تعزيز عملية اتخاذ القرارات المستندة إلى البيانات من خلال التحسين المستمر للوحة المتابعة الإدارية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=49"
  },
  {
    ID: 705,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "التحوّل في تسيير الأعمال والمساءلة",
    Title: "تنفيذ توصيات هيئات الرقابة في الوقت المناسب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=50"
  },
  {
    ID: 706,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "التصدي للعنصرية في مكان العمل",
    Title: "التصدي للأشكال الشخصية والمؤسسية والمنهجية للعنصرية في المنظمة ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=53"
  },
  {
    ID: 707,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "التصدي للعنصرية في مكان العمل",
    Title: "تعزيز نظم المساءلة للنظر في ادعاءات العنصرية في مكان العمل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=53"
  },
  {
    ID: 708,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "التصدي للعنصرية في مكان العمل",
    Title: "تحسين الشفافية المؤسسية فيما يتعلق بالتنوع",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=54"
  },
  {
    ID: 709,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Programme: "إدارة الاستراتيجيات والسياسات الإدارية ومسائل الامتثال",
    Subprogramme: "التصدي للعنصرية في مكان العمل",
    Title: "زيادة المعارف المتعلقة بالتصدي للعنصرية والتمييز العنصري في مكان العمل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=ar#page=55"
  },
  {
    ID: 710,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: دعم الموارد البشرية ",
    Title: "تحصل كيانات الأمانة العامة على دعم وتوجيه شاملين في مجال الموارد البشرية التشغيلية لأغراض إعادة الهيكلة وتقليص الحجم",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=7"
  },
  {
    ID: 711,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: دعم الموارد البشرية ",
    Title: "تحسين إدارة الأداء على نطاق الأمانة العامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=8"
  },
  {
    ID: 712,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: دعم الموارد البشرية ",
    Title: "تعزيز عملية إعداد قوائم المرشحين المقبولين وإدارتها لفائدة الأمانة العامة بنطاقها العالمي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=8"
  },
  {
    ID: 713,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: دعم الموارد البشرية ",
    Title: "تعزيز استقدام الموظفين المقدمين دون مقابل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=9"
  },
  {
    ID: 714,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: تنمية القدرات والتدريب العملياتي",
    Title: "يمكن لموظفي الأمم المتحدة وأفرادها، والدول الأعضاء، والمرشحين للوظائف، والمديرين المسؤولين عن التعيين الاستفادة من مركز موحد لمهارات اللغات والاتصال",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=11"
  },
  {
    ID: 715,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: تنمية القدرات والتدريب العملياتي",
    Title: "مبادرة UNTold: نهج جماعي للتعلم والابتكار على نطاق منظومة الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=12"
  },
  {
    ID: 716,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: تنمية القدرات والتدريب العملياتي",
    Title: "تعزيز القدرات التنظيمية في مجالات الابتكار وتحليل البيانات والتحول الرقمي والاستشراف الاستراتيجي والعلوم السلوكية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=13"
  },
  {
    ID: 717,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: تنمية القدرات والتدريب العملياتي",
    Title: "تحسين توافر التوجيهات الإدارية والتنفيذية وإمكانية الوصول إليها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=13"
  },
  {
    ID: 718,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: إدارة الرعاية الصحية، والسلامة والصحة المهنيتان ",
    Title: "تحسين مستوى التأهب لمنع مخاطر الأمراض المعدية التي تؤثر على موظفي وأفراد الأمم المتحدة والتخفيف منها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=15"
  },
  {
    ID: 719,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: إدارة الرعاية الصحية، والسلامة والصحة المهنيتان ",
    Title: "استخدام أفراد الأمم المتحدة للخدمات الصحية الوقائية لتحسين صحتهم ورفاههم",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=16"
  },
  {
    ID: 720,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: إدارة الرعاية الصحية، والسلامة والصحة المهنيتان ",
    Title: "تحسين جودة رعاية المرضى",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=17"
  },
  {
    ID: 721,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "عمليات الدعم: إدارة الرعاية الصحية، والسلامة والصحة المهنيتان ",
    Title: "تعزيز إمكانية الوصول إلى الدعم الرقمي للصحة النفسية لأفراد حفظ السلام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين أداء وسلامة وأمن بعثات حفظ السلام، بما يشمل كفالة الانتقال السلس في أعقاب تنفيذ قرارات مجلس الأمن",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=17"
  },
  {
    ID: 722,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "إدارة سلسلة الإمداد: الإدارة المتكاملة لسلسلة الإمداد",
    Title: "إعادة الأفراد النظاميين إلى أوطانهم على نحو آمن وفي الوقت المناسب تمشيا مع خطط الطوارئ الخاصة بالبعثات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين أداء وسلامة وأمن بعثات حفظ السلام، بما يشمل كفالة الانتقال السلس في أعقاب تنفيذ قرارات مجلس الأمن",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=19"
  },
  {
    ID: 723,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "إدارة سلسلة الإمداد: الإدارة المتكاملة لسلسلة الإمداد",
    Title: "تنويع المشاركة في فرص الأعمال التجارية مع الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "النساء والفتيات",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=20"
  },
  {
    ID: 724,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "إدارة سلسلة الإمداد: الإدارة المتكاملة لسلسلة الإمداد",
    Title: "زيادة توافر الحلول اللوجستية تحت الطلب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=21"
  },
  {
    ID: 725,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "إدارة سلسلة الإمداد: الإدارة المتكاملة لسلسلة الإمداد",
    Title: "حلول متكاملة لسلسلة الإمداد في البيئات الإنسانية والبيئات المعقدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=21"
  },
  {
    ID: 726,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "إدارة سلسلة الإمداد: دعم القدرات النظامية ",
    Title: "تنفذ بعثات حفظ السلام خطط طوارئ أتاحت خفض التكاليف",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين أداء وسلامة وأمن بعثات حفظ السلام، بما يشمل كفالة الانتقال السلس في أعقاب تنفيذ قرارات مجلس الأمن",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=24"
  },
  {
    ID: 727,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "إدارة سلسلة الإمداد: دعم القدرات النظامية ",
    Title: "بوابة جامعة آمنة للدول الأعضاء لتقديم المطالبات والحصول على المعلومات المتعلقة بنشر أفرادها في عمليات السلام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=24"
  },
  {
    ID: 728,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "إدارة سلسلة الإمداد: دعم القدرات النظامية ",
    Title: "تحديث السياسات والإجراءات والمعايير والتعاريف المتعلقة بالأفراد النظاميين والمعدات المملوكة للوحدات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=25"
  },
  {
    ID: 729,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "إدارة سلسلة الإمداد: دعم القدرات النظامية ",
    Title: "تعزيز إدارة الذخائر المملوكة للوحدات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=26"
  },
  {
    ID: 730,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "الأنشطة الخاصة",
    Title: "إنشاء مكتب الأمم المتحدة لتقديم الدعم في هايتي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "29BDOS21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=28"
  },
  {
    ID: 731,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "الأنشطة الخاصة",
    Title: "اضطلاع الكيانات التي تمر بمرحلة انتقالية بتعزيز إدارة وظائف الدعم العملياتي طوال دورة حياتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين أداء وسلامة وأمن بعثات حفظ السلام، بما يشمل كفالة الانتقال السلس في أعقاب تنفيذ قرارات مجلس الأمن",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=29"
  },
  {
    ID: 732,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "الأنشطة الخاصة",
    Title: "تقديم خدمات أفضل تتسم بالكفاءة من خلال تعزيز الدعم والخدمات الاستشارية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CO,PK,ZW",
    Image: "29BDOS23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=30"
  },
  {
    ID: 733,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "الأنشطة الخاصة",
    Title: "تعزيز ترتيبات الشراكة في مجال الدعم",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=31"
  },
  {
    ID: 734,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "الإدارة، نيويورك",
    Title: "أتمتة استرداد تكاليف الإيجار من خلال كشوف المرتبات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=33"
  },
  {
    ID: 735,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "الإدارة، نيويورك",
    Title: "الحفظ الرقمي للسجلات التاريخية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=34"
  },
  {
    ID: 736,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "الإدارة، نيويورك",
    Title: "مواءمة الحيز المكتبي مع احتياجات المنظمة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=35"
  },
  {
    ID: 737,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "إدارة الدعم العملياتي",
    Programme: "إدارة الدعم العملياتي",
    Subprogramme: "الإدارة، نيويورك",
    Title: "زيادة إمكانية الوصول إلى مباني ومرافق مقر الأمم المتحدة للأشخاص ذوي الإعاقة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    BeneficiaryTwo: "التمكين",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=ar#page=35"
  },
  {
    ID: 738,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "الاستراتيجية والابتكار التكنولوجي",
    Title: "تعزيز الوعي بأمن تكنولوجيا المعلومات والأمن لحماية الأمانة العامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=7"
  },
  {
    ID: 739,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "الاستراتيجية والابتكار التكنولوجي",
    Title: "تعزيز فعالية تنفيذ الولايات بتسخير الذكاء الاصطناعي التوليدي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=9"
  },
  {
    ID: 740,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "الاستراتيجية والابتكار التكنولوجي",
    Title: "استخدام الذكاء الاصطناعي بطريقة أخلاقية ومسؤولة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=9"
  },
  {
    ID: 741,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "الاستراتيجية والابتكار التكنولوجي",
    Title: "تمكين كيانات الأمانة العامة من تطبيق استراتيجية تكنولوجيا المعلومات والاتصالات بفعالية من أجل تحسين تنفيذ ولاياتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=10"
  },
  {
    ID: 742,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "دعم العمليات",
    Title: "إتاحة اتصال المندوبين والموظفين بالإنترنت بصورة أكثر موثوقية وثباتا نتيجة لتحسين تقنية الاتصال اللاسلكي في المقر",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=13"
  },
  {
    ID: 743,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "دعم العمليات",
    Title: "تعزيز إدارة التكنولوجيات التي تدعم الاجتماعات الحكومية الدولية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=14"
  },
  {
    ID: 744,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "دعم العمليات",
    Title: "تقليل المخاطر من خلال استخدام خدمات التحقق من هوية المستخدمين القائمة على الحوسبة السحابية من أجل ضمان أمن الوصول",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=14"
  },
  {
    ID: 745,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "دعم العمليات",
    Title: "الحد من التجزؤ وتعزيز مرونة تكنولوجيا المعلومات والاتصالات وأمنها وتوحيد معايير البنية التحتية لمراكز البيانات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=15"
  },
  {
    ID: 746,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "الحلول المركزية",
    Title: "زيادة إتاحة المواقع الشبكية والتطبيقات بنقلها إلى خارج مركز التكنولوجيا الأساسي في نيويورك",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=18"
  },
  {
    ID: 747,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "الحلول المركزية",
    Title: "إيجاد حلول مصممة حسب الطلب في أوانها في مجال تكنولوجيا المعلومات للاستفادة منها في تنفيذ الولايات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تسخير أوجه التقدم المحرز في العلم والتكنولوجيا والابتكار، بما في ذلك الذكاء الاصطناعي، لأغراض التنمية المستدامة",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=18"
  },
  {
    ID: 748,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "الحلول المركزية",
    Title: "إدماج الذكاء الاصطناعي في حلول تكنولوجيا المعلومات والاتصالات للمساعدة في عملية صنع القرار",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=19"
  },
  {
    ID: 749,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "مكتب تكنولوجيا المعلومات والاتصالات",
    Programme: "مكتب تكنولوجيا المعلومات والاتصالات",
    Subprogramme: "الحلول المركزية",
    Title: "تعزيز معايير المواقع الشبكية الإعلامية للأمم المتحدة، وأمنها، وتعددية لغاتها، وإمكانية الوصول إليها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29COICT12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=ar#page=20"
  },
  {
    ID: 750,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "تحسين توقيت تجهيز دفاتر المحاسبة اليومية للعملاء",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=7"
  },
  {
    ID: 751,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "تحسين سبل حصر الأصول في مباني مكتب الأمم المتحدة في نيروبي ومرافقه وبناه التحتية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=8"
  },
  {
    ID: 752,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "تحسين تسوية المدفوعات المرفوضة والمردودة في مواعيدها المقررة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KE",
    Image: "29DUNON3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=9"
  },
  {
    ID: 753,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "تحسين توقيت تقديم التقارير المالية إلى الجهات المانحة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=9"
  },
  {
    ID: 754,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "يستطيع الموظفون والعاملون الحصول على الدعم المحسن في مجال الصحة العقلية والنفسية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=12"
  },
  {
    ID: 755,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "اكتساب الموظفين والأفراد معارف ومهارات جديدة لتحسين فعالية المنظمة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=12"
  },
  {
    ID: 756,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "تحسين تقديم الخدمات المتصلة بمزايا الموظفين واستحقاقاتهم في الوقت المناسب لجميع الجهات المستفيدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=13"
  },
  {
    ID: 757,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "تحسين تقديم الخدمات المتصلة بعمليات الفحص المسبق للتوظيف في الوقت المناسب من جانب المكاتب المستفيدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=14"
  },
  {
    ID: 758,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "خدمات الدعم",
    Title: "تتمتع كيانات الأمم المتحدة في كينيا بإمكانية الوصول إلى مركز المناسبات داخل مجمع الأمم المتحدة في نيروبي",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=16"
  },
  {
    ID: 759,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "خدمات الدعم",
    Title: "إنشاء أماكن جديدة للاجتماعات والتعاون للمندوبين والموظفين والأفراد",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=17"
  },
  {
    ID: 760,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "خدمات الدعم",
    Title: "حصول موظفي الأمم المتحدة في كينيا والمنطقة على خدمات البلد المضيف على نحو سلس وفعال",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=17"
  },
  {
    ID: 761,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "خدمات الدعم",
    Title: "تحسين مرافق خدمات المؤتمرات المدمجة مع مباني مقر الأمم المتحدة في نيروبي",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=18"
  },
  {
    ID: 762,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "منصة حديثة لتكنولوجيا المعلومات والاتصالات تتوافق مع المعايير العالمية للأمم المتحدة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=20"
  },
  {
    ID: 763,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "تحسين مواءمة سياسات وممارسات تكنولوجيا المعلومات والاتصالات في الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=21"
  },
  {
    ID: 764,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "سلاسة المداولات الحكومية الدولية من خلال ترقية تكنولوجيا المؤتمرات وصيانتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KE",
    Image: "29DUNON15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=22"
  },
  {
    ID: 765,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "مكتب الأمم المتحدة في نيروبي",
    Programme: "الإدارة، نيروبي",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "تعزيز قابلية التشغيل البيني للشبكات في إطار منصة مقدم خدمات واحد",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=ar#page=22"
  },
  {
    ID: 766,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "تحسين توقيت مدفوعات الموردين",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=7"
  },
  {
    ID: 767,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "تمتُّع الكيانات بإمكانية الحصول على دعم مخصص عند الانتقال إلى قصر الأمم أو مغادرته",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=8"
  },
  {
    ID: 768,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "عمليات معاملات الخزانة المتسمة بالمرونة والكفاءة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=8"
  },
  {
    ID: 769,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "اكتساب العملاء فهماً أوضح لأداء الخدمات من خلال التقارير الفصلية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=9"
  },
  {
    ID: 770,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "دعم الموظفين في تغيير المسار المهني وانتهاء الخدمة المبكر",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=11"
  },
  {
    ID: 771,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "الموظفون والمتقدمون الخارجيون للوظائف يفهمون بشكل أفضل عملية التوظيف في الأمم المتحدة ويتخذون قرارات مستنيرة متعلقة بالحياة المهنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=12"
  },
  {
    ID: 772,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "توسيع نطاق مشاركة الشباب والحوار بين الأجيال",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "الشباب",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=13"
  },
  {
    ID: 773,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "تحسين دعم القوى العاملة والاستعداد التنظيمي من خلال عمليات الانتقال",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=13"
  },
  {
    ID: 774,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "خدمات الدعم",
    Title: "تساعد الأنظمة السمعية البصرية لقاعة الجمعية في تنظيم اجتماعات ومناسبات حكومية دولية واسعة النطاق",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=15"
  },
  {
    ID: 775,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "خدمات الدعم",
    Title: "مركز دعم الأنشطة، المرحلة الثانية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=17"
  },
  {
    ID: 776,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "خدمات الدعم",
    Title: "استفادة العملاء من مرافق المباني الحديثة بعد أعمال التجديد في إطار الخطة الاستراتيجية لحفظ التراث",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=17"
  },
  {
    ID: 777,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "خدمات الدعم",
    Title: "تحسين إدارة الطاقة في قصر الأمم",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المناخ والبيئة",
    SpecificResult: "الإدارة المستدامة للموارد؛ وأوجه التقدم المحرز في مجال الطاقة المتجددة",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=18"
  },
  {
    ID: 778,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "يحقق العملاء استخدامًا أكثر كفاءة للخطوط الهاتفية الثابتة ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=20"
  },
  {
    ID: 779,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "مركز دعم الأنشطة، المرحلة الأولى",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين الاجتماعات والمداولات المتعددة الأطراف",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=20"
  },
  {
    ID: 780,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "تعزيز الكفاءة والأمن باستخدام إنترنت الأشياء من أجل تحسين تجربة العملاء",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=21"
  },
  {
    ID: 781,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "توفير خدمات شبكات أسرع وأكثر موثوقية للعملاء",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=21"
  },
  {
    ID: 782,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "خدمات المكتبة",
    Title: "صون مجموعات مقتنيات المكتبة التاريخية التي لا يمكن تعويضها أثناء أعمال التجديد من أجل الأجيال القادمة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=24"
  },
  {
    ID: 783,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "خدمات المكتبة",
    Title: "زيادة توافر الأدوات اللازمة لتمكين العملاء من الوصول إلى موارد المعلومات واستخدامها بكفاءة ومسؤولية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=24"
  },
  {
    ID: 784,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "خدمات المكتبة",
    Title: "تحسين إمكانية الوصول إلى المزيد من معارف الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=25"
  },
  {
    ID: 785,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "مكتب الأمم المتحدة في جنيف",
    Programme: "الإدارة، جنيف",
    Subprogramme: "خدمات المكتبة",
    Title: "إتاحة اطلاع الدول الأعضاء وغيرها من أصحاب المصلحة على محفوظات الأمم المتحدة بصورة مستدامة على المدى الطويل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=ar#page=26"
  },
  {
    ID: 786,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "مواصلة تنفيذ البرامج في ظل الانقطاع المفاجئ في التمويل",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=7"
  },
  {
    ID: 787,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "تحسين المحاسبة والإبلاغ الماليين من خلال تنفيذ المعيار 47 من المعايير المحاسبية الدولية للقطاع العام",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=7"
  },
  {
    ID: 788,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "تقليص عدد المسائل المالية غير المحلولة في المكاتب الميدانية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=8"
  },
  {
    ID: 789,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "تخطيط البرامج والشؤون المالية وشؤون الميزانية",
    Title: "تحسين الشفافية المالية والإشراف الإداري",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=9"
  },
  {
    ID: 790,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "تحسين طريقة التعاقد مع موظفي المشاريع الميدانية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=11"
  },
  {
    ID: 791,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "نحو إدماج الأشخاص ذوي الإعاقة في القوة العاملة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين عملية استقدام الموظفين وتعيينهم في كيانات الأمم المتحدة، بما في ذلك الحد من أوجه عدم المساواة من حيث التمثيل الجنساني والجغرافي",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=11"
  },
  {
    ID: 792,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "أن يكون العملاء على علم ودراية بجميع سياسات الموارد البشرية ذات الصلة وتطوراتها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين عملية نشر المعلومات وتيسير الحصول عليها",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=12"
  },
  {
    ID: 793,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "إدارة الموارد البشرية",
    Title: "زيادة الوعي بمدونة قواعد السلوك لمنع التحرش، بما في ذلك التحرش الجنسي، في مناسبات منظومة الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز آليات العدالة الداخلية والوساطة من أجل زيادة التحلي بالسلوك الأخلاقي وتعزيز الانسجام وتحسين إمكانية اللجوء إلى العدالة داخل الأمم المتحدة",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=13"
  },
  {
    ID: 794,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "خدمات الدعم",
    Title: "الإدارة المعزَّزة للممتلكات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=15"
  },
  {
    ID: 795,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "خدمات الدعم",
    Title: "تحسين رصد الشركاء المنفذين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=16"
  },
  {
    ID: 796,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "خدمات الدعم",
    Title: "تبسيط مسار العمل المتعلق بتسجيل المراسلات الرسمية وتوزيعها",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=16"
  },
  {
    ID: 797,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "خدمات الدعم",
    Title: "تحسين استخدام حيّز المكاتب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=17"
  },
  {
    ID: 798,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "تعزيز موثوقية عمليات تكنولوجيا المعلومات والاتصالات من خلال توحيد البنية التحتية الافتراضية وتقليل الاعتماد على الرخص القائمة على الاشتراكات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=19"
  },
  {
    ID: 799,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "تعزيز أمن المعلومات في الميدان",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=20"
  },
  {
    ID: 800,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "التحول الرقمي من قبل الكيانات المستفيدة من أجل تحسين إنجاز الولاية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=20"
  },
  {
    ID: 801,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "مكتب الأمم المتحدة في فيينا",
    Programme: "الإدارة، فيينا",
    Subprogramme: "عمليات تكنولوجيا المعلومات والاتصالات",
    Title: "اتباع نهج منسّق بشأن أمن تكنولوجيا المعلومات والاتصالات في جميع مواقع الإدارات المستفيدة من مكتب الأمم المتحدة في فيينا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=ar#page=21"
  },
  {
    ID: 802,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "المراجعة الداخلية للحسابات",
    Title: "تعزيز المساءلة فيما يتعلق بوقت عمل الموظفين وحضورهم",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=7"
  },
  {
    ID: 803,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "المراجعة الداخلية للحسابات",
    Title: "تعزيز نظم الرصد لتحسين إدارة الأداء لدعم تنفيذ البرامج",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=7"
  },
  {
    ID: 804,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "المراجعة الداخلية للحسابات",
    Title: "تعزيز تنفيذ ولايات الأمم المتحدة وبرامجها من خلال تعزيز القدرات التنظيمية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=8"
  },
  {
    ID: 805,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "المراجعة الداخلية للحسابات",
    Title: "زيادة أوجه الكفاءة في إدارة المنظمة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=9"
  },
  {
    ID: 806,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "التفتيش والتقييم",
    Title: "تعزيز قدرات التقييم الذاتي في الأمانة العامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=11"
  },
  {
    ID: 807,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "التفتيش والتقييم",
    Title: "تعزيز نظام المنسقين المقيمين",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=11"
  },
  {
    ID: 808,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "التفتيش والتقييم",
    Title: "تعزيز النتائج البرنامجية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=12"
  },
  {
    ID: 809,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "التفتيش والتقييم",
    Title: "تنفيذ الولاية بشكل أفضل من خلال تحسين تخطيط البرامج",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=13"
  },
  {
    ID: 810,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "التحقيقات",
    Title: "تعزيز قدرة المنظمة على حماية مواردها ومساءلة موظفيها",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=15"
  },
  {
    ID: 811,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "التحقيقات",
    Title: "تعزيز الاستجابة للتحقيقات المتعلقة بسوء السلوك التي تتطلب استجابة تركّز على الضحايا",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=15"
  },
  {
    ID: 812,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "التحقيقات",
    Title: "تحسين تناول شكاوى سوء السلوك واتخاذ القرار بشأنها في الوقت المناسب",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=16"
  },
  {
    ID: 813,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "مكتب خدمات الرقابة الداخلية",
    Programme: "الرقابة الداخلية",
    Subprogramme: "التحقيقات",
    Title: "إجراء التحقيق في أوانه في الحالات التي قد تتسبب في خسارة مالية للمنظمة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز التصدي للاستغلال والانتهاك الجنسيين، والتحرش الجنسي، والغش والفساد؛ وتحسين تعميم الأخذ بنهج يركز على الضحايا",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=ar#page=17"
  },
  {
    ID: 814,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "لجنة الخدمة المدنية الدولية",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "لجنة الخدمة المدنية الدولية",
    Title: "نموذج عادل ومنصف للعلاوة الانتقالية الشخصية",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=4"
  },
  {
    ID: 815,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "لجنة الخدمة المدنية الدولية",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "لجنة الخدمة المدنية الدولية",
    Title: "إتاحة مزيد من المرونة للموظفين العاملين في مراكز العمل المنطوية على مشقة بالغة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=5"
  },
  {
    ID: 816,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "لجنة الخدمة المدنية الدولية",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "لجنة الخدمة المدنية الدولية",
    Title: "معايير سلوك منقحة لتوجيه المنظمات بشأن القضايا الناشئة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=6"
  },
  {
    ID: 817,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "لجنة الخدمة المدنية الدولية",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "لجنة الخدمة المدنية الدولية",
    Title: "مجموعة عناصر الأجر تعكس الأهداف والمعايير والبارامترات التي أقرتها الجمعية العامة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=7"
  },
  {
    ID: 818,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "وحدة التفتيش المشتركة",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "وحدة التفتيش المشتركة",
    Title: "زيادة الاستجابة لتوصيات وحدة التفتيش المشتركة من خلال توفير إمكانية الوصول إلى أداة جديدة لتتبع التوصيات",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=15"
  },
  {
    ID: 819,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "وحدة التفتيش المشتركة",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "وحدة التفتيش المشتركة",
    Title: "تعزيز إدارة المسائل الإدارية والبرنامجية من جانب مؤسسات منظومة الأمم المتحدة من خلال تنفيذ التوصيات الاستراتيجية والتشغيلية الصادرة عن وحدة التفتيش المشتركة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=16"
  },
  {
    ID: 820,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "وحدة التفتيش المشتركة",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "وحدة التفتيش المشتركة",
    Title: "الأثر المعزز لتوصيات وحدة التفتيش المشتركة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=17"
  },
  {
    ID: 821,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "وحدة التفتيش المشتركة",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "وحدة التفتيش المشتركة",
    Title: "تعزيز قاعدة المعارف على نطاق المنظومة واتخاذ قرارات مستنيرة من خلال نتائج الرقابة القائمة على الأدلة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=18"
  },
  {
    ID: 822,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "مجلس الرؤساء التنفيذيين في منظومة الأمم المتحدة المعني بالتنسيق",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "مجلس الرؤساء التنفيذيين في منظومة الأمم المتحدة المعني بالتنسيق",
    Title: "مبادرات واسعة النطاق لتحقيق الكفاءة من أجل تبسيط عمليات منظومة الأمم المتحدة بشكل جماعي، وخفض التكاليف، والحفاظ على الأثر المحقق",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=26"
  },
  {
    ID: 823,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "مجلس الرؤساء التنفيذيين في منظومة الأمم المتحدة المعني بالتنسيق",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "مجلس الرؤساء التنفيذيين في منظومة الأمم المتحدة المعني بالتنسيق",
    Title: "مبادرة الهوية الرقمية للأمم المتحدة، لبنة أساسية في تمكين قابلية التشغيل البيني في جميع مؤسسات الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "التطورات التكنولوجية التي تؤدي إلى تحسين نوعية المعلومات ومدى توافرها وتيسير الحصول عليها وتعزيز أمنها",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=26"
  },
  {
    ID: 824,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "مجلس الرؤساء التنفيذيين في منظومة الأمم المتحدة المعني بالتنسيق",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "مجلس الرؤساء التنفيذيين في منظومة الأمم المتحدة المعني بالتنسيق",
    Title: "تحسين الاتساق بين أنشطة منظومة الأمم المتحدة من أجل التعجيل بإحراز تقدم نحو تحقيق أهداف التنمية المستدامة وتنفيذ ميثاق المستقبل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تسريع وتيرة التقدم المحرز نحو تحقيق أهداف التنمية المستدامة، بما في ذلك من خلال تمتين هياكل التنسيق، والاستفادة من أوجه الترابط القائمة بين أهداف التنمية المستدامة",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=27"
  },
  {
    ID: 825,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "مجلس الرؤساء التنفيذيين في منظومة الأمم المتحدة المعني بالتنسيق",
    Programme: "الأنشطة الإدارية المشتركة التمويل",
    Subprogramme: "مجلس الرؤساء التنفيذيين في منظومة الأمم المتحدة المعني بالتنسيق",
    Title: "التنسيق والاتساق في منظومة الأمم المتحدة يحقق إجراءات تتسم بالكفاءة والاستدامة والالتزام بالمبادئ",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تبسيط البرامج وتوخي الشفافية فيها وتيسير الوصول إليها من أجل تحسين تنفيذها",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=ar#page=28"
  },
  {
    ID: 826,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "خدمات الأمن والسلامة",
    Title: "بيئة آمنة ومأمونة لجميع المندوبين والمشاركين في الدورة الثمانين للجمعية العامة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "المجتمع الدولي",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=7"
  },
  {
    ID: 827,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "خدمات الأمن والسلامة",
    Title: "تحسين سهولة تنقُّل المندوبين والموظفين في جميع مراكز العمل",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=8"
  },
  {
    ID: 828,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "خدمات الأمن والسلامة",
    Title: "تحسين مرافق التسجيل وإصدار الشارات والتسهيلات الأمنية الخاصة بالأشخاص ذوي الإعاقة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: "اللاجئون والأقليات والفئات الضعيفة الأخرى",
    SpecificResult: "تحسين البنية التحتية التي تدعم عمليات الأمم المتحدة على نحو أكثر كفاءة وفعالية",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=8"
  },
  {
    ID: 829,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "خدمات الأمن والسلامة",
    Title: "تحسين عملية اتخاذ القرارات المتعلقة بالسلامة والأمن",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=9"
  },
  {
    ID: 830,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "العمليات الميدانية",
    Title: "زيادة أوجه الكفاءة التشغيلية مع التركيز على المواقع العالية الخطورة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=11"
  },
  {
    ID: 831,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "العمليات الميدانية",
    Title: "تحسين التأهب والاستجابة للأزمات",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=12"
  },
  {
    ID: 832,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "العمليات الميدانية",
    Title: "تحسين عملية اتخاذ القرارات الأمنية",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=13"
  },
  {
    ID: 833,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "العمليات الميدانية",
    Title: "اتخاذ القرارات المتعلقة بالسلامة والأمن بطريقة واعية بالمخاطر",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=13"
  },
  {
    ID: 834,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "الشراكات والخدمات المتخصصة",
    Title: "تعزيز النظم الرقمية الجديدة لسلامة وأمن أفراد الأمم المتحدة",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تحسين كفاءة العمليات بفضل العلم والتكنولوجيا والابتكار",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=15"
  },
  {
    ID: 835,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "الشراكات والخدمات المتخصصة",
    Title: "الاضطلاع بعمليات متسقة ومنسقة على نطاق نظام الأمم المتحدة لإدارة الأمن",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=16"
  },
  {
    ID: 836,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "الشراكات والخدمات المتخصصة",
    Title: "تعزيز خدمات الحماية الشخصية لكبار موظفي الأمم المتحدة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=17"
  },
  {
    ID: 837,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "إدارة شؤون السلامة والأمن",
    Programme: "السلامة والأمن",
    Subprogramme: "الشراكات والخدمات المتخصصة",
    Title: "اتباع نهج منسّق بشأن تقديم الدعم النفسي الاجتماعي عقب الحوادث الخطيرة",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "تمكين التقدم نحو تحقيق الأولويات الثماني",
    Beneficiary: "التمكين",
    BeneficiaryTwo: " ",
    SpecificResult: "تعزيز القدرة التنظيمية والمساءلة والاستجابة من أجل تنفيذ الولايات بمزيد من الفعالية",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=ar#page=17"
  }
]